(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.dD.a$ === region.d8.a$)
	{
		return 'on line ' + region.dD.a$;
	}
	return 'on lines ' + region.dD.a$ + ' through ' + region.d8.a$;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hP,
		impl.dK,
		impl.jP,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		ev: func(record.ev),
		P: record.P,
		O: record.O
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.ev;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.P;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.O) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hP,
		impl.dK,
		impl.jP,
		function(sendToApp, initialModel) {
			var view = impl.kh;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hP,
		impl.dK,
		impl.jP,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dC && impl.dC(sendToApp)
			var view = impl.kh;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fD);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.j_) && (_VirtualDom_doc.title = title = doc.j_);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iB;
	var onUrlRequest = impl.iC;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dC: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eG === next.eG
							&& curr.hD === next.hD
							&& curr.iS.a === next.iS.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hP: function(flags)
		{
			return A3(impl.hP, flags, _Browser_getUrl(), key);
		},
		kh: impl.kh,
		dK: impl.dK,
		jP: impl.jP
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hA: 'hidden', fL: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hA: 'mozHidden', fL: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hA: 'msHidden', fL: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hA: 'webkitHidden', fL: 'webkitvisibilitychange' }
		: { hA: 'hidden', fL: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		eQ: _Browser_getScene(),
		e9: {
			km: _Browser_window.pageXOffset,
			kn: _Browser_window.pageYOffset,
			kk: _Browser_doc.documentElement.clientWidth,
			hy: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		kk: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		hy: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			eQ: {
				kk: node.scrollWidth,
				hy: node.scrollHeight
			},
			e9: {
				km: node.scrollLeft,
				kn: node.scrollTop,
				kk: node.clientWidth,
				hy: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			eQ: _Browser_getScene(),
			e9: {
				km: x,
				kn: y,
				kk: _Browser_doc.documentElement.clientWidth,
				hy: _Browser_doc.documentElement.clientHeight
			},
			gU: {
				km: x + rect.left,
				kn: y + rect.top,
				kk: rect.width,
				hy: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.c8.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.c8.b, xhr)); });
		$elm$core$Maybe$isJust(request.e2) && _Http_track(router, xhr, request.e2.a);

		try {
			xhr.open(request.ij, request.j7, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.j7));
		}

		_Http_configureRequest(xhr, request);

		request.fD.a && xhr.setRequestHeader('Content-Type', request.fD.a);
		xhr.send(request.fD.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ek; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.jY.a || 0;
	xhr.responseType = request.c8.d;
	xhr.withCredentials = request.fk;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		j7: xhr.responseURL,
		cM: xhr.status,
		dF: xhr.statusText,
		ek: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			ju: event.loaded,
			eU: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			i$: event.loaded,
			eU: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.ir) { flags += 'm'; }
	if (options.fJ) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $author$project$Main$LinkClicked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$UrlChanged = function (a) {
	return {$: 7, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.d) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.e),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.e);
		} else {
			var treeLen = builder.d * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.f) : builder.f;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.d);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.e) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.e);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{f: nodeList, d: (len / $elm$core$Array$branchFactor) | 0, e: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {eg: fragment, hD: host, iO: path, iS: port_, eG: protocol, eH: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$Hidden = {$: 0};
var $author$project$Main$DocsPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$LoggedOutPage = {$: 2};
var $author$project$Main$MainPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lib$RemoteData$EmptyLoading = {$: 0};
var $author$project$Pages$DocsPage$defaultModel = {aT: $author$project$Lib$RemoteData$EmptyLoading};
var $author$project$Pages$Main$MainPage$Hidden = {$: 0};
var $author$project$Pages$Main$EnvironmentsView$Hidden = {$: 0};
var $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing = {$: 0};
var $author$project$Pages$Main$EntityListing$TreeView$State = $elm$core$Basics$identity;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Pages$Main$EntityListing$TreeView$defaultState = {N: $elm$core$Set$empty};
var $author$project$Lib$DragDrop$NotDragging = {$: 0};
var $author$project$Lib$DragDrop$init = $author$project$Lib$DragDrop$NotDragging;
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$defaultModel = {W: $author$project$Lib$DragDrop$init, ar: $elm$core$Dict$empty, E: $elm$core$Maybe$Nothing, cP: $author$project$Pages$Main$EntityListing$TreeView$defaultState};
var $author$project$Pages$Main$EnvironmentsView$defaultModel = {l: $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing, K: $author$project$Pages$Main$EntityListing$GenericEntityListingView$defaultModel, a2: $author$project$Pages$Main$EnvironmentsView$Hidden};
var $author$project$Pages$Main$PrincipalsView$Hidden = {$: 0};
var $author$project$Pages$Main$PrincipalsView$defaultModel = {l: $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing, K: $author$project$Pages$Main$EntityListing$GenericEntityListingView$defaultModel, a2: $author$project$Pages$Main$PrincipalsView$Hidden};
var $author$project$Pages$Main$RolesView$Hidden = {$: 0};
var $author$project$Pages$Main$RolesView$defaultModel = {l: $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing, K: $author$project$Pages$Main$EntityListing$GenericEntityListingView$defaultModel, a2: $author$project$Pages$Main$RolesView$Hidden};
var $author$project$Pages$Main$TenantSettingsView$defaultModel = {ee: $author$project$Lib$RemoteData$EmptyLoading};
var $author$project$Pages$Main$Repository$emptyRepository = {Y: $author$project$Lib$RemoteData$EmptyLoading, ea: $author$project$Lib$RemoteData$EmptyLoading, de: $author$project$Lib$RemoteData$EmptyLoading, dt: $author$project$Lib$RemoteData$EmptyLoading, du: $author$project$Lib$RemoteData$EmptyLoading, dy: $author$project$Lib$RemoteData$EmptyLoading, eN: $author$project$Lib$RemoteData$EmptyLoading};
var $author$project$Pages$Main$MainPage$defaultModel = F2(
	function (_v0, route) {
		var selectedBranchKey = _v0.js;
		return {al: $author$project$Lib$RemoteData$EmptyLoading, aQ: $author$project$Pages$Main$EnvironmentsView$defaultModel, a2: $author$project$Pages$Main$MainPage$Hidden, a6: $author$project$Pages$Main$PrincipalsView$defaultModel, A: $author$project$Pages$Main$Repository$emptyRepository, a7: $author$project$Pages$Main$RolesView$defaultModel, aC: route, js: selectedBranchKey, ba: $author$project$Pages$Main$TenantSettingsView$defaultModel, S: $author$project$Lib$RemoteData$EmptyLoading};
	});
var $author$project$Main$routeToDefaultPage = F2(
	function (flags, route) {
		switch (route.$) {
			case 0:
				var mainPageRoute = route.a;
				return $author$project$Main$MainPage(
					A2($author$project$Pages$Main$MainPage$defaultModel, flags, mainPageRoute));
			case 1:
				return $author$project$Main$DocsPage($author$project$Pages$DocsPage$defaultModel);
			default:
				return $author$project$Main$LoggedOutPage;
		}
	});
var $author$project$Routes$MainPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Routes$Principals = 2;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aa: frag, iN: params, R: unvisited, kg: value, aj: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.R;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.kg);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.kg);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.iO),
					$elm$url$Url$Parser$prepareQuery(url.eH),
					url.eg,
					$elm$core$Basics$identity)));
	});
var $author$project$Routes$DocsPage = {$: 1};
var $author$project$Routes$LoggedOutPage = {$: 2};
var $author$project$Routes$Environments = 1;
var $author$project$Routes$MissingPermissions = 4;
var $author$project$Routes$Roles = 0;
var $author$project$Routes$TenantSettings = 3;
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aj;
		var unvisited = _v0.R;
		var params = _v0.iN;
		var frag = _v0.aa;
		var value = _v0.kg;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aj;
			var unvisited = _v1.R;
			var params = _v1.iN;
			var frag = _v1.aa;
			var value = _v1.kg;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aj;
		var unvisited = _v0.R;
		var params = _v0.iN;
		var frag = _v0.aa;
		var value = _v0.kg;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Routes$mainPageRouteParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			4,
			$elm$url$Url$Parser$s('missingPermissions')),
			A2(
			$elm$url$Url$Parser$map,
			0,
			$elm$url$Url$Parser$s('roles')),
			A2(
			$elm$url$Url$Parser$map,
			1,
			$elm$url$Url$Parser$s('environments')),
			A2(
			$elm$url$Url$Parser$map,
			2,
			$elm$url$Url$Parser$s('principals')),
			A2(
			$elm$url$Url$Parser$map,
			3,
			$elm$url$Url$Parser$s('tenantSettings'))
		]));
var $author$project$Routes$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Routes$MainPage, $author$project$Routes$mainPageRouteParser),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$DocsPage,
			$elm$url$Url$Parser$s('docs')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$LoggedOutPage,
			$elm$url$Url$Parser$s('loggedOut'))
		]));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Routes$urlToRoute = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Routes$MainPage(2),
		A2($elm$url$Url$Parser$parse, $author$project$Routes$routeParser, url));
};
var $author$project$Main$defaultModel = F3(
	function (flags, url, key) {
		return {
			bP: flags,
			a2: $author$project$Main$Hidden,
			b7: key,
			z: A2(
				$author$project$Main$routeToDefaultPage,
				flags,
				$author$project$Routes$urlToRoute(url))
		};
	});
var $author$project$Main$DocsPageMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$MainPageMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$NoOp = {$: 0};
var $author$project$Main$PageMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$DocsPage$BeginLoadUserPermissions = {$: 0};
var $author$project$Pages$DocsPage$init = $author$project$Pages$DocsPage$BeginLoadUserPermissions;
var $author$project$Pages$Main$MainPage$BeginLoadUserPermissions = {$: 12};
var $author$project$Pages$Main$MainPage$init = $author$project$Pages$Main$MainPage$BeginLoadUserPermissions;
var $author$project$Main$initMsg = function (model) {
	var _v0 = model.z;
	switch (_v0.$) {
		case 0:
			return $author$project$Main$PageMsg(
				$author$project$Main$MainPageMsg($author$project$Pages$Main$MainPage$init));
		case 1:
			return $author$project$Main$PageMsg(
				$author$project$Main$DocsPageMsg($author$project$Pages$DocsPage$init));
		default:
			return $author$project$Main$NoOp;
	}
};
var $author$project$Utils$CmdUtils$msgToCmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var model = A3($author$project$Main$defaultModel, flags, url, key);
		return _Utils_Tuple2(
			model,
			$author$project$Utils$CmdUtils$msgToCmd(
				$author$project$Main$initMsg(model)));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$AppMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$GotLogout = function (a) {
	return {$: 5, a: a};
};
var $author$project$AppMsg$OnHttpError = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $ccapndave$elm_update_extra$Update$Extra$addCmd = F2(
	function (cmd_, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $ccapndave$elm_update_extra$Update$Extra$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Utils$HttpUtils$apiErrorResponseToString = function (_v0) {
	var statusCode = _v0.cM;
	var statusText = _v0.dF;
	var message = _v0.ev;
	var callId = _v0.dV;
	return message + ('\n' + ('Kutsun ID : ' + (callId + ('\n' + ('Status : ' + (statusText + (' - ' + $elm$core$String$fromInt(statusCode))))))));
};
var $author$project$Utils$HttpUtils$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var text = error.a;
			return 'Bad Url: ' + text;
		case 1:
			return 'Http Timeout';
		case 2:
			return 'Network Error';
		case 3:
			var errorResponse = error.a;
			return $author$project$Utils$HttpUtils$apiErrorResponseToString(errorResponse);
		case 4:
			var message = error.a;
			return 'Bad Http Body: ' + message;
		default:
			return '';
	}
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Routes$mainPageRouteToUrlStr = function (route) {
	switch (route) {
		case 4:
			return '/missingPermissions';
		case 0:
			return '/roles';
		case 1:
			return '/environments';
		case 2:
			return '/principals';
		default:
			return '/tenantSettings';
	}
};
var $author$project$Routes$routeToUrlString = function (route) {
	switch (route.$) {
		case 0:
			var mainPageRoute = route.a;
			return $author$project$Routes$mainPageRouteToUrlStr(mainPageRoute);
		case 1:
			return '/docs';
		default:
			return '/loggedOut';
	}
};
var $author$project$Main$navigateToCmd = F2(
	function (model, route) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			model.b7,
			$author$project$Routes$routeToUrlString(route));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Lib$CustomHttp$AjaxRedirection = {$: 5};
var $author$project$Lib$CustomHttp$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$CustomHttp$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lib$CustomHttp$NetworkError = {$: 2};
var $author$project$Lib$CustomHttp$Timeout = {$: 1};
var $author$project$Lib$CustomHttp$ajaxRedirectionStatusCode = 278;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Lib$CustomHttp$ApiErrorResponse = F4(
	function (message, callId, statusCode, statusText) {
		return {dV: callId, ev: message, cM: statusCode, dF: statusText};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Lib$CustomHttp$makeApiErrorResponseDecoder = F2(
	function (statusCode, statusText) {
		return A5(
			$elm$json$Json$Decode$map4,
			$author$project$Lib$CustomHttp$ApiErrorResponse,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'callId', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed(statusCode),
			$elm$json$Json$Decode$succeed(statusText));
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Lib$CustomHttp$httpResponseToResult = F3(
	function (goodStatusToResult, redirectionResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Lib$CustomHttp$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Lib$CustomHttp$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Lib$CustomHttp$NetworkError);
			case 3:
				var statusCode = response.a.cM;
				var statusText = response.a.dF;
				var body = response.b;
				var errorResponseDecoder = A2($author$project$Lib$CustomHttp$makeApiErrorResponseDecoder, statusCode, statusText);
				var errorResponse = A2(
					$elm$core$Result$withDefault,
					{dV: '-1', ev: body, cM: statusCode, dF: statusText},
					A2($elm$json$Json$Decode$decodeString, errorResponseDecoder, body));
				return $elm$core$Result$Err(
					$author$project$Lib$CustomHttp$BadStatus(errorResponse));
			default:
				var statusCode = response.a.cM;
				var body = response.b;
				return _Utils_eq(statusCode, $author$project$Lib$CustomHttp$ajaxRedirectionStatusCode) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Result$Err($author$project$Lib$CustomHttp$AjaxRedirection),
					A2($elm$core$Maybe$map, $elm$core$Result$Ok, redirectionResult)) : goodStatusToResult(body);
		}
	});
var $author$project$Lib$CustomHttp$expectWhateverCustom = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		A2(
			$author$project$Lib$CustomHttp$httpResponseToResult,
			function (_v0) {
				return $elm$core$Result$Ok(0);
			},
			$elm$core$Maybe$Just(0)));
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.cM));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl = F2(
	function (method, url) {
		return {
			fD: $elm$http$Http$emptyBody,
			c8: $elm$http$Http$expectString(
				function (_v0) {
					return 0;
				}),
			ek: _List_Nil,
			ij: method,
			jY: $elm$core$Maybe$Nothing,
			j7: url,
			aG: false
		};
	});
var $lukewestby$elm_http_builder$HttpBuilder$post = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('POST');
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {eK: reqs, eW: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.e2;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.eK));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.eW)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					fk: r.fk,
					fD: r.fD,
					c8: A2(_Http_mapExpect, func, r.c8),
					ek: r.ek,
					ij: r.ij,
					jY: r.jY,
					e2: r.e2,
					j7: r.j7
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{fk: false, fD: r.fD, c8: r.c8, ek: r.ek, ij: r.ij, jY: r.jY, e2: r.e2, j7: r.j7}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{fk: true, fD: r.fD, c8: r.c8, ek: r.ek, ij: r.ij, jY: r.jY, e2: r.e2, j7: r.j7}));
};
var $lukewestby$elm_http_builder$HttpBuilder$request = function (builder) {
	var req = builder.aG ? $elm$http$Http$riskyRequest : $elm$http$Http$request;
	return req(
		{fD: builder.fD, c8: builder.c8, ek: builder.ek, ij: builder.ij, jY: builder.jY, e2: $elm$core$Maybe$Nothing, j7: builder.j7});
};
var $author$project$Api$ApiUrls$urlRoot = '/api';
var $author$project$Api$ApiUrls$userActionsUrlRoot = $author$project$Api$ApiUrls$urlRoot + '/user';
var $lukewestby$elm_http_builder$HttpBuilder$withExpect = F2(
	function (expect, builder) {
		return {fD: builder.fD, c8: expect, ek: builder.ek, ij: builder.ij, jY: builder.jY, j7: builder.j7, aG: builder.aG};
	});
var $author$project$Api$UserApi$requestLogin = function (toMsg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			$author$project$Lib$CustomHttp$expectWhateverCustom(toMsg),
			$lukewestby$elm_http_builder$HttpBuilder$post($author$project$Api$ApiUrls$userActionsUrlRoot + '/login')));
};
var $author$project$Api$UserApi$requestLogout = function (toMsg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			$author$project$Lib$CustomHttp$expectWhateverCustom(toMsg),
			$lukewestby$elm_http_builder$HttpBuilder$post($author$project$Api$ApiUrls$userActionsUrlRoot + '/logout')));
};
var $ccapndave$elm_update_extra$Update$Extra$sequence = F3(
	function (update, msgs, init) {
		var foldUpdate = $ccapndave$elm_update_extra$Update$Extra$andThen(update);
		return A3($elm$core$List$foldl, foldUpdate, init, msgs);
	});
var $author$project$Pages$Main$MainPage$SetRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Main$MainPage$setRoute = $author$project$Pages$Main$MainPage$SetRoute;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.eG;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.eg,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.eH,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.iS,
					_Utils_ap(http, url.hD)),
				url.iO)));
};
var $author$project$Pages$DocsPage$GotUserPermissions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lib$RemoteData$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Authentication$UserPermissions$ManageCommands = 8;
var $author$project$AppMsg$NoOp = {$: 0};
var $author$project$Lib$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lib$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $author$project$Lib$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $author$project$Lib$RemoteData$Success(x);
	}
};
var $author$project$Lib$CustomHttp$BadBody = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lib$CustomHttp$expectJsonCustom = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			A2(
				$author$project$Lib$CustomHttp$httpResponseToResult,
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						A2($elm$core$Basics$composeL, $author$project$Lib$CustomHttp$BadBody, $elm$json$Json$Decode$errorToString),
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				},
				$elm$core$Maybe$Nothing));
	});
var $lukewestby$elm_http_builder$HttpBuilder$get = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('GET');
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Authentication$UserPermissions$ManageConnections = 10;
var $author$project$Authentication$UserPermissions$ManageEndpoints = 12;
var $author$project$Authentication$UserPermissions$ManageEnvironments = 11;
var $author$project$Authentication$UserPermissions$ManageLogs = 16;
var $author$project$Authentication$UserPermissions$ManagePrincipals = 14;
var $author$project$Authentication$UserPermissions$ManageRevisions = 17;
var $author$project$Authentication$UserPermissions$ManageRoles = 13;
var $author$project$Authentication$UserPermissions$ManageTenantSettings = 15;
var $author$project$Authentication$UserPermissions$ManageViews = 9;
var $author$project$Authentication$UserPermissions$Other = 18;
var $author$project$Authentication$UserPermissions$ReadCommands = 1;
var $author$project$Authentication$UserPermissions$ReadConnections = 3;
var $author$project$Authentication$UserPermissions$ReadEndpoints = 5;
var $author$project$Authentication$UserPermissions$ReadEnvironments = 4;
var $author$project$Authentication$UserPermissions$ReadPrincipals = 7;
var $author$project$Authentication$UserPermissions$ReadRoles = 6;
var $author$project$Authentication$UserPermissions$ReadViewsAdmin = 2;
var $author$project$Authentication$UserPermissions$SelectBranch = 0;
var $author$project$Api$UserApi$userPermissionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(
			function () {
				switch (str) {
					case 'SelectBranch':
						return 0;
					case 'ReadCommands':
						return 1;
					case 'ReadViewsAdmin':
						return 2;
					case 'ReadConnections':
						return 3;
					case 'ReadEnvironments':
						return 4;
					case 'ReadEndpoints':
						return 5;
					case 'ReadRoles':
						return 6;
					case 'ReadPrincipals':
						return 7;
					case 'ManageCommands':
						return 8;
					case 'ManageViews':
						return 9;
					case 'ManageConnections':
						return 10;
					case 'ManageEnvironments':
						return 11;
					case 'ManageEndpoints':
						return 12;
					case 'ManageRoles':
						return 13;
					case 'ManagePrincipals':
						return 14;
					case 'ManageTenantSettings':
						return 15;
					case 'ManageLogs':
						return 16;
					case 'ManageRevisions':
						return 17;
					default:
						return 18;
				}
			}());
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$UserApi$userPermissionsFromUserDataDecoder = A2(
	$elm$json$Json$Decode$field,
	'permissions',
	$elm$json$Json$Decode$list($author$project$Api$UserApi$userPermissionDecoder));
var $author$project$Api$UserApi$getUserPermissions = function (toMsg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($author$project$Lib$CustomHttp$expectJsonCustom, toMsg, $author$project$Api$UserApi$userPermissionsFromUserDataDecoder),
			$lukewestby$elm_http_builder$HttpBuilder$get($author$project$Api$ApiUrls$userActionsUrlRoot + '/userData')));
};
var $author$project$Lib$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $author$project$Lib$RemoteData$Success(
					f(value));
			case 1:
				var oldValue = data.a;
				return $author$project$Lib$RemoteData$Loading(
					f(oldValue));
			case 0:
				return $author$project$Lib$RemoteData$EmptyLoading;
			default:
				var error = data.a;
				return $author$project$Lib$RemoteData$Failure(error);
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Pages$PageUpdateUtils$withoutActions = function (model) {
	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$AppMsg$NoOp);
};
var $author$project$Pages$DocsPage$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						aT: $author$project$Lib$RemoteData$Loading(false)
					}),
				$author$project$Api$UserApi$getUserPermissions($author$project$Pages$DocsPage$GotUserPermissions),
				$author$project$AppMsg$NoOp);
		} else {
			var result = msg.a;
			return $author$project$Pages$PageUpdateUtils$withoutActions(
				_Utils_update(
					model,
					{
						aT: A2(
							$author$project$Lib$RemoteData$map,
							$elm$core$List$member(8),
							$author$project$Lib$RemoteData$fromResult(result))
					}));
		}
	});
var $author$project$Pages$Main$MainPage$BeginLoadBranches = {$: 13};
var $author$project$Pages$Main$OutMsg$BeginReloadAllEntities = {$: 1};
var $author$project$Pages$Main$MainPage$EnvironmentsMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Main$MainPage$GotBranches = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Main$MainPage$GotEnvironmentGroups = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Main$MainPage$GotEnvironments = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Main$MainPage$GotIdentityProviders = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Main$MainPage$GotPrincipalGroups = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Main$MainPage$GotPrincipals = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Main$MainPage$GotRoleGroups = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Main$MainPage$GotRoles = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Main$MainPage$GotUserPermissions = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Main$MainPage$Message = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$MainPage$OutMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$MainPage$PrincipalsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$AppMsg$RequestLogout = {$: 2};
var $author$project$Pages$Main$MainPage$RolesMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Main$MainPage$TenantSettingsMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$PageUpdateUtils$addCmd = F2(
	function (cmd_, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var appMsg = _v0.c;
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])),
			appMsg);
	});
var $author$project$AppMsg$BatchAppMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PageUpdateUtils$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var appMsg = _v0.c;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		var appMsg_ = _v1.c;
		return _Utils_Tuple3(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])),
			$author$project$AppMsg$BatchAppMsg(
				_List_fromArray(
					[appMsg, appMsg_])));
	});
var $author$project$Pages$Main$MainPage$getApiConfig = function (model) {
	return {js: model.js};
};
var $author$project$Entity$AavoBranch$AavoBranch = F2(
	function (key, title) {
		return {h_: key, j_: title};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$BranchApi$aavoBranchDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'title',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Entity$AavoBranch$AavoBranch)));
var $author$project$Api$BranchApi$getBranches = function (toMsg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$author$project$Lib$CustomHttp$expectJsonCustom,
				toMsg,
				$elm$json$Json$Decode$list($author$project$Api$BranchApi$aavoBranchDecoder)),
			$lukewestby$elm_http_builder$HttpBuilder$get($author$project$Api$ApiUrls$urlRoot + '/branches')));
};
var $author$project$Api$ApiUrls$adminUrlRoot = $author$project$Api$ApiUrls$urlRoot + '/admin';
var $author$project$Api$ApiUrls$environmentGroupsUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/environmentGroups';
var $author$project$Entity$GenericEntityGroup$GenericEntityGroup = F6(
	function (id, pos, aproProjectId, name, description, parentId) {
		return {fp: aproProjectId, gC: description, bZ: id, is: name, dp: parentId, cr: pos};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parentId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'aproProjectId',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'pos',
					$elm$json$Json$Decode$int,
					0,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Entity$GenericEntityGroup$GenericEntityGroup)))))));
var $author$project$Api$ApiUrls$aavoBranchHeader = 'X-aavo-branch';
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Utils$DictUtils$mapKeys = function (_function) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (_v0) {
					var key = _v0.a;
					var value = _v0.b;
					return _Utils_Tuple2(
						_function(key),
						value);
				}),
			$elm$core$Dict$fromList));
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Entity$Common$nonExistentId = -1;
var $author$project$Entity$Common$strToIdOrDefault = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$withDefault($author$project$Entity$Common$nonExistentId));
var $author$project$Decoding$DecodingUtils$entityDictDecoder = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$dict,
	$elm$json$Json$Decode$map(
		$author$project$Utils$DictUtils$mapKeys($author$project$Entity$Common$strToIdOrDefault)));
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $lukewestby$elm_http_builder$HttpBuilder$withHeader = F3(
	function (key, value, builder) {
		return _Utils_update(
			builder,
			{
				ek: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					builder.ek)
			});
	});
var $author$project$Api$EntityApi$getEntityDictData = F4(
	function (url, decoder, _v0, toMsg) {
		var selectedBranchKey = _v0.js;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$author$project$Lib$CustomHttp$expectJsonCustom,
					toMsg,
					$author$project$Decoding$DecodingUtils$entityDictDecoder(decoder)),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					$author$project$Api$ApiUrls$aavoBranchHeader,
					selectedBranchKey,
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Api$EntityApi$getEnvironmentGroups = A2($author$project$Api$EntityApi$getEntityDictData, $author$project$Api$ApiUrls$environmentGroupsUrl, $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder);
var $author$project$Entity$Environment$Environment = function (id) {
	return function (groupId) {
		return function (pos) {
			return function (aproProjectId) {
				return function (idAnchor) {
					return function (name) {
						return function (displayName) {
							return function (description) {
								return function (environmentType) {
									return function (connections) {
										return function (dynamicConnections) {
											return function (environmentParams) {
												return {fp: aproProjectId, f9: connections, gC: description, gE: displayName, gP: dynamicConnections, g0: environmentParams, g1: environmentType, hw: groupId, bZ: id, hH: idAnchor, is: name, cr: pos};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Entity$CommandParameter$CommandParameter = F2(
	function (key, value) {
		return {h_: key, kg: value};
	});
var $author$project$Serializable$Bool_ = function (a) {
	return {$: 3, a: a};
};
var $author$project$Serializable$Float_ = function (a) {
	return {$: 2, a: a};
};
var $author$project$Serializable$Int_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Serializable$String_ = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Serializable$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Serializable$Bool_, $elm$json$Json$Decode$bool),
			A2($elm$json$Json$Decode$map, $author$project$Serializable$Int_, $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$map, $author$project$Serializable$Float_, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $author$project$Serializable$String_, $elm$json$Json$Decode$string)
		]));
var $author$project$Decoding$CommandParameterDecoding$commandParameterDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Entity$CommandParameter$CommandParameter,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'value',
		$elm$json$Json$Decode$nullable($author$project$Serializable$decoder)));
var $author$project$Entity$Connection$ConnectionReferenceSet = F5(
	function (dbConnectionId, httpConnectionId, fileServerConnectionId, mailServerConnectionId, awsConnectionId) {
		return {fy: awsConnectionId, gq: dbConnectionId, hh: fileServerConnectionId, hF: httpConnectionId, h8: mailServerConnectionId};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Decoding$ConnectionDecoding$connectionReferenceSetDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Entity$Connection$ConnectionReferenceSet,
	A2(
		$elm$json$Json$Decode$field,
		'dbConnectionId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'httpConnectionId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'fileServerConnectionId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'mailServerConnectionId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'awsConnectionId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)));
var $author$project$Entity$Environment$DynamicConnectionAssociation = F2(
	function (dynamicConnectionId, actualConnectionId) {
		return {fh: actualConnectionId, gO: dynamicConnectionId};
	});
var $author$project$Decoding$EnvironmentDecoding$dynamicConnectionAssociationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actualConnectionId',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dynamicConnectionId',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Entity$Environment$DynamicConnectionAssociation)));
var $author$project$Decoding$EnvironmentDecoding$environmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'environmentParameters',
	$elm$json$Json$Decode$list($author$project$Decoding$CommandParameterDecoding$commandParameterDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dynamicConnections',
		$elm$json$Json$Decode$list($author$project$Decoding$EnvironmentDecoding$dynamicConnectionAssociationDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'connections',
			$author$project$Decoding$ConnectionDecoding$connectionReferenceSetDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'environmentType',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'displayName',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'idAnchor',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'aproProjectId',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'pos',
										$elm$json$Json$Decode$int,
										0,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'groupId',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$Entity$Environment$Environment)))))))))))));
var $author$project$Api$ApiUrls$environmentsUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/environments';
var $author$project$Api$EntityApi$getEnvironments = A2($author$project$Api$EntityApi$getEntityDictData, $author$project$Api$ApiUrls$environmentsUrl, $author$project$Decoding$EnvironmentDecoding$environmentDecoder);
var $author$project$Entity$IdentityProvider$IdentityProvider = F3(
	function (id, name, type_) {
		return {bZ: id, is: name, j5: type_};
	});
var $author$project$Entity$IdentityProvider$Auth0IdentityProvider = 0;
var $author$project$Entity$IdentityProvider$OAuthIdentityProvider = 1;
var $author$project$Api$MiscApi$identityProviderTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Auth0':
				return $elm$json$Json$Decode$succeed(0);
			case 'OAuth':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown IdentityProviderType ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$MiscApi$identityProviderDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Api$MiscApi$identityProviderTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Entity$IdentityProvider$IdentityProvider))));
var $author$project$Api$ApiUrls$identityProvidersUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/identityProviders';
var $author$project$Api$MiscApi$getIdentityProviders = function (toMsg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$author$project$Lib$CustomHttp$expectJsonCustom,
				toMsg,
				$elm$json$Json$Decode$list($author$project$Api$MiscApi$identityProviderDecoder)),
			$lukewestby$elm_http_builder$HttpBuilder$get($author$project$Api$ApiUrls$identityProvidersUrl)));
};
var $author$project$Pages$Main$MainPage$LoadEnvironmentGroups = {$: 19};
var $author$project$Pages$Main$MainPage$LoadEnvironments = {$: 18};
var $author$project$Pages$Main$MainPage$LoadIdentityProviders = {$: 22};
var $author$project$Pages$Main$MainPage$LoadPrincipalGroups = {$: 21};
var $author$project$Pages$Main$MainPage$LoadPrincipals = {$: 20};
var $author$project$Pages$Main$MainPage$LoadRoleGroups = {$: 17};
var $author$project$Pages$Main$MainPage$LoadRoles = {$: 16};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Pages$Main$TenantSettingsView$LoadTenantSettings = {$: 1};
var $author$project$Pages$Main$TenantSettingsView$reloadTenantSettings = $author$project$Pages$Main$TenantSettingsView$LoadTenantSettings;
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Pages$Main$MainPage$getLoadMessagesForAllPermittedEntities = function (model) {
	var loadMessagesByPermissionOptions = _List_fromArray(
		[
			_Utils_Tuple2(
			_List_fromArray(
				[6, 13]),
			_List_fromArray(
				[$author$project$Pages$Main$MainPage$LoadRoles, $author$project$Pages$Main$MainPage$LoadRoleGroups])),
			_Utils_Tuple2(
			_List_fromArray(
				[4, 11]),
			_List_fromArray(
				[$author$project$Pages$Main$MainPage$LoadEnvironments, $author$project$Pages$Main$MainPage$LoadEnvironmentGroups])),
			_Utils_Tuple2(
			_List_fromArray(
				[7, 14]),
			_List_fromArray(
				[$author$project$Pages$Main$MainPage$LoadPrincipals, $author$project$Pages$Main$MainPage$LoadPrincipalGroups, $author$project$Pages$Main$MainPage$LoadIdentityProviders])),
			_Utils_Tuple2(
			_List_fromArray(
				[15]),
			_List_fromArray(
				[
					$author$project$Pages$Main$MainPage$TenantSettingsMsg($author$project$Pages$Main$TenantSettingsView$reloadTenantSettings)
				]))
		]);
	var _v0 = model.S;
	if (_v0.$ === 3) {
		var userPermissions = _v0.a;
		return A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var permissionOptions = _v1.a;
					return A2(
						$elm$core$List$any,
						function (permission) {
							return A2($elm$core$List$member, permission, userPermissions);
						},
						permissionOptions);
				},
				loadMessagesByPermissionOptions));
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$ApiUrls$principalAssociationGroupsUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/principalAssociationGroups';
var $author$project$Api$EntityApi$getPrincipalGroups = A2($author$project$Api$EntityApi$getEntityDictData, $author$project$Api$ApiUrls$principalAssociationGroupsUrl, $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder);
var $author$project$Api$ApiUrls$principalAssociationsUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/principals';
var $author$project$Entity$PrincipalAssociation$PrincipalAssociation = F9(
	function (id, groupId, pos, principalState, principalType, sessionExpirationDurationDays, description, environmentAssociations, userSettings) {
		return {gC: description, g_: environmentAssociations, hw: groupId, bZ: id, cr: pos, iY: principalState, iZ: principalType, jy: sessionExpirationDurationDays, ke: userSettings};
	});
var $author$project$Entity$Environment$EnvironmentAssociation = F2(
	function (environmentId, roleId) {
		return {g$: environmentId, jj: roleId};
	});
var $author$project$Decoding$PrincipalDecoding$environmentAssociationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Entity$Environment$EnvironmentAssociation,
	A2($elm$json$Json$Decode$field, 'environmentId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'roleId', $elm$json$Json$Decode$int));
var $author$project$Entity$PrincipalAssociation$PreparedPrincipalState = function (a) {
	return {$: 0, a: a};
};
var $author$project$Entity$PrincipalAssociation$ReadyPrincipalState = function (a) {
	return {$: 1, a: a};
};
var $author$project$Decoding$PrincipalDecoding$principalStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'prepared':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Entity$PrincipalAssociation$PreparedPrincipalState,
					A2(
						$elm$json$Json$Decode$map,
						function (id) {
							return {iV: id};
						},
						A2($elm$json$Json$Decode$field, 'preparedPrincipalId', $elm$json$Json$Decode$string)));
			case 'ready':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Entity$PrincipalAssociation$ReadyPrincipalState,
					A2(
						$elm$json$Json$Decode$map,
						function (id) {
							return {iX: id};
						},
						A2($elm$json$Json$Decode$field, 'principalId', $elm$json$Json$Decode$string)));
			default:
				return $elm$json$Json$Decode$fail('Invalid PrincipalState ' + str);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Entity$PrincipalAssociation$TTokenPrincipal = function (clientId) {
	return {fS: clientId};
};
var $author$project$Entity$PrincipalAssociation$TUserPrincipal = F2(
	function (email, mfaEnabled) {
		return {d7: email, il: mfaEnabled};
	});
var $author$project$Entity$PrincipalAssociation$TokenPrincipal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Entity$PrincipalAssociation$UserPrincipal = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Decoding$PrincipalDecoding$principalTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'user':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Entity$PrincipalAssociation$UserPrincipal,
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Entity$PrincipalAssociation$TUserPrincipal,
						A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'mfaEnabled', $elm$json$Json$Decode$bool)));
			case 'token':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Entity$PrincipalAssociation$TokenPrincipal,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Entity$PrincipalAssociation$TTokenPrincipal,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['tokenCredentials', 'clientId']),
							$elm$json$Json$Decode$string)));
			default:
				return $elm$json$Json$Decode$fail('Invalid principal type ' + str);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $elm$core$Basics$round = _Basics_round;
var $author$project$Utils$TimeUtils$secondsToDays = function (seconds) {
	return $elm$core$Basics$round(((seconds / 60) / 60) / 24);
};
var $author$project$Entity$PrincipalAssociation$UserSettings = F2(
	function (userParameters, useNfc) {
		return {ka: useNfc, kd: userParameters};
	});
var $author$project$Decoding$PrincipalDecoding$userSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'useNfc',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'userParameters',
		$elm$json$Json$Decode$list($author$project$Decoding$CommandParameterDecoding$commandParameterDecoder),
		$elm$json$Json$Decode$succeed($author$project$Entity$PrincipalAssociation$UserSettings)));
var $author$project$Decoding$PrincipalDecoding$principalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'userSettings',
	$author$project$Decoding$PrincipalDecoding$userSettingsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'environmentAssociations',
		$elm$json$Json$Decode$list($author$project$Decoding$PrincipalDecoding$environmentAssociationDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sessionExpirationDurationSeconds',
				A2($elm$json$Json$Decode$map, $author$project$Utils$TimeUtils$secondsToDays, $elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'principalType',
					$author$project$Decoding$PrincipalDecoding$principalTypeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'principalState',
						$author$project$Decoding$PrincipalDecoding$principalStateDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pos',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'groupId',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Entity$PrincipalAssociation$PrincipalAssociation))))))))));
var $author$project$Api$EntityApi$getPrincipals = A2($author$project$Api$EntityApi$getEntityDictData, $author$project$Api$ApiUrls$principalAssociationsUrl, $author$project$Decoding$PrincipalDecoding$principalDecoder);
var $author$project$Api$ApiUrls$roleGroupsUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/roleGroups';
var $author$project$Api$EntityApi$getRoleGroups = A2($author$project$Api$EntityApi$getEntityDictData, $author$project$Api$ApiUrls$roleGroupsUrl, $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder);
var $author$project$Entity$Role$Role = function (id) {
	return function (groupId) {
		return function (pos) {
			return function (aproProjectId) {
				return function (idAnchor) {
					return function (name) {
						return function (description) {
							return function (isUserRole) {
								return function (defaultViewId) {
									return function (views) {
										return function (commandIds) {
											return function (includedRoleIds) {
												return function (permissions) {
													return function (settingsViewComponentCommandIds) {
														return function (appBarViewComponentCommandIds) {
															return {fo: appBarViewComponentCommandIds, fp: aproProjectId, f$: commandIds, gx: defaultViewId, gC: description, hw: groupId, bZ: id, hH: idAnchor, hO: includedRoleIds, hY: isUserRole, is: name, eB: permissions, cr: pos, jz: settingsViewComponentCommandIds, kj: views};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Entity$Role$ViewAssociation = F3(
	function (viewId, showDirectly, permissions) {
		return {eB: permissions, jD: showDirectly, ki: viewId};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Entity$Role$DataViewPermissions = function (editingEnabled) {
	return {gT: editingEnabled};
};
var $author$project$Entity$Role$ViewPermissions = function (dataViewPermissions) {
	return {go: dataViewPermissions};
};
var $author$project$Decoding$RoleDecoding$viewPermissionsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Entity$Role$ViewPermissions,
	A2(
		$elm$json$Json$Decode$field,
		'dataViewPermissions',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Entity$Role$DataViewPermissions,
			A2($elm$json$Json$Decode$field, 'editingEnabled', $elm$json$Json$Decode$bool))));
var $author$project$Decoding$RoleDecoding$viewAssociationDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Entity$Role$ViewAssociation,
	A2($elm$json$Json$Decode$field, 'viewId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'showDirectly', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'permissions', $author$project$Decoding$RoleDecoding$viewPermissionsDecoder));
var $author$project$Decoding$RoleDecoding$roleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'appBarViewComponentCommandIds',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'settingsViewComponentCommandIds',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'permissions',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'includedRoleIds',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'commandIds',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'views',
						$elm$json$Json$Decode$list($author$project$Decoding$RoleDecoding$viewAssociationDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'defaultViewId',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'isUserRole',
								$elm$json$Json$Decode$bool,
								true,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'description',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'idAnchor',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'aproProjectId',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'pos',
													$elm$json$Json$Decode$int,
													0,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'groupId',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$int,
															$elm$json$Json$Decode$succeed($author$project$Entity$Role$Role))))))))))))))));
var $author$project$Api$ApiUrls$rolesUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/roles';
var $author$project$Api$EntityApi$getRoles = A2($author$project$Api$EntityApi$getEntityDictData, $author$project$Api$ApiUrls$rolesUrl, $author$project$Decoding$RoleDecoding$roleDecoder);
var $author$project$Pages$PageUpdateUtils$justAppMsg = F2(
	function (model, appMsg) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, appMsg);
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$selectedBranchChanged = _Platform_outgoingPort('selectedBranchChanged', $elm$json$Json$Encode$string);
var $author$project$Pages$PageUpdateUtils$sequence = F3(
	function (update, msgs, init) {
		var foldUpdate = $author$project$Pages$PageUpdateUtils$andThen(update);
		return A3($elm$core$List$foldl, foldUpdate, init, msgs);
	});
var $author$project$Lib$RemoteData$toLoading = function (remoteData) {
	switch (remoteData.$) {
		case 1:
			var oldData = remoteData.a;
			return $author$project$Lib$RemoteData$Loading(oldData);
		case 3:
			var data = remoteData.a;
			return $author$project$Lib$RemoteData$Loading(data);
		case 0:
			return $author$project$Lib$RemoteData$EmptyLoading;
		default:
			var e = remoteData.a;
			return $author$project$Lib$RemoteData$Failure(e);
	}
};
var $author$project$Pages$Main$EnvironmentsView$BeginDeleteEnvironment = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$BeginDeleteGroup = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$BeginEditEnvironment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$BeginEditGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$BeginSaveEnvironment = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$BeginSaveGroup = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$GotDeleteEnvironment = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$GotDeleteGroup = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$GotPostEnvironment = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$GotPostGroup = function (a) {
	return {$: 16, a: a};
};
var $author$project$Lib$Form$LoadStatus$InProgress = {$: 1};
var $author$project$Pages$Main$EnvironmentsView$ListingViewMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$EnvironmentsView$NoOp = {$: 0};
var $author$project$Pages$Main$OutMsg$NoOp = {$: 0};
var $author$project$Entity$Common$TEntity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Entity$Common$TGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$OutMsg$UpdateRepository = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Main$OutMsg$BatchOutMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$SubViewUpdateUtils$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var outMsg = _v0.c;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		var outMsg_ = _v1.c;
		return _Utils_Tuple3(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])),
			$author$project$Pages$Main$OutMsg$BatchOutMsg(
				_List_fromArray(
					[outMsg, outMsg_])));
	});
var $author$project$Utils$StringUtils$fromBool = function (bool) {
	return bool ? 'true' : 'false';
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Serializable$toString = function (serializable) {
	switch (serializable.$) {
		case 0:
			var string_ = serializable.a;
			return string_;
		case 1:
			var int_ = serializable.a;
			return $elm$core$String$fromInt(int_);
		case 2:
			var float_ = serializable.a;
			return $elm$core$String$fromFloat(float_);
		default:
			var bool_ = serializable.a;
			return $author$project$Utils$StringUtils$fromBool(bool_);
	}
};
var $author$project$Forms$CommandParameterForm$createCommandParameterFormValues = function (commandParameter) {
	return {
		h_: commandParameter.h_,
		kg: A2($elm$core$Maybe$map, $author$project$Serializable$toString, commandParameter.kg)
	};
};
var $author$project$Forms$ConnectionForms$createConnectionSetFormValues = function (connectionSet) {
	var connectionIdOrEmpty = function (getFromConnectionSet) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Entity$Common$nonExistentId,
			getFromConnectionSet(connectionSet));
	};
	return {
		fy: connectionIdOrEmpty(
			function ($) {
				return $.fy;
			}),
		gq: connectionIdOrEmpty(
			function ($) {
				return $.gq;
			}),
		hh: connectionIdOrEmpty(
			function ($) {
				return $.hh;
			}),
		hF: connectionIdOrEmpty(
			function ($) {
				return $.hF;
			}),
		h8: connectionIdOrEmpty(
			function ($) {
				return $.h8;
			})
	};
};
var $author$project$Forms$EnvironmentForms$createEnvironmentFormValues = function (env) {
	return {
		fp: env.fp,
		bG: $author$project$Forms$ConnectionForms$createConnectionSetFormValues(env.f9),
		gC: env.gC,
		gE: env.gE,
		gP: env.gP,
		g0: A2($elm$core$List$map, $author$project$Forms$CommandParameterForm$createCommandParameterFormValues, env.g0),
		g1: env.g1,
		hw: env.hw,
		bZ: env.bZ,
		hH: env.hH,
		is: env.is,
		cr: env.cr
	};
};
var $author$project$Entity$Connection$createNewConnectionReferenceSet = A5($author$project$Entity$Connection$ConnectionReferenceSet, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Entity$Common$lastPosition = -1;
var $author$project$Entity$Common$notPersistedId = 0;
var $author$project$Entity$Environment$createNewEnvironment = {fp: $elm$core$Maybe$Nothing, f9: $author$project$Entity$Connection$createNewConnectionReferenceSet, gC: '', gE: '', gP: _List_Nil, g0: _List_Nil, g1: '', hw: $elm$core$Maybe$Nothing, bZ: $author$project$Entity$Common$notPersistedId, hH: $elm$core$Maybe$Nothing, is: '', cr: $author$project$Entity$Common$lastPosition};
var $author$project$Entity$GenericEntityGroup$createNewGenericEntityGroup = {fp: $elm$core$Maybe$Nothing, gC: '', bZ: $author$project$Entity$Common$notPersistedId, is: '', dp: $elm$core$Maybe$Nothing, cr: $author$project$Entity$Common$lastPosition};
var $lukewestby$elm_http_builder$HttpBuilder$delete = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('DELETE');
var $author$project$Lib$CustomHttp$expectStringCustom = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		A2($author$project$Lib$CustomHttp$httpResponseToResult, $elm$core$Result$Ok, $elm$core$Maybe$Nothing));
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Api$EntityApi$strResultToIdResult = $elm$core$Result$andThen(
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		$elm$core$Result$fromMaybe(
			$author$project$Lib$CustomHttp$BadBody('Id ei ollut kelvollinen'))));
var $author$project$Api$EntityApi$deleteEntity = F4(
	function (url, _v0, id, toMsg) {
		var selectedBranchKey = _v0.js;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$author$project$Lib$CustomHttp$expectStringCustom(
					A2($elm$core$Basics$composeR, $author$project$Api$EntityApi$strResultToIdResult, toMsg)),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					$author$project$Api$ApiUrls$aavoBranchHeader,
					selectedBranchKey,
					$lukewestby$elm_http_builder$HttpBuilder$delete(
						A2(
							$elm$url$Url$Builder$relative,
							_List_fromArray(
								[
									url,
									$elm$core$String$fromInt(id)
								]),
							_List_Nil)))));
	});
var $author$project$Api$EntityApi$deleteEnvironment = $author$project$Api$EntityApi$deleteEntity($author$project$Api$ApiUrls$environmentsUrl);
var $author$project$Api$EntityApi$deleteEnvironmentGroup = $author$project$Api$EntityApi$deleteEntity($author$project$Api$ApiUrls$environmentGroupsUrl);
var $author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData = F2(
	function (data, id) {
		return A2(
			$author$project$Lib$RemoteData$map,
			$elm$core$Dict$remove(id),
			data);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId = function (model) {
	var _v0 = model.E;
	if (!_v0.$) {
		if (_v0.a.$ === 1) {
			var group = _v0.a.a;
			return $elm$core$Maybe$Just(group.bZ);
		} else {
			var entity = _v0.a.a;
			return entity.hw;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lib$RemoteData$update = F2(
	function (f, remoteData) {
		switch (remoteData.$) {
			case 3:
				var data = remoteData.a;
				var _v1 = f(data);
				var first = _v1.a;
				var second = _v1.b;
				return _Utils_Tuple2(
					$author$project$Lib$RemoteData$Success(first),
					second);
			case 0:
				return _Utils_Tuple2($author$project$Lib$RemoteData$EmptyLoading, $elm$core$Platform$Cmd$none);
			case 1:
				var oldData = remoteData.a;
				return _Utils_Tuple2(
					$author$project$Lib$RemoteData$Loading(
						f(oldData).a),
					$elm$core$Platform$Cmd$none);
			default:
				var error = remoteData.a;
				return _Utils_Tuple2(
					$author$project$Lib$RemoteData$Failure(error),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Lib$RemoteData$updateData = F2(
	function (f, remoteData) {
		return A2(
			$author$project$Lib$RemoteData$update,
			function (l) {
				return _Utils_Tuple2(
					f(l),
					$elm$core$Platform$Cmd$none);
			},
			remoteData).a;
	});
var $author$project$Utils$RemoteDataUtils$insertToEntityDictWebData = F2(
	function (data, item) {
		return A2(
			$author$project$Lib$RemoteData$updateData,
			function (dict) {
				return A3($elm$core$Dict$insert, item.bZ, item, dict);
			},
			data);
	});
var $author$project$Pages$Main$EntityListing$EntityListingFilters$TextFilter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Main$EntityListing$EntityListingFilters$createStringFilter = F3(
	function (filterProps, filterValue, element) {
		return A2(
			$elm$core$List$any,
			function (f) {
				return A2(
					$elm$core$String$contains,
					filterValue,
					f(element));
			},
			filterProps);
	});
var $author$project$Pages$Main$EntityListing$EntityListingFilters$commonStringFilter = F2(
	function (entityFilterProps, groupFilterProps) {
		return {
			bN: $author$project$Pages$Main$EntityListing$EntityListingFilters$createStringFilter(entityFilterProps),
			bO: $author$project$Pages$Main$EntityListing$EntityListingFilters$createStringFilter(groupFilterProps),
			c9: $author$project$Pages$Main$EntityListing$EntityListingFilters$TextFilter('Haku'),
			bZ: 'common_string_filter'
		};
	});
var $author$project$Pages$Main$EntityListing$ListingViewUtils$aproProjectIdColumns = function (entity) {
	var _v0 = entity.fp;
	if (!_v0.$) {
		var projectId = _v0.a;
		return _List_fromArray(
			[
				'APRO ' + $elm$core$String$fromInt(projectId)
			]);
	} else {
		return _List_Nil;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Utils$StringUtils$firstLine = function (string) {
	return $elm$core$String$fromList(
		A2(
			$elm_community$list_extra$List$Extra$takeWhile,
			$elm$core$Basics$neq('\n'),
			$elm$core$String$toList(string)));
};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Pages$Main$EntityListing$ListingViewUtils$idAnchorColumns = function (entity) {
	return $elm_community$maybe_extra$Maybe$Extra$toList(entity.hH);
};
var $author$project$Pages$Main$EnvironmentsView$getEntityTreeItemColumns = function (environment) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$core$String$fromInt(environment.bZ),
				environment.is,
				environment.gE,
				$author$project$Utils$StringUtils$firstLine(environment.gC)
			]),
		_Utils_ap(
			$author$project$Pages$Main$EntityListing$ListingViewUtils$aproProjectIdColumns(environment),
			$author$project$Pages$Main$EntityListing$ListingViewUtils$idAnchorColumns(environment)));
};
var $author$project$Entity$GenericEntityGroup$getGenericEntityGroupListingFields = function (group) {
	return _Utils_ap(
		_List_fromArray(
			[
				'Ryhmä',
				$elm$core$String$fromInt(group.bZ),
				group.is,
				$author$project$Utils$StringUtils$firstLine(group.gC)
			]),
		$author$project$Pages$Main$EntityListing$ListingViewUtils$aproProjectIdColumns(group));
};
var $author$project$Pages$Main$EnvironmentsView$listingViewConfig = {
	da: _List_fromArray(
		[
			A2(
			$author$project$Pages$Main$EntityListing$EntityListingFilters$commonStringFilter,
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bZ;
					},
					$elm$core$String$fromInt),
					function ($) {
					return $.is;
				},
					function ($) {
					return $.gC;
				}
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bZ;
					},
					$elm$core$String$fromInt),
					function ($) {
					return $.is;
				},
					function ($) {
					return $.gC;
				}
				]))
		]),
	dc: function ($) {
		return $.ea;
	},
	eh: $author$project$Pages$Main$EnvironmentsView$getEntityTreeItemColumns,
	ei: $author$project$Entity$GenericEntityGroup$getGenericEntityGroupListingFields,
	bQ: function ($) {
		return $.Y;
	}
};
var $author$project$Lib$Form$FormView$ErrorTracking = $elm$core$Basics$identity;
var $author$project$Lib$Form$LoadStatus$Idle = {$: 0};
var $author$project$Lib$Form$FormView$makeModel = function (values) {
	return {
		aR: {cJ: false, cK: $elm$core$Set$empty},
		_: $elm$core$Maybe$Nothing,
		F: $author$project$Lib$Form$LoadStatus$Idle,
		e8: values
	};
};
var $author$project$Pages$Main$OutMsg$OnHttpError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult = F3(
	function (onOk, model, result) {
		if (!result.$) {
			var content = result.a;
			return onOk(content);
		} else {
			var err = result.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Pages$Main$OutMsg$OnHttpError(err));
		}
	});
var $author$project$Pages$Main$EnvironmentsView$onGotDelete = F2(
	function (updateRepository, model) {
		return A2(
			$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
			function (id) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a2: $author$project$Pages$Main$EnvironmentsView$Hidden}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						updateRepository(id)));
			},
			model);
	});
var $author$project$Pages$Main$EditEntityOrGroupModel$updateKeepingMode = F2(
	function (currentModel, newModel) {
		var _v0 = _Utils_Tuple2(currentModel, newModel);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (_v0.b.$ === 1) {
						var focusedCodeField = _v0.a.a._;
						var newModel_ = _v0.b.a;
						return $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
							_Utils_update(
								newModel_,
								{_: focusedCodeField}));
					} else {
						break _v0$2;
					}
				case 2:
					if (_v0.b.$ === 2) {
						return newModel;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return currentModel;
	});
var $author$project$Pages$Main$EnvironmentsView$onGotPostResult = F2(
	function (_v0, model) {
		var makeNewEditModel = _v0.di;
		var updateRepository = _v0.dL;
		return A2(
			$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
			function (environment) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							l: A2(
								$author$project$Pages$Main$EditEntityOrGroupModel$updateKeepingMode,
								model.l,
								makeNewEditModel(environment))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						updateRepository(environment)));
			},
			model);
	});
var $author$project$Pages$Main$EnvironmentsView$positionUpdatingConfig = {
	dc: function ($) {
		return $.ea;
	},
	bQ: function ($) {
		return $.Y;
	},
	dz: F2(
		function (environments, repo) {
			return _Utils_update(
				repo,
				{
					ea: $author$project$Lib$RemoteData$Success(environments)
				});
		}),
	dB: F2(
		function (groups, repo) {
			return _Utils_update(
				repo,
				{
					Y: $author$project$Lib$RemoteData$Success(groups)
				});
		})
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Serializable$encode = function (serializable) {
	switch (serializable.$) {
		case 0:
			var string_ = serializable.a;
			return $elm$json$Json$Encode$string(string_);
		case 1:
			var int_ = serializable.a;
			return $elm$json$Json$Encode$int(int_);
		case 2:
			var float_ = serializable.a;
			return $elm$json$Json$Encode$float(float_);
		default:
			var bool_ = serializable.a;
			return $elm$json$Json$Encode$bool(bool_);
	}
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Encoding$Utils$encodeMaybe = F2(
	function (encoder, maybeVal) {
		if (maybeVal.$ === 1) {
			return $elm$json$Json$Encode$null;
		} else {
			var val = maybeVal.a;
			return encoder(val);
		}
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Encoding$CommandParameterEncoding$encodeCommandParameter = function (commandParameter) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(commandParameter.h_)),
				_Utils_Tuple2(
				'value',
				A2($author$project$Encoding$Utils$encodeMaybe, $author$project$Serializable$encode, commandParameter.kg))
			]));
};
var $author$project$Encoding$ConnectionEncoding$encodeConnectionReferenceSet = function (set) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dbConnectionId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, set.gq)),
				_Utils_Tuple2(
				'httpConnectionId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, set.hF)),
				_Utils_Tuple2(
				'fileServerConnectionId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, set.hh)),
				_Utils_Tuple2(
				'mailServerConnectionId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, set.h8)),
				_Utils_Tuple2(
				'awsConnectionId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, set.fy))
			]));
};
var $author$project$Encoding$EnvironmentEncoding$encodeDynamicConnectionAssociation = function (_v0) {
	var dynamicConnectionId = _v0.gO;
	var actualConnectionId = _v0.fh;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dynamicConnectionId',
				$elm$json$Json$Encode$int(dynamicConnectionId)),
				_Utils_Tuple2(
				'actualConnectionId',
				$elm$json$Json$Encode$int(actualConnectionId))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Encoding$EnvironmentEncoding$encodeEnvironment = function (environment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(environment.is)),
				_Utils_Tuple2(
				'displayName',
				$elm$json$Json$Encode$string(environment.gE)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(environment.gC)),
				_Utils_Tuple2(
				'environmentType',
				$elm$json$Json$Encode$string(environment.g1)),
				_Utils_Tuple2(
				'connections',
				$author$project$Encoding$ConnectionEncoding$encodeConnectionReferenceSet(environment.f9)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(environment.bZ)),
				_Utils_Tuple2(
				'groupId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, environment.hw)),
				_Utils_Tuple2(
				'pos',
				$elm$json$Json$Encode$int(environment.cr)),
				_Utils_Tuple2(
				'aproProjectId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, environment.fp)),
				_Utils_Tuple2(
				'idAnchor',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$string, environment.hH)),
				_Utils_Tuple2(
				'dynamicConnections',
				A2($elm$json$Json$Encode$list, $author$project$Encoding$EnvironmentEncoding$encodeDynamicConnectionAssociation, environment.gP)),
				_Utils_Tuple2(
				'environmentParameters',
				A2($elm$json$Json$Encode$list, $author$project$Encoding$CommandParameterEncoding$encodeCommandParameter, environment.g0))
			]));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $lukewestby$elm_http_builder$HttpBuilder$withBody = F2(
	function (body, builder) {
		return _Utils_update(
			builder,
			{fD: body});
	});
var $lukewestby$elm_http_builder$HttpBuilder$withJsonBody = function (value) {
	return $lukewestby$elm_http_builder$HttpBuilder$withBody(
		$elm$http$Http$jsonBody(value));
};
var $author$project$Api$EntityApi$postEntity = F6(
	function (url, encoder, decoder, _v0, entity, toMsg) {
		var selectedBranchKey = _v0.js;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($author$project$Lib$CustomHttp$expectJsonCustom, toMsg, decoder),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					$author$project$Api$ApiUrls$aavoBranchHeader,
					selectedBranchKey,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						encoder(entity),
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Api$EntityApi$postEnvironment = A3($author$project$Api$EntityApi$postEntity, $author$project$Api$ApiUrls$environmentsUrl, $author$project$Encoding$EnvironmentEncoding$encodeEnvironment, $author$project$Decoding$EnvironmentDecoding$environmentDecoder);
var $author$project$Entity$GenericEntityGroup$encodeGenericEntityGroup = function (group) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(group.is)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(group.gC)),
				_Utils_Tuple2(
				'parentId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, group.dp)),
				_Utils_Tuple2(
				'pos',
				$elm$json$Json$Encode$int(group.cr)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(group.bZ)),
				_Utils_Tuple2(
				'aproProjectId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, group.fp))
			]));
};
var $author$project$Api$EntityApi$postEnvironmentGroup = A3($author$project$Api$EntityApi$postEntity, $author$project$Api$ApiUrls$environmentGroupsUrl, $author$project$Entity$GenericEntityGroup$encodeGenericEntityGroup, $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder);
var $author$project$Api$EntityApi$encodesaveEntityPositionRequest = function (_v0) {
	var id = _v0.bZ;
	var pos = _v0.cr;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(id)),
				_Utils_Tuple2(
				'pos',
				$elm$json$Json$Encode$int(pos))
			]));
};
var $lukewestby$elm_http_builder$HttpBuilder$put = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('PUT');
var $author$project$Api$EntityApi$saveEntityPosition = F4(
	function (url, _v0, _v1, toMsg) {
		var selectedBranchKey = _v0.js;
		var id = _v1.bZ;
		var pos = _v1.cr;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$author$project$Lib$CustomHttp$expectWhateverCustom(toMsg),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Api$EntityApi$encodesaveEntityPositionRequest(
						{bZ: id, cr: pos}),
					A3(
						$lukewestby$elm_http_builder$HttpBuilder$withHeader,
						$author$project$Api$ApiUrls$aavoBranchHeader,
						selectedBranchKey,
						$lukewestby$elm_http_builder$HttpBuilder$put(
							A2(
								$elm$url$Url$Builder$relative,
								_List_fromArray(
									[url, 'position']),
								_List_Nil))))));
	});
var $author$project$Api$EntityApi$saveEnvironmentGroupPosition = $author$project$Api$EntityApi$saveEntityPosition($author$project$Api$ApiUrls$environmentGroupsUrl);
var $author$project$Api$EntityApi$saveEnvironmentPosition = $author$project$Api$EntityApi$saveEntityPosition($author$project$Api$ApiUrls$environmentsUrl);
var $author$project$Pages$Main$EnvironmentsView$Confirm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lib$Form$FormView$setStatusTo = F2(
	function (state, model) {
		return _Utils_update(
			model,
			{F: state});
	});
var $author$project$Pages$Main$EnvironmentsView$setCurrentViewLoadStatusTo = F2(
	function (status, model) {
		var modal = function () {
			var _v1 = model.a2;
			if (_v1.$ === 2) {
				var config = _v1.a;
				return $author$project$Pages$Main$EnvironmentsView$Confirm(
					_Utils_update(
						config,
						{eV: status}));
			} else {
				return model.a2;
			}
		}();
		var editItemModel = function () {
			var _v0 = model.l;
			switch (_v0.$) {
				case 1:
					var formModel = _v0.a;
					return $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
						A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel));
				case 2:
					var formModel = _v0.a;
					return $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
						A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel));
				default:
					return $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing;
			}
		}();
		return _Utils_update(
			model,
			{l: editItemModel, a2: modal});
	});
var $author$project$Pages$Main$EnvironmentsView$CloseCurrentModal = {$: 2};
var $author$project$Pages$Main$SubViewUpdateUtils$withoutActions = function (model) {
	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$OutMsg$NoOp);
};
var $author$project$Pages$Main$EnvironmentsView$showConfirmModal = F3(
	function (model, message, onConfirmed) {
		return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
			_Utils_update(
				model,
				{
					a2: $author$project$Pages$Main$EnvironmentsView$Confirm(
						{fI: $author$project$Pages$Main$EnvironmentsView$CloseCurrentModal, f6: onConfirmed, gc: message, eV: $author$project$Lib$Form$LoadStatus$Idle})
				}));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewEntityOutMsg = {$: 4};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewGroupOutMsg = {$: 5};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditEntityOutMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditGroupOutMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginRefreshOutMsg = {$: 1};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$ConfirmDeleteEntity = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$ConfirmDeleteGroup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$OutMsgNoOp = {$: 0};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$SetEntityPositionOutMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$SetGroupPositionOutMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Main$EntityListing$TreeElement$getPositionOfElement = function (element) {
	if (!element.$) {
		var entity = element.a;
		return entity.cr;
	} else {
		var group = element.a;
		return group.cr;
	}
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$getNewPositionOnAfterDropToElementSpanArea = F2(
	function (element, lowerElement) {
		return (_Utils_cmp(
			$author$project$Pages$Main$EntityListing$TreeElement$getPositionOfElement(lowerElement),
			element.cr) < 0) ? $author$project$Pages$Main$EntityListing$TreeElement$getPositionOfElement(lowerElement) : ((_Utils_cmp(
			$author$project$Pages$Main$EntityListing$TreeElement$getPositionOfElement(lowerElement),
			element.cr) > 0) ? ($author$project$Pages$Main$EntityListing$TreeElement$getPositionOfElement(lowerElement) - 1) : element.cr);
	});
var $author$project$Pages$Main$EntityListing$TreeElement$getParentIdOfElement = function (element) {
	if (!element.$) {
		var entity = element.a;
		return entity.hw;
	} else {
		var group = element.a;
		return group.dp;
	}
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$getPositionOfLastChildOfGroup = F3(
	function (config, repository, groupId) {
		var _v0 = _Utils_Tuple2(
			config.bQ(repository),
			config.dc(repository));
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var groups = _v0.a.a;
			var entities = _v0.b.a;
			var childrenPositions = _Utils_ap(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cr;
					},
					A2(
						$elm$core$List$filter,
						function (e) {
							return _Utils_eq(e.hw, groupId);
						},
						$elm$core$Dict$values(entities))),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cr;
					},
					A2(
						$elm$core$List$filter,
						function (g) {
							return _Utils_eq(g.dp, groupId);
						},
						$elm$core$Dict$values(groups))));
			return A2(
				$elm$core$Maybe$withDefault,
				-1,
				$elm$core$List$maximum(childrenPositions));
		} else {
			return -1;
		}
	});
var $author$project$Lib$DragDrop$DraggedOver = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Lib$DragDrop$Dragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lib$DragDrop$updateCommon = F3(
	function (sticky, msg, model) {
		var _v0 = _Utils_Tuple3(msg, model, sticky);
		_v0$9:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					var dragId = _v1.a;
					return _Utils_Tuple2(
						$author$project$Lib$DragDrop$Dragging(dragId),
						$elm$core$Maybe$Nothing);
				case 1:
					var _v2 = _v0.a;
					return _Utils_Tuple2($author$project$Lib$DragDrop$NotDragging, $elm$core$Maybe$Nothing);
				case 2:
					switch (_v0.b.$) {
						case 1:
							var dropId = _v0.a.a;
							var dragId = _v0.b.a;
							return _Utils_Tuple2(
								A4($author$project$Lib$DragDrop$DraggedOver, dragId, dropId, 0, $elm$core$Maybe$Nothing),
								$elm$core$Maybe$Nothing);
						case 2:
							var dropId = _v0.a.a;
							var _v3 = _v0.b;
							var dragId = _v3.a;
							var pos = _v3.d;
							return _Utils_Tuple2(
								A4($author$project$Lib$DragDrop$DraggedOver, dragId, dropId, 0, pos),
								$elm$core$Maybe$Nothing);
						default:
							break _v0$9;
					}
				case 3:
					if ((_v0.b.$ === 2) && (!_v0.c)) {
						var dropId_ = _v0.a.a;
						var _v4 = _v0.b;
						var dragId = _v4.a;
						var dropId = _v4.b;
						return _Utils_eq(dropId_, dropId) ? _Utils_Tuple2(
							$author$project$Lib$DragDrop$Dragging(dragId),
							$elm$core$Maybe$Nothing) : _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					} else {
						break _v0$9;
					}
				case 4:
					switch (_v0.b.$) {
						case 1:
							var _v5 = _v0.a;
							var dropId = _v5.a;
							var timeStamp = _v5.b;
							var pos = _v5.c;
							var dragId = _v0.b.a;
							return _Utils_Tuple2(
								A4(
									$author$project$Lib$DragDrop$DraggedOver,
									dragId,
									dropId,
									timeStamp,
									$elm$core$Maybe$Just(pos)),
								$elm$core$Maybe$Nothing);
						case 2:
							var _v6 = _v0.a;
							var dropId = _v6.a;
							var timeStamp = _v6.b;
							var pos = _v6.c;
							var _v7 = _v0.b;
							var dragId = _v7.a;
							var currentDropId = _v7.b;
							var currentTimeStamp = _v7.c;
							var currentPos = _v7.d;
							return _Utils_eq(timeStamp, currentTimeStamp) ? _Utils_Tuple2(model, $elm$core$Maybe$Nothing) : ((_Utils_eq(
								$elm$core$Maybe$Just(pos),
								currentPos) && _Utils_eq(dropId, currentDropId)) ? _Utils_Tuple2(model, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
								A4(
									$author$project$Lib$DragDrop$DraggedOver,
									dragId,
									dropId,
									timeStamp,
									$elm$core$Maybe$Just(pos)),
								$elm$core$Maybe$Nothing));
						default:
							break _v0$9;
					}
				default:
					switch (_v0.b.$) {
						case 1:
							var _v8 = _v0.a;
							var dropId = _v8.a;
							var pos = _v8.b;
							var dragId = _v0.b.a;
							return _Utils_Tuple2(
								$author$project$Lib$DragDrop$NotDragging,
								$elm$core$Maybe$Just(
									_Utils_Tuple3(dragId, dropId, pos)));
						case 2:
							var _v9 = _v0.a;
							var dropId = _v9.a;
							var pos = _v9.b;
							var _v10 = _v0.b;
							var dragId = _v10.a;
							return _Utils_Tuple2(
								$author$project$Lib$DragDrop$NotDragging,
								$elm$core$Maybe$Just(
									_Utils_Tuple3(dragId, dropId, pos)));
						default:
							break _v0$9;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
	});
var $author$project$Lib$DragDrop$update = $author$project$Lib$DragDrop$updateCommon(false);
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$updateOnDragDropCommandTreeItemMsg = F4(
	function (config, repository, model, msg) {
		var _v0 = A2($author$project$Lib$DragDrop$update, msg, model.W);
		var dragDropModel = _v0.a;
		var dropResult = _v0.b;
		var saveOutMsg = function () {
			_v1$6:
			while (true) {
				if (!dropResult.$) {
					if (!dropResult.a.a.$) {
						switch (dropResult.a.b.$) {
							case 2:
								var _v2 = dropResult.a;
								var entity = _v2.a.a;
								var group = _v2.b.a;
								return A2(
									$author$project$Pages$Main$EntityListing$GenericEntityListingView$SetEntityPositionOutMsg,
									_Utils_update(
										entity,
										{
											hw: $elm$core$Maybe$Just(group.bZ),
											cr: A3(
												$author$project$Pages$Main$EntityListing$GenericEntityListingView$getPositionOfLastChildOfGroup,
												config,
												repository,
												$elm$core$Maybe$Just(group.bZ))
										}),
									{ad: entity.cr});
							case 1:
								var _v4 = dropResult.a;
								var entity = _v4.a.a;
								var _v5 = _v4.b;
								return A2(
									$author$project$Pages$Main$EntityListing$GenericEntityListingView$SetEntityPositionOutMsg,
									_Utils_update(
										entity,
										{
											hw: $elm$core$Maybe$Nothing,
											cr: A3($author$project$Pages$Main$EntityListing$GenericEntityListingView$getPositionOfLastChildOfGroup, config, repository, $elm$core$Maybe$Nothing)
										}),
									{ad: entity.cr});
							case 3:
								var _v8 = dropResult.a;
								var entity = _v8.a.a;
								var lowerElement = _v8.b.a.b4;
								return A2(
									$author$project$Pages$Main$EntityListing$GenericEntityListingView$SetEntityPositionOutMsg,
									_Utils_update(
										entity,
										{
											hw: $author$project$Pages$Main$EntityListing$TreeElement$getParentIdOfElement(lowerElement),
											cr: A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$getNewPositionOnAfterDropToElementSpanArea, entity, lowerElement)
										}),
									{ad: entity.cr});
							default:
								break _v1$6;
						}
					} else {
						switch (dropResult.a.b.$) {
							case 2:
								var _v3 = dropResult.a;
								var group = _v3.a.a;
								var parentGroup = _v3.b.a;
								return A2(
									$author$project$Pages$Main$EntityListing$GenericEntityListingView$SetGroupPositionOutMsg,
									_Utils_update(
										group,
										{
											dp: $elm$core$Maybe$Just(parentGroup.bZ),
											cr: A3(
												$author$project$Pages$Main$EntityListing$GenericEntityListingView$getPositionOfLastChildOfGroup,
												config,
												repository,
												$elm$core$Maybe$Just(group.bZ))
										}),
									{ad: group.cr});
							case 1:
								var _v6 = dropResult.a;
								var group = _v6.a.a;
								var _v7 = _v6.b;
								return A2(
									$author$project$Pages$Main$EntityListing$GenericEntityListingView$SetGroupPositionOutMsg,
									_Utils_update(
										group,
										{
											dp: $elm$core$Maybe$Nothing,
											cr: A3($author$project$Pages$Main$EntityListing$GenericEntityListingView$getPositionOfLastChildOfGroup, config, repository, $elm$core$Maybe$Nothing)
										}),
									{ad: group.cr});
							case 3:
								var _v9 = dropResult.a;
								var group = _v9.a.a;
								var lowerElement = _v9.b.a.b4;
								return A2(
									$author$project$Pages$Main$EntityListing$GenericEntityListingView$SetGroupPositionOutMsg,
									_Utils_update(
										group,
										{
											dp: $author$project$Pages$Main$EntityListing$TreeElement$getParentIdOfElement(lowerElement),
											cr: A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$getNewPositionOnAfterDropToElementSpanArea, group, lowerElement)
										}),
									{ad: group.cr});
							default:
								break _v1$6;
						}
					}
				} else {
					break _v1$6;
				}
			}
			return $author$project$Pages$Main$EntityListing$GenericEntityListingView$OutMsgNoOp;
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{W: dragDropModel}),
			$elm$core$Platform$Cmd$none,
			saveOutMsg);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$update = F4(
	function (config, repository, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$EntityListing$GenericEntityListingView$OutMsgNoOp);
			case 1:
				var newState = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cP: newState}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$EntityListing$GenericEntityListingView$OutMsgNoOp);
			case 2:
				var filterId = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ar: A3($elm$core$Dict$insert, filterId, value, model.ar)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$EntityListing$GenericEntityListingView$OutMsgNoOp);
			case 3:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginRefreshOutMsg);
			case 4:
				var commandOrGroup = msg.a;
				var outMsg = function () {
					if (!commandOrGroup.$) {
						var entity = commandOrGroup.a;
						return $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditEntityOutMsg(entity);
					} else {
						var group = commandOrGroup.a;
						return $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditGroupOutMsg(group);
					}
				}();
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, outMsg);
			case 6:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewEntityOutMsg);
			case 7:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewGroupOutMsg);
			case 5:
				var commandOrGroup = msg.a;
				var outMsg = function () {
					if (!commandOrGroup.$) {
						var entity = commandOrGroup.a;
						return $author$project$Pages$Main$EntityListing$GenericEntityListingView$ConfirmDeleteEntity(entity);
					} else {
						var group = commandOrGroup.a;
						return $author$project$Pages$Main$EntityListing$GenericEntityListingView$ConfirmDeleteGroup(group);
					}
				}();
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, outMsg);
			case 8:
				var element = msg.a;
				var newSelection = _Utils_eq(
					model.E,
					$elm$core$Maybe$Just(element)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(element);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{E: newSelection}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$EntityListing$GenericEntityListingView$OutMsgNoOp);
			default:
				var dragDropMsg = msg.a;
				return A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$updateOnDragDropCommandTreeItemMsg, config, repository, model, dragDropMsg);
		}
	});
var $author$project$Pages$Main$EntityListing$PositionUpdating$decrementPositionIfHigherThan = F2(
	function (limit, resource) {
		return (_Utils_cmp(resource.cr, limit) > 0) ? _Utils_update(
			resource,
			{cr: resource.cr - 1}) : resource;
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Utils$DictUtils$mapValues = F2(
	function (_function, dict) {
		return A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, v) {
					return _function(v);
				}),
			dict);
	});
var $author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete = F3(
	function (config, repository, deletedPos) {
		var _v0 = _Utils_Tuple2(
			config.dc(repository),
			config.bQ(repository));
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var entities = _v0.a.a;
			var groups = _v0.b.a;
			var groups_ = A2(
				$author$project$Utils$DictUtils$mapValues,
				$author$project$Pages$Main$EntityListing$PositionUpdating$decrementPositionIfHigherThan(deletedPos),
				groups);
			var entities_ = A2(
				$author$project$Utils$DictUtils$mapValues,
				$author$project$Pages$Main$EntityListing$PositionUpdating$decrementPositionIfHigherThan(deletedPos),
				entities);
			return A2(
				config.dB,
				groups_,
				A2(config.dz, entities_, repository));
		} else {
			return repository;
		}
	});
var $author$project$Entity$Common$entityOrGroupsEquals = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var a_ = _v0.a.a;
					var b_ = _v0.b.a;
					return _Utils_eq(a_.bZ, b_.bZ);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 1) {
					var a_ = _v0.a.a;
					var b_ = _v0.b.a;
					return _Utils_eq(a_.bZ, b_.bZ);
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $author$project$Pages$Main$EntityListing$PositionUpdating$getEntityOrGroupPosition = function (entityOrGroup) {
	if (!entityOrGroup.$) {
		var entity = entityOrGroup.a;
		return entity.cr;
	} else {
		var entityGroup = entityOrGroup.a;
		return entityGroup.cr;
	}
};
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionIfInRange = F3(
	function (oldPos, newPos, resource) {
		return (_Utils_cmp(newPos, oldPos) < 0) ? (((_Utils_cmp(resource.cr, newPos) > -1) && (_Utils_cmp(resource.cr, oldPos) < 0)) ? _Utils_update(
			resource,
			{cr: resource.cr + 1}) : resource) : ((_Utils_cmp(newPos, oldPos) > 0) ? (((_Utils_cmp(resource.cr, newPos) < 1) && (_Utils_cmp(resource.cr, oldPos) > 0)) ? _Utils_update(
			resource,
			{cr: resource.cr - 1}) : resource) : resource);
	});
var $author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove = F4(
	function (config, repository, oldPos, updatedResource) {
		var _v0 = _Utils_Tuple2(
			config.dc(repository),
			config.bQ(repository));
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var entities = _v0.a.a;
			var groups = _v0.b.a;
			var newPos = $author$project$Pages$Main$EntityListing$PositionUpdating$getEntityOrGroupPosition(updatedResource);
			var groups_ = A2(
				$author$project$Utils$DictUtils$mapValues,
				function (g) {
					return A2(
						$author$project$Entity$Common$entityOrGroupsEquals,
						updatedResource,
						$author$project$Entity$Common$TGroup(g)) ? _Utils_update(
						g,
						{cr: newPos}) : A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionIfInRange, oldPos, newPos, g);
				},
				groups);
			var entities_ = A2(
				$author$project$Utils$DictUtils$mapValues,
				function (e) {
					return A2(
						$author$project$Entity$Common$entityOrGroupsEquals,
						updatedResource,
						$author$project$Entity$Common$TEntity(e)) ? _Utils_update(
						e,
						{cr: newPos}) : A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionIfInRange, oldPos, newPos, e);
				},
				entities);
			return A2(
				config.dB,
				groups_,
				A2(config.dz, entities_, repository));
		} else {
			return repository;
		}
	});
var $author$project$Pages$Main$EnvironmentsView$handleListingViewOutMsg = F5(
	function (apiConfig, repository, model, cmd, outMsg) {
		var newMsg = function (msg) {
			return A3(
				$author$project$Pages$Main$SubViewUpdateUtils$andThen,
				A2($author$project$Pages$Main$EnvironmentsView$update, apiConfig, repository),
				msg,
				_Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$NoOp));
		};
		switch (outMsg.$) {
			case 0:
				return _Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$NoOp);
			case 1:
				return _Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$BeginReloadAllEntities);
			case 2:
				var entity = outMsg.a;
				return newMsg(
					$author$project$Pages$Main$EnvironmentsView$BeginEditEnvironment(entity));
			case 3:
				var group = outMsg.a;
				return newMsg(
					$author$project$Pages$Main$EnvironmentsView$BeginEditGroup(group));
			case 4:
				return newMsg(
					$author$project$Pages$Main$EnvironmentsView$BeginEditEnvironment(
						_Utils_update(
							$author$project$Entity$Environment$createNewEnvironment,
							{
								hw: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})));
			case 5:
				return newMsg(
					$author$project$Pages$Main$EnvironmentsView$BeginEditGroup(
						_Utils_update(
							$author$project$Entity$GenericEntityGroup$createNewGenericEntityGroup,
							{
								dp: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})));
			case 6:
				var environment = outMsg.a;
				return A3(
					$author$project$Pages$Main$EnvironmentsView$showConfirmModal,
					model,
					'Haluatko varmasti poistaa ympäristön ' + (environment.is + '?'),
					$author$project$Pages$Main$EnvironmentsView$BeginDeleteEnvironment(environment));
			case 7:
				var group = outMsg.a;
				return A3(
					$author$project$Pages$Main$EnvironmentsView$showConfirmModal,
					model,
					'Haluatko varmasti poistaa ryhmän ' + (group.is + '?'),
					$author$project$Pages$Main$EnvironmentsView$BeginDeleteGroup(group));
			case 8:
				var environment = outMsg.a;
				var oldPos = outMsg.b.ad;
				var repo = A4(
					$author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove,
					$author$project$Pages$Main$EnvironmentsView$positionUpdatingConfig,
					repository,
					oldPos,
					$author$project$Entity$Common$TEntity(environment));
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$andThen,
					A2($author$project$Pages$Main$EnvironmentsView$update, apiConfig, repo),
					$author$project$Pages$Main$EnvironmentsView$BeginSaveEnvironment(environment),
					_Utils_Tuple3(
						model,
						A3(
							$author$project$Api$EntityApi$saveEnvironmentPosition,
							apiConfig,
							environment,
							$elm$core$Basics$always($author$project$Pages$Main$EnvironmentsView$NoOp)),
						$author$project$Pages$Main$OutMsg$UpdateRepository(repo)));
			default:
				var group = outMsg.a;
				var oldPos = outMsg.b.ad;
				var repo = A4(
					$author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove,
					$author$project$Pages$Main$EnvironmentsView$positionUpdatingConfig,
					repository,
					oldPos,
					$author$project$Entity$Common$TGroup(group));
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$andThen,
					A2($author$project$Pages$Main$EnvironmentsView$update, apiConfig, repo),
					$author$project$Pages$Main$EnvironmentsView$BeginSaveGroup(group),
					_Utils_Tuple3(
						model,
						A3(
							$author$project$Api$EntityApi$saveEnvironmentGroupPosition,
							apiConfig,
							group,
							$elm$core$Basics$always($author$project$Pages$Main$EnvironmentsView$NoOp)),
						$author$project$Pages$Main$OutMsg$UpdateRepository(repo)));
		}
	});
var $author$project$Pages$Main$EnvironmentsView$update = F4(
	function (apiConfig, repository, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$OutMsg$NoOp);
				case 1:
					var listingViewMsg = msg.a;
					var _v1 = A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$update, $author$project$Pages$Main$EnvironmentsView$listingViewConfig, repository, listingViewMsg, model.K);
					var listingViewModel = _v1.a;
					var listingViewCmd = _v1.b;
					var listingViewOutMsg = _v1.c;
					return A5(
						$author$project$Pages$Main$EnvironmentsView$handleListingViewOutMsg,
						apiConfig,
						repository,
						_Utils_update(
							model,
							{K: listingViewModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Main$EnvironmentsView$ListingViewMsg, listingViewCmd),
						listingViewOutMsg);
				case 4:
					var environment = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
									$author$project$Lib$Form$FormView$makeModel(
										$author$project$Forms$EnvironmentForms$createEnvironmentFormValues(environment)))
							}));
				case 5:
					var group = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
									$author$project$Lib$Form$FormView$makeModel(group))
							}));
				case 2:
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{a2: $author$project$Pages$Main$EnvironmentsView$Hidden}));
				case 6:
					var newValues = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(newValues)
							}));
				case 7:
					var newValues = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(newValues)
							}));
				case 8:
					var environment = msg.a;
					var $temp$apiConfig = apiConfig,
						$temp$repository = repository,
						$temp$msg = $author$project$Pages$Main$EnvironmentsView$BeginEditEnvironment(
						_Utils_update(
							environment,
							{
								hw: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})),
						$temp$model = _Utils_update(
						model,
						{a2: $author$project$Pages$Main$EnvironmentsView$Hidden});
					apiConfig = $temp$apiConfig;
					repository = $temp$repository;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 3:
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{l: $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing}));
				case 9:
					var environment = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$EnvironmentsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$postEnvironment, apiConfig, environment, $author$project$Pages$Main$EnvironmentsView$GotPostEnvironment),
						$author$project$Pages$Main$OutMsg$NoOp);
				case 10:
					var group = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$EnvironmentsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$postEnvironmentGroup, apiConfig, group, $author$project$Pages$Main$EnvironmentsView$GotPostGroup),
						$author$project$Pages$Main$OutMsg$NoOp);
				case 11:
					var environment = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$EnvironmentsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$deleteEnvironment, apiConfig, environment.bZ, $author$project$Pages$Main$EnvironmentsView$GotDeleteEnvironment),
						$author$project$Pages$Main$OutMsg$UpdateRepository(
							A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete, $author$project$Pages$Main$EnvironmentsView$positionUpdatingConfig, repository, environment.cr)));
				case 12:
					var group = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$EnvironmentsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$deleteEnvironmentGroup, apiConfig, group.bZ, $author$project$Pages$Main$EnvironmentsView$GotDeleteGroup),
						$author$project$Pages$Main$OutMsg$UpdateRepository(
							A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete, $author$project$Pages$Main$EnvironmentsView$positionUpdatingConfig, repository, group.cr)));
				case 15:
					var result = msg.a;
					return A3(
						$author$project$Pages$Main$EnvironmentsView$onGotPostResult,
						{
							di: A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel, $author$project$Lib$Form$FormView$makeModel),
								$author$project$Forms$EnvironmentForms$createEnvironmentFormValues),
							dL: function (environment) {
								return _Utils_update(
									repository,
									{
										ea: A2($author$project$Utils$RemoteDataUtils$insertToEntityDictWebData, repository.ea, environment)
									});
							}
						},
						model,
						result);
				case 16:
					var result = msg.a;
					return A3(
						$author$project$Pages$Main$EnvironmentsView$onGotPostResult,
						{
							di: A2($elm$core$Basics$composeL, $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel, $author$project$Lib$Form$FormView$makeModel),
							dL: function (group) {
								return _Utils_update(
									repository,
									{
										Y: A2($author$project$Utils$RemoteDataUtils$insertToEntityDictWebData, repository.Y, group)
									});
							}
						},
						model,
						result);
				case 13:
					var httpResult = msg.a;
					return A3(
						$author$project$Pages$Main$EnvironmentsView$onGotDelete,
						function (id) {
							return _Utils_update(
								repository,
								{
									ea: A2($author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData, repository.ea, id)
								});
						},
						model,
						httpResult);
				default:
					var httpResult = msg.a;
					return A3(
						$author$project$Pages$Main$EnvironmentsView$onGotDelete,
						function (id) {
							return _Utils_update(
								repository,
								{
									Y: A2($author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData, repository.Y, id)
								});
						},
						model,
						httpResult);
			}
		}
	});
var $author$project$Pages$Main$PrincipalsView$AddNewPrincipalAssociationModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$PrincipalsView$BeginDeleteGroup = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Main$PrincipalsView$BeginDeletePrincipal = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Main$PrincipalsView$BeginEditGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Main$PrincipalsView$BeginEditPrincipal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$PrincipalsView$BeginSaveGroup = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Main$PrincipalsView$BeginSavePrincipal = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Main$PrincipalsView$GotDeleteGroup = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Main$PrincipalsView$GotDeletePrincipal = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Main$PrincipalsView$GotPostGroup = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Main$PrincipalsView$GotPostNewApiTokenAssociation = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Main$PrincipalsView$GotPostNewRegularUserAssociation = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Main$PrincipalsView$GotPutPrincipalAssociation = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Main$PrincipalsView$ListingViewMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$PrincipalsView$NoOp = {$: 0};
var $author$project$Pages$Main$PrincipalsView$RevealApiTokenModal = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Forms$PrincipalForms$createUserSettingsFormValues = function (_v0) {
	var userParameters = _v0.kd;
	var useNfc = _v0.ka;
	return {
		ka: useNfc,
		kd: A2($elm$core$List$map, $author$project$Forms$CommandParameterForm$createCommandParameterFormValues, userParameters)
	};
};
var $author$project$Forms$PrincipalForms$createPrincipalFormValues = function (principal) {
	return {
		gC: principal.gC,
		g_: principal.g_,
		hw: principal.hw,
		bZ: principal.bZ,
		cr: principal.cr,
		iY: principal.iY,
		iZ: principal.iZ,
		jy: $elm$core$String$fromInt(principal.jy),
		ke: $author$project$Forms$PrincipalForms$createUserSettingsFormValues(principal.ke)
	};
};
var $author$project$Api$EntityApi$deletePrincipalAssociation = $author$project$Api$EntityApi$deleteEntity($author$project$Api$ApiUrls$principalAssociationsUrl);
var $author$project$Api$EntityApi$deletePrincipalAssociationGroup = $author$project$Api$EntityApi$deleteEntity($author$project$Api$ApiUrls$principalAssociationGroupsUrl);
var $author$project$Pages$Main$PrincipalsView$insertPrincipalAssociationOutMsg = F2(
	function (repository, principalAssociation) {
		return $author$project$Pages$Main$OutMsg$UpdateRepository(
			_Utils_update(
				repository,
				{
					du: A2($author$project$Utils$RemoteDataUtils$insertToEntityDictWebData, repository.du, principalAssociation)
				}));
	});
var $author$project$Pages$Main$EntityListing$EntityListingFilters$SelectionFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$EntityListing$EntityListingFilters$entityTypeFilter = F2(
	function (filter, options) {
		return {
			bN: filter,
			bO: F2(
				function (_v0, _v1) {
					return false;
				}),
			c9: $author$project$Pages$Main$EntityListing$EntityListingFilters$SelectionFilter(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('', 'Kaikki tyypit'),
					options)),
			bZ: 'entity_type_filter'
		};
	});
var $author$project$Pages$Main$PrincipalsView$filterByPrincipalType = F2(
	function (filterValue, principal) {
		var requiredValue = function () {
			var _v0 = principal.iZ;
			if (!_v0.$) {
				return 'user';
			} else {
				return 'api_token';
			}
		}();
		return _Utils_eq(filterValue, requiredValue);
	});
var $author$project$Entity$PrincipalAssociation$getEmailOrClientId = function (principalAssociation) {
	var _v0 = principalAssociation.iZ;
	if (!_v0.$) {
		var email = _v0.a.d7;
		return email;
	} else {
		var clientId = _v0.a.fS;
		return clientId;
	}
};
var $author$project$Entity$PrincipalAssociation$getTypeAsString = function (principalAssociation) {
	var _v0 = principalAssociation.iZ;
	if (!_v0.$) {
		return 'Käyttäjä';
	} else {
		return 'Token';
	}
};
var $author$project$Pages$Main$PrincipalsView$getEntityTreeItemColumns = function (principal) {
	return _List_fromArray(
		[
			$author$project$Entity$PrincipalAssociation$getTypeAsString(principal),
			$elm$core$String$fromInt(principal.bZ),
			$author$project$Entity$PrincipalAssociation$getEmailOrClientId(principal),
			$author$project$Utils$StringUtils$firstLine(principal.gC)
		]);
};
var $author$project$Entity$PrincipalAssociation$getPrincipalId = function (principalAssociation) {
	var _v0 = principalAssociation.iY;
	if (!_v0.$) {
		var preparedPrincipalId = _v0.a.iV;
		return preparedPrincipalId;
	} else {
		var principalId = _v0.a.iX;
		return principalId;
	}
};
var $author$project$Pages$Main$PrincipalsView$listingViewConfig = {
	da: _List_fromArray(
		[
			A2(
			$author$project$Pages$Main$EntityListing$EntityListingFilters$entityTypeFilter,
			$author$project$Pages$Main$PrincipalsView$filterByPrincipalType,
			_List_fromArray(
				[
					_Utils_Tuple2('user', 'Käyttäjä'),
					_Utils_Tuple2('api_token', 'API-token')
				])),
			A2(
			$author$project$Pages$Main$EntityListing$EntityListingFilters$commonStringFilter,
			_List_fromArray(
				[
					$author$project$Entity$PrincipalAssociation$getEmailOrClientId,
					function ($) {
					return $.gC;
				},
					$author$project$Entity$PrincipalAssociation$getPrincipalId
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bZ;
					},
					$elm$core$String$fromInt),
					function ($) {
					return $.is;
				},
					function ($) {
					return $.gC;
				}
				]))
		]),
	dc: function ($) {
		return $.du;
	},
	eh: $author$project$Pages$Main$PrincipalsView$getEntityTreeItemColumns,
	ei: $author$project$Entity$GenericEntityGroup$getGenericEntityGroupListingFields,
	bQ: function ($) {
		return $.dt;
	}
};
var $author$project$Forms$CommonForms$createOptionalFormValues = F2(
	function (_default, maybeValues) {
		if (!maybeValues.$) {
			var innerValues = maybeValues.a;
			return {aX: innerValues, aY: true};
		} else {
			return {aX: _default, aY: false};
		}
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Entity$IdentityProvider$isInternalIdentityProvider = function (identityProvider) {
	var _v0 = identityProvider.j5;
	if (!_v0) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Entity$IdentityProvider$isExternalIdentityProvider = function (identityProvider) {
	return !$author$project$Entity$IdentityProvider$isInternalIdentityProvider(identityProvider);
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Forms$CreateNewPrincipalAssociationForm$makeNewPrincipalAssociationFormValues = function (identityProviders) {
	var defaultIdentityProviderId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.bZ;
			},
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				A2($elm_community$list_extra$List$Extra$find, $author$project$Entity$IdentityProvider$isExternalIdentityProvider, identityProviders),
				$elm$core$List$head(identityProviders))));
	return {
		hK: defaultIdentityProviderId,
		dq: A2($author$project$Forms$CommonForms$createOptionalFormValues, '', $elm$core$Maybe$Nothing),
		ag: 'user',
		bf: ''
	};
};
var $author$project$Pages$Main$PrincipalsView$onGotDeleteResult = F2(
	function (updateRepository, model) {
		return A2(
			$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
			function (id) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a2: $author$project$Pages$Main$PrincipalsView$Hidden}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						updateRepository(id)));
			},
			model);
	});
var $author$project$Pages$Main$PrincipalsView$CloseCurrentModal = {$: 2};
var $author$project$Pages$Main$PrincipalsView$MessageModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$PrincipalsView$ConfirmationModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo = F2(
	function (status, model) {
		var modal = function () {
			var _v1 = model.a2;
			switch (_v1.$) {
				case 1:
					var errorText = _v1.a.aq;
					var formModel = _v1.a.ee;
					return $author$project$Pages$Main$PrincipalsView$AddNewPrincipalAssociationModal(
						{
							aq: errorText,
							ee: A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel)
						});
				case 3:
					var config = _v1.a;
					return $author$project$Pages$Main$PrincipalsView$ConfirmationModal(
						_Utils_update(
							config,
							{eV: status}));
				default:
					return model.a2;
			}
		}();
		var editItemModel = function () {
			var _v0 = model.l;
			switch (_v0.$) {
				case 1:
					var formModel = _v0.a;
					return $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
						A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel));
				case 2:
					var formModel = _v0.a;
					return $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
						A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel));
				default:
					return $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing;
			}
		}();
		return _Utils_update(
			model,
			{l: editItemModel, a2: modal});
	});
var $author$project$Pages$Main$PrincipalsView$updateNewPrincipalModal = F2(
	function (func, model) {
		var modal = function () {
			var _v0 = model.a2;
			if (_v0.$ === 1) {
				var modalRec = _v0.a;
				return $author$project$Pages$Main$PrincipalsView$AddNewPrincipalAssociationModal(
					func(modalRec));
			} else {
				return model.a2;
			}
		}();
		return _Utils_update(
			model,
			{a2: modal});
	});
var $author$project$Pages$Main$PrincipalsView$onPostNewRegularUserAssociationOkResult = F3(
	function (repository, model, result) {
		var model_ = A2($author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$Idle, model);
		if (!result.$) {
			var userAlreadyExisted = result.a.kc;
			var principalAssociation = result.a.iW;
			var _v1 = userAlreadyExisted ? _Utils_Tuple2('Vanha käyttäjä yhdistettiin', 'Olemassa oleva käyttäjä yhdistettiin asiakkaaseen.') : _Utils_Tuple2('Uusi käyttäjä luotiin', 'Uusi käyttäjä luotiin ja yhdistettiin asiakkaaseen.');
			var messageTitle = _v1.a;
			var messageContent = _v1.b;
			return _Utils_Tuple3(
				_Utils_update(
					model_,
					{
						l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
							$author$project$Lib$Form$FormView$makeModel(
								$author$project$Forms$PrincipalForms$createPrincipalFormValues(principalAssociation))),
						a2: $author$project$Pages$Main$PrincipalsView$MessageModal(
							{fU: $author$project$Pages$Main$PrincipalsView$CloseCurrentModal, gc: messageContent, j_: messageTitle})
					}),
				$elm$core$Platform$Cmd$none,
				A2($author$project$Pages$Main$PrincipalsView$insertPrincipalAssociationOutMsg, repository, principalAssociation));
		} else {
			return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
				A2(
					$author$project$Pages$Main$PrincipalsView$updateNewPrincipalModal,
					function (modalState) {
						return _Utils_update(
							modalState,
							{aq: 'Käyttäjä on jo olemassa ja yhdistetty.'});
					},
					model));
		}
	});
var $author$project$Pages$Main$PrincipalsView$positionUpdatingConfig = {
	dc: function ($) {
		return $.du;
	},
	bQ: function ($) {
		return $.dt;
	},
	dz: F2(
		function (principals, repo) {
			return _Utils_update(
				repo,
				{
					du: $author$project$Lib$RemoteData$Success(principals)
				});
		}),
	dB: F2(
		function (groups, repo) {
			return _Utils_update(
				repo,
				{
					dt: $author$project$Lib$RemoteData$Success(groups)
				});
		})
};
var $author$project$Entity$PrincipalAssociation$ApiTokenWithSecret = F2(
	function (clientId, clientSecret) {
		return {fS: clientId, fT: clientSecret};
	});
var $author$project$Entity$PrincipalAssociation$CreateApiTokenAssociationResult = F2(
	function (association, token) {
		return {fr: association, j0: token};
	});
var $author$project$Decoding$PrincipalDecoding$createApiTokenAssociationResultDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Entity$PrincipalAssociation$CreateApiTokenAssociationResult,
	A2($elm$json$Json$Decode$field, 'principalAssociation', $author$project$Decoding$PrincipalDecoding$principalDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'token',
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Entity$PrincipalAssociation$ApiTokenWithSecret,
			A2($elm$json$Json$Decode$field, 'clientId', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'clientSecret', $elm$json$Json$Decode$string))));
var $author$project$Api$EntityApi$postApiTokenAssociation = F2(
	function (_v0, toMsg) {
		var selectedBranchKey = _v0.js;
		var url = $author$project$Api$ApiUrls$principalAssociationsUrl + '/apiToken';
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A3(
				$lukewestby$elm_http_builder$HttpBuilder$withHeader,
				$author$project$Api$ApiUrls$aavoBranchHeader,
				selectedBranchKey,
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					A2($author$project$Lib$CustomHttp$expectJsonCustom, toMsg, $author$project$Decoding$PrincipalDecoding$createApiTokenAssociationResultDecoder),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Api$EntityApi$postPrincipalAssociationGroup = A3($author$project$Api$EntityApi$postEntity, $author$project$Api$ApiUrls$principalAssociationGroupsUrl, $author$project$Entity$GenericEntityGroup$encodeGenericEntityGroup, $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder);
var $author$project$Entity$PrincipalAssociation$CreateUserSucceeded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Entity$PrincipalAssociation$TCreateUserSucceeded = F2(
	function (userAlreadyExisted, principalAssociation) {
		return {iW: principalAssociation, kc: userAlreadyExisted};
	});
var $author$project$Entity$PrincipalAssociation$UserAlreadyAssociated = {$: 1};
var $author$project$Decoding$PrincipalDecoding$createRegularPrincipalAssociationResultDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		var mapSuccessfulResult = function (userAlreadyExisted) {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Entity$PrincipalAssociation$CreateUserSucceeded,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Entity$PrincipalAssociation$TCreateUserSucceeded,
					$elm$json$Json$Decode$succeed(userAlreadyExisted),
					A2($elm$json$Json$Decode$field, 'association', $author$project$Decoding$PrincipalDecoding$principalDecoder)));
		};
		switch (type_) {
			case 'newUserCreated':
				return mapSuccessfulResult(false);
			case 'existingUserAssociated':
				return mapSuccessfulResult(true);
			case 'userAlreadyAssociated':
				return $elm$json$Json$Decode$succeed($author$project$Entity$PrincipalAssociation$UserAlreadyAssociated);
			default:
				return $elm$json$Json$Decode$fail('Unknown CreateRegularUserAssociationResult type ' + type_);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Encoding$PrincipalEncoding$encodePostRegularUserAssociationDto = function (dto) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(dto.d7)),
				_Utils_Tuple2(
				'identityProviderId',
				$elm$json$Json$Encode$string(dto.hK)),
				_Utils_Tuple2(
				'password',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$string, dto.dq))
			]));
};
var $author$project$Api$EntityApi$postRegularUserAssociation = function () {
	var url = $author$project$Api$ApiUrls$principalAssociationsUrl + '/user';
	return A3($author$project$Api$EntityApi$postEntity, url, $author$project$Encoding$PrincipalEncoding$encodePostRegularUserAssociationDto, $author$project$Decoding$PrincipalDecoding$createRegularPrincipalAssociationResultDecoder);
}();
var $author$project$Utils$TimeUtils$daysToSeconds = function (days) {
	return ((days * 60) * 60) * 24;
};
var $author$project$Encoding$PrincipalEncoding$encodeEnvironmentAssociation = function (environmentAssociation) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'environmentId',
				$elm$json$Json$Encode$int(environmentAssociation.g$)),
				_Utils_Tuple2(
				'roleId',
				$elm$json$Json$Encode$int(environmentAssociation.jj))
			]));
};
var $author$project$Encoding$PrincipalEncoding$encodePrincipalState = function (principalState) {
	return $elm$json$Json$Encode$object(
		function () {
			if (!principalState.$) {
				var preparedPrincipalId = principalState.a.iV;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('prepared')),
						_Utils_Tuple2(
						'preparedPrincipalId',
						$elm$json$Json$Encode$string(preparedPrincipalId))
					]);
			} else {
				var principalId = principalState.a.iX;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ready')),
						_Utils_Tuple2(
						'principalId',
						$elm$json$Json$Encode$string(principalId))
					]);
			}
		}());
};
var $author$project$Encoding$PrincipalEncoding$encodePrincipalType = function (principalType) {
	return $elm$json$Json$Encode$object(
		function () {
			if (!principalType.$) {
				var email = principalType.a.d7;
				var mfaEnabled = principalType.a.il;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('user')),
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(email)),
						_Utils_Tuple2(
						'mfaEnabled',
						$elm$json$Json$Encode$bool(mfaEnabled))
					]);
			} else {
				var clientId = principalType.a.fS;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('token')),
						_Utils_Tuple2(
						'tokenCredentials',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'clientId',
									$elm$json$Json$Encode$string(clientId))
								])))
					]);
			}
		}());
};
var $author$project$Encoding$PrincipalEncoding$encodeUserSettings = function (userSettings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userParameters',
				A2($elm$json$Json$Encode$list, $author$project$Encoding$CommandParameterEncoding$encodeCommandParameter, userSettings.kd)),
				_Utils_Tuple2(
				'useNfc',
				$elm$json$Json$Encode$bool(userSettings.ka))
			]));
};
var $author$project$Encoding$PrincipalEncoding$encodePrincipalAssociation = function (principal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'principalState',
				$author$project$Encoding$PrincipalEncoding$encodePrincipalState(principal.iY)),
				_Utils_Tuple2(
				'principalType',
				$author$project$Encoding$PrincipalEncoding$encodePrincipalType(principal.iZ)),
				_Utils_Tuple2(
				'sessionExpirationDurationSeconds',
				$elm$json$Json$Encode$int(
					$author$project$Utils$TimeUtils$daysToSeconds(principal.jy))),
				_Utils_Tuple2(
				'environmentAssociations',
				A2($elm$json$Json$Encode$list, $author$project$Encoding$PrincipalEncoding$encodeEnvironmentAssociation, principal.g_)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(principal.gC)),
				_Utils_Tuple2(
				'userSettings',
				$author$project$Encoding$PrincipalEncoding$encodeUserSettings(principal.ke)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(principal.bZ)),
				_Utils_Tuple2(
				'groupId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, principal.hw)),
				_Utils_Tuple2(
				'pos',
				$elm$json$Json$Encode$int(principal.cr))
			]));
};
var $author$project$Api$EntityApi$putPrincipalAssociation = F3(
	function (_v0, principalAssociation, toMsg) {
		var selectedBranchKey = _v0.js;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($author$project$Lib$CustomHttp$expectJsonCustom, toMsg, $author$project$Decoding$PrincipalDecoding$principalDecoder),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					$author$project$Api$ApiUrls$aavoBranchHeader,
					selectedBranchKey,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						$author$project$Encoding$PrincipalEncoding$encodePrincipalAssociation(principalAssociation),
						$lukewestby$elm_http_builder$HttpBuilder$put($author$project$Api$ApiUrls$principalAssociationsUrl)))));
	});
var $author$project$Api$EntityApi$savePrincipalAssociationGroupPosition = $author$project$Api$EntityApi$saveEntityPosition($author$project$Api$ApiUrls$principalAssociationGroupsUrl);
var $author$project$Api$EntityApi$savePrincipalAssociationPosition = $author$project$Api$EntityApi$saveEntityPosition($author$project$Api$ApiUrls$principalAssociationsUrl);
var $author$project$Pages$Main$PrincipalsView$showConfirmModal = F3(
	function (model, message, onConfirmed) {
		return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
			_Utils_update(
				model,
				{
					a2: $author$project$Pages$Main$PrincipalsView$ConfirmationModal(
						{fI: $author$project$Pages$Main$PrincipalsView$CloseCurrentModal, f6: onConfirmed, gc: message, eV: $author$project$Lib$Form$LoadStatus$Idle})
				}));
	});
var $author$project$Lib$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Pages$Main$PrincipalsView$handleListingViewOutMsg = F5(
	function (apiConfig, repository, model, cmd, outMsg) {
		var newMsg = function (msg) {
			return A3(
				$author$project$Pages$Main$SubViewUpdateUtils$andThen,
				A2($author$project$Pages$Main$PrincipalsView$update, apiConfig, repository),
				msg,
				_Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$NoOp));
		};
		switch (outMsg.$) {
			case 0:
				return _Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$NoOp);
			case 1:
				return _Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$BeginReloadAllEntities);
			case 2:
				var entity = outMsg.a;
				return newMsg(
					$author$project$Pages$Main$PrincipalsView$BeginEditPrincipal(entity));
			case 3:
				var group = outMsg.a;
				return newMsg(
					$author$project$Pages$Main$PrincipalsView$BeginEditGroup(group));
			case 4:
				var identityProviders = A2($author$project$Lib$RemoteData$withDefault, _List_Nil, repository.de);
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							a2: $author$project$Pages$Main$PrincipalsView$AddNewPrincipalAssociationModal(
								{
									aq: '',
									ee: $author$project$Lib$Form$FormView$makeModel(
										$author$project$Forms$CreateNewPrincipalAssociationForm$makeNewPrincipalAssociationFormValues(identityProviders))
								})
						}));
			case 5:
				return newMsg(
					$author$project$Pages$Main$PrincipalsView$BeginEditGroup(
						_Utils_update(
							$author$project$Entity$GenericEntityGroup$createNewGenericEntityGroup,
							{
								dp: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})));
			case 6:
				var principal = outMsg.a;
				var message = function () {
					var _v5 = principal.iZ;
					if (!_v5.$) {
						var email = _v5.a.d7;
						return 'Haluatko varmasti poistaa käyttäjän ' + (email + '?');
					} else {
						var clientId = _v5.a.fS;
						return 'Haluatko varmasti poistaa API-Tokenin ' + (clientId + '?');
					}
				}();
				return A3(
					$author$project$Pages$Main$PrincipalsView$showConfirmModal,
					model,
					message,
					$author$project$Pages$Main$PrincipalsView$BeginDeletePrincipal(principal));
			case 7:
				var group = outMsg.a;
				return A3(
					$author$project$Pages$Main$PrincipalsView$showConfirmModal,
					model,
					'Haluatko varmasti poistaa ryhmän ' + (group.is + '?'),
					$author$project$Pages$Main$PrincipalsView$BeginDeleteGroup(group));
			case 8:
				var principal = outMsg.a;
				var oldPos = outMsg.b.ad;
				var repo = A4(
					$author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove,
					$author$project$Pages$Main$PrincipalsView$positionUpdatingConfig,
					repository,
					oldPos,
					$author$project$Entity$Common$TEntity(principal));
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$andThen,
					A2($author$project$Pages$Main$PrincipalsView$update, apiConfig, repo),
					$author$project$Pages$Main$PrincipalsView$BeginSavePrincipal(principal),
					_Utils_Tuple3(
						model,
						A3(
							$author$project$Api$EntityApi$savePrincipalAssociationPosition,
							apiConfig,
							principal,
							$elm$core$Basics$always($author$project$Pages$Main$PrincipalsView$NoOp)),
						$author$project$Pages$Main$OutMsg$UpdateRepository(repo)));
			default:
				var group = outMsg.a;
				var oldPos = outMsg.b.ad;
				var repo = A4(
					$author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove,
					$author$project$Pages$Main$PrincipalsView$positionUpdatingConfig,
					repository,
					oldPos,
					$author$project$Entity$Common$TGroup(group));
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$andThen,
					A2($author$project$Pages$Main$PrincipalsView$update, apiConfig, repo),
					$author$project$Pages$Main$PrincipalsView$BeginSaveGroup(group),
					_Utils_Tuple3(
						model,
						A3(
							$author$project$Api$EntityApi$savePrincipalAssociationGroupPosition,
							apiConfig,
							group,
							$elm$core$Basics$always($author$project$Pages$Main$PrincipalsView$NoOp)),
						$author$project$Pages$Main$OutMsg$UpdateRepository(repo)));
		}
	});
var $author$project$Pages$Main$PrincipalsView$update = F4(
	function (apiConfig, repository, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$OutMsg$NoOp);
			case 1:
				var listingViewMsg = msg.a;
				var _v1 = A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$update, $author$project$Pages$Main$PrincipalsView$listingViewConfig, repository, listingViewMsg, model.K);
				var listingViewModel = _v1.a;
				var listingViewCmd = _v1.b;
				var listingViewOutMsg = _v1.c;
				return A5(
					$author$project$Pages$Main$PrincipalsView$handleListingViewOutMsg,
					apiConfig,
					repository,
					_Utils_update(
						model,
						{K: listingViewModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Main$PrincipalsView$ListingViewMsg, listingViewCmd),
					listingViewOutMsg);
			case 4:
				var principal = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
								$author$project$Lib$Form$FormView$makeModel(
									$author$project$Forms$PrincipalForms$createPrincipalFormValues(principal))),
							a2: $author$project$Pages$Main$PrincipalsView$Hidden
						}));
			case 5:
				var group = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							l: $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
								$author$project$Lib$Form$FormView$makeModel(group))
						}));
			case 2:
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{a2: $author$project$Pages$Main$PrincipalsView$Hidden}));
			case 6:
				var newValues = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(newValues)
						}));
			case 7:
				var newValues = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							l: $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(newValues)
						}));
			case 8:
				var newFormModel = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					A2(
						$author$project$Pages$Main$PrincipalsView$updateNewPrincipalModal,
						function (modalState) {
							return _Utils_update(
								modalState,
								{ee: newFormModel});
						},
						model));
			case 9:
				var principalType = msg.a.iZ;
				var identityProviderId = msg.a.hK;
				var password = msg.a.dq;
				var cmd = function () {
					if (!principalType.$) {
						var email = principalType.a.d7;
						return A3(
							$author$project$Api$EntityApi$postRegularUserAssociation,
							apiConfig,
							{d7: email, hK: identityProviderId, dq: password},
							$author$project$Pages$Main$PrincipalsView$GotPostNewRegularUserAssociation);
					} else {
						return A2($author$project$Api$EntityApi$postApiTokenAssociation, apiConfig, $author$project$Pages$Main$PrincipalsView$GotPostNewApiTokenAssociation);
					}
				}();
				return _Utils_Tuple3(
					A2($author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
					cmd,
					$author$project$Pages$Main$OutMsg$NoOp);
			case 3:
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{l: $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing}));
			case 10:
				var principalAssociation = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
					A3($author$project$Api$EntityApi$putPrincipalAssociation, apiConfig, principalAssociation, $author$project$Pages$Main$PrincipalsView$GotPutPrincipalAssociation),
					$author$project$Pages$Main$OutMsg$NoOp);
			case 11:
				var group = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
					A3($author$project$Api$EntityApi$postPrincipalAssociationGroup, apiConfig, group, $author$project$Pages$Main$PrincipalsView$GotPostGroup),
					$author$project$Pages$Main$OutMsg$NoOp);
			case 12:
				var principal = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
					A3($author$project$Api$EntityApi$deletePrincipalAssociation, apiConfig, principal.bZ, $author$project$Pages$Main$PrincipalsView$GotDeletePrincipal),
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete, $author$project$Pages$Main$PrincipalsView$positionUpdatingConfig, repository, principal.cr)));
			case 13:
				var group = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Pages$Main$PrincipalsView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
					A3($author$project$Api$EntityApi$deletePrincipalAssociationGroup, apiConfig, group.bZ, $author$project$Pages$Main$PrincipalsView$GotDeleteGroup),
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete, $author$project$Pages$Main$PrincipalsView$positionUpdatingConfig, repository, group.cr)));
			case 18:
				var result = msg.a;
				return A3(
					$author$project$Pages$Main$PrincipalsView$onGotDeleteResult,
					function (id) {
						return _Utils_update(
							repository,
							{
								du: A2($author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData, repository.du, id)
							});
					},
					model,
					result);
			case 19:
				var result = msg.a;
				return A3(
					$author$project$Pages$Main$PrincipalsView$onGotDeleteResult,
					function (id) {
						return _Utils_update(
							repository,
							{
								dt: A2($author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData, repository.dt, id)
							});
					},
					model,
					result);
			case 17:
				var httpResult = msg.a;
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
					function (principal) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									l: A2(
										$author$project$Pages$Main$EditEntityOrGroupModel$updateKeepingMode,
										model.l,
										$author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
											$author$project$Lib$Form$FormView$makeModel(
												$author$project$Forms$PrincipalForms$createPrincipalFormValues(principal))))
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Pages$Main$PrincipalsView$insertPrincipalAssociationOutMsg, repository, principal));
					},
					model,
					httpResult);
			case 14:
				var httpResult = msg.a;
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
					A2($author$project$Pages$Main$PrincipalsView$onPostNewRegularUserAssociationOkResult, repository, model),
					model,
					httpResult);
			case 15:
				var httpResult = msg.a;
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
					function (_v3) {
						var token = _v3.j0;
						var association = _v3.fr;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a2: A2($author$project$Pages$Main$PrincipalsView$RevealApiTokenModal, token, association)
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Pages$Main$PrincipalsView$insertPrincipalAssociationOutMsg, repository, association));
					},
					model,
					httpResult);
			default:
				var httpResult = msg.a;
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
					function (group) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									l: A2(
										$author$project$Pages$Main$EditEntityOrGroupModel$updateKeepingMode,
										model.l,
										$author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
											$author$project$Lib$Form$FormView$makeModel(group)))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Main$OutMsg$UpdateRepository(
								_Utils_update(
									repository,
									{
										dt: A2($author$project$Utils$RemoteDataUtils$insertToEntityDictWebData, repository.dt, group)
									})));
					},
					model,
					httpResult);
		}
	});
var $author$project$Pages$Main$RolesView$BeginDeleteGroup = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Main$RolesView$BeginDeleteRole = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Main$RolesView$BeginEditGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Main$RolesView$BeginEditRole = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$RolesView$BeginSaveGroup = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Main$RolesView$BeginSaveRole = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Main$RolesView$GotDeleteGroup = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Main$RolesView$GotDeleteRole = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Main$RolesView$GotPostGroup = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Main$RolesView$GotPostRole = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Main$RolesView$ListingViewMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$RolesView$NoOp = {$: 0};
var $author$project$Entity$Role$createNewRole = {fo: _List_Nil, fp: $elm$core$Maybe$Nothing, f$: _List_Nil, gx: $elm$core$Maybe$Nothing, gC: '', hw: $elm$core$Maybe$Nothing, bZ: $author$project$Entity$Common$notPersistedId, hH: $elm$core$Maybe$Nothing, hO: _List_Nil, hY: false, is: '', eB: _List_Nil, cr: $author$project$Entity$Common$lastPosition, jz: _List_Nil, kj: _List_Nil};
var $author$project$Forms$EntitySelectFormList$EntitySelectFormListValues = function (selectedEntities) {
	return {ah: selectedEntities};
};
var $author$project$Forms$EntitySelectFormList$SelectEntityFormValues = function (id) {
	return {bZ: id};
};
var $author$project$Forms$EntitySelectFormList$createEntitySelectFormListValues = function (selectedIds) {
	return $author$project$Forms$EntitySelectFormList$EntitySelectFormListValues(
		A2($elm$core$List$map, $author$project$Forms$EntitySelectFormList$SelectEntityFormValues, selectedIds));
};
var $author$project$Forms$RoleForms$ViewAssociationFormValues = F3(
	function (viewId, showDirectly, permissionsValues) {
		return {cq: permissionsValues, jD: showDirectly, ki: viewId};
	});
var $author$project$Forms$RoleForms$createViewAssociationFormValues = function (viewAssociation) {
	return A3(
		$author$project$Forms$RoleForms$ViewAssociationFormValues,
		viewAssociation.ki,
		viewAssociation.jD,
		{aO: viewAssociation.eB.go.gT});
};
var $author$project$Forms$RoleForms$createRoleFormValues = function (role) {
	return {
		bv: $author$project$Forms$EntitySelectFormList$createEntitySelectFormListValues(role.fo),
		fp: role.fp,
		bE: $author$project$Forms$EntitySelectFormList$createEntitySelectFormListValues(role.f$),
		gx: A2($elm$core$Maybe$withDefault, $author$project$Entity$Common$nonExistentId, role.gx),
		gC: role.gC,
		hw: role.hw,
		bZ: role.bZ,
		hH: role.hH,
		b_: $author$project$Forms$EntitySelectFormList$createEntitySelectFormListValues(role.hO),
		hY: role.hY,
		is: role.is,
		cp: A2($elm$core$String$join, ',', role.eB),
		cr: role.cr,
		cI: $author$project$Forms$EntitySelectFormList$createEntitySelectFormListValues(role.jz),
		bg: A2($elm$core$List$map, $author$project$Forms$RoleForms$createViewAssociationFormValues, role.kj)
	};
};
var $author$project$Api$EntityApi$deleteRole = $author$project$Api$EntityApi$deleteEntity($author$project$Api$ApiUrls$rolesUrl);
var $author$project$Api$EntityApi$deleteRoleGroup = $author$project$Api$EntityApi$deleteEntity($author$project$Api$ApiUrls$roleGroupsUrl);
var $author$project$Pages$Main$RolesView$getEntityTreeItemColumns = function (role) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$core$String$fromInt(role.bZ),
				role.is,
				$author$project$Utils$StringUtils$firstLine(role.gC)
			]),
		_Utils_ap(
			$author$project$Pages$Main$EntityListing$ListingViewUtils$aproProjectIdColumns(role),
			$author$project$Pages$Main$EntityListing$ListingViewUtils$idAnchorColumns(role)));
};
var $author$project$Pages$Main$RolesView$listingViewConfig = {
	da: _List_fromArray(
		[
			A2(
			$author$project$Pages$Main$EntityListing$EntityListingFilters$commonStringFilter,
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bZ;
					},
					$elm$core$String$fromInt),
					function ($) {
					return $.is;
				},
					function ($) {
					return $.gC;
				}
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bZ;
					},
					$elm$core$String$fromInt),
					function ($) {
					return $.is;
				},
					function ($) {
					return $.gC;
				}
				]))
		]),
	dc: function ($) {
		return $.eN;
	},
	eh: $author$project$Pages$Main$RolesView$getEntityTreeItemColumns,
	ei: $author$project$Entity$GenericEntityGroup$getGenericEntityGroupListingFields,
	bQ: function ($) {
		return $.dy;
	}
};
var $author$project$Pages$Main$RolesView$onGotDelete = F2(
	function (updateRepository, model) {
		return A2(
			$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
			function (id) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a2: $author$project$Pages$Main$RolesView$Hidden}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						updateRepository(id)));
			},
			model);
	});
var $author$project$Pages$Main$RolesView$onGotPostResult = F2(
	function (_v0, model) {
		var makeNewEditModel = _v0.di;
		var updateRepository = _v0.dL;
		return A2(
			$author$project$Pages$Main$SubViewUpdateUtils$handleHttpResult,
			function (role) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							l: A2(
								$author$project$Pages$Main$EditEntityOrGroupModel$updateKeepingMode,
								model.l,
								makeNewEditModel(role))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Main$OutMsg$UpdateRepository(
						updateRepository(role)));
			},
			model);
	});
var $author$project$Pages$Main$RolesView$positionUpdatingConfig = {
	dc: function ($) {
		return $.eN;
	},
	bQ: function ($) {
		return $.dy;
	},
	dz: F2(
		function (roles, repo) {
			return _Utils_update(
				repo,
				{
					eN: $author$project$Lib$RemoteData$Success(roles)
				});
		}),
	dB: F2(
		function (groups, repo) {
			return _Utils_update(
				repo,
				{
					dy: $author$project$Lib$RemoteData$Success(groups)
				});
		})
};
var $author$project$Encoding$RoleEncoding$encodeViewPermissions = function (permissions) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dataViewPermissions',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'editingEnabled',
							$elm$json$Json$Encode$bool(permissions.go.gT))
						])))
			]));
};
var $author$project$Encoding$RoleEncoding$encodeViewAssociation = function (viewAssociation) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'viewId',
				$elm$json$Json$Encode$int(viewAssociation.ki)),
				_Utils_Tuple2(
				'showDirectly',
				$elm$json$Json$Encode$bool(viewAssociation.jD)),
				_Utils_Tuple2(
				'permissions',
				$author$project$Encoding$RoleEncoding$encodeViewPermissions(viewAssociation.eB))
			]));
};
var $author$project$Encoding$RoleEncoding$encodeRole = function (role) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(role.is)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(role.gC)),
				_Utils_Tuple2(
				'isUserRole',
				$elm$json$Json$Encode$bool(role.hY)),
				_Utils_Tuple2(
				'views',
				A2($elm$json$Json$Encode$list, $author$project$Encoding$RoleEncoding$encodeViewAssociation, role.kj)),
				_Utils_Tuple2(
				'defaultViewId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, role.gx)),
				_Utils_Tuple2(
				'commandIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, role.f$)),
				_Utils_Tuple2(
				'includedRoleIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, role.hO)),
				_Utils_Tuple2(
				'permissions',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, role.eB)),
				_Utils_Tuple2(
				'settingsViewComponentCommandIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, role.jz)),
				_Utils_Tuple2(
				'appBarViewComponentCommandIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, role.fo)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(role.bZ)),
				_Utils_Tuple2(
				'groupId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, role.hw)),
				_Utils_Tuple2(
				'pos',
				$elm$json$Json$Encode$int(role.cr)),
				_Utils_Tuple2(
				'aproProjectId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, role.fp)),
				_Utils_Tuple2(
				'idAnchor',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$string, role.hH))
			]));
};
var $author$project$Api$EntityApi$postRole = A3($author$project$Api$EntityApi$postEntity, $author$project$Api$ApiUrls$rolesUrl, $author$project$Encoding$RoleEncoding$encodeRole, $author$project$Decoding$RoleDecoding$roleDecoder);
var $author$project$Api$EntityApi$postRoleGroup = A3($author$project$Api$EntityApi$postEntity, $author$project$Api$ApiUrls$roleGroupsUrl, $author$project$Entity$GenericEntityGroup$encodeGenericEntityGroup, $author$project$Entity$GenericEntityGroup$genericEntityGroupDecoder);
var $author$project$Api$EntityApi$saveRoleGroupPosition = $author$project$Api$EntityApi$saveEntityPosition($author$project$Api$ApiUrls$roleGroupsUrl);
var $author$project$Api$EntityApi$saveRolePosition = $author$project$Api$EntityApi$saveEntityPosition($author$project$Api$ApiUrls$rolesUrl);
var $author$project$Pages$Main$RolesView$Confirm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Main$RolesView$setCurrentViewLoadStatusTo = F2(
	function (status, model) {
		var modal = function () {
			var _v1 = model.a2;
			if (_v1.$ === 2) {
				var config = _v1.a;
				return $author$project$Pages$Main$RolesView$Confirm(
					_Utils_update(
						config,
						{eV: status}));
			} else {
				return model.a2;
			}
		}();
		var editItemModel = function () {
			var _v0 = model.l;
			switch (_v0.$) {
				case 1:
					var formModel = _v0.a;
					return $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
						A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel));
				case 2:
					var formModel = _v0.a;
					return $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
						A2($author$project$Lib$Form$FormView$setStatusTo, status, formModel));
				default:
					return $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing;
			}
		}();
		return _Utils_update(
			model,
			{l: editItemModel, a2: modal});
	});
var $author$project$Pages$Main$RolesView$CloseCurrentModal = {$: 2};
var $author$project$Pages$Main$RolesView$showConfirmModal = F3(
	function (model, message, onConfirmed) {
		return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
			_Utils_update(
				model,
				{
					a2: $author$project$Pages$Main$RolesView$Confirm(
						{fI: $author$project$Pages$Main$RolesView$CloseCurrentModal, f6: onConfirmed, gc: message, eV: $author$project$Lib$Form$LoadStatus$Idle})
				}));
	});
var $author$project$Pages$Main$RolesView$handleListingViewOutMsg = F5(
	function (apiConfig, repository, model, cmd, outMsg) {
		var newMsg = function (msg) {
			return A3(
				$author$project$Pages$Main$SubViewUpdateUtils$andThen,
				A2($author$project$Pages$Main$RolesView$update, apiConfig, repository),
				msg,
				_Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$NoOp));
		};
		switch (outMsg.$) {
			case 0:
				return _Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$NoOp);
			case 1:
				return _Utils_Tuple3(model, cmd, $author$project$Pages$Main$OutMsg$BeginReloadAllEntities);
			case 2:
				var entity = outMsg.a;
				return newMsg(
					$author$project$Pages$Main$RolesView$BeginEditRole(entity));
			case 3:
				var group = outMsg.a;
				return newMsg(
					$author$project$Pages$Main$RolesView$BeginEditGroup(group));
			case 4:
				return newMsg(
					$author$project$Pages$Main$RolesView$BeginEditRole(
						_Utils_update(
							$author$project$Entity$Role$createNewRole,
							{
								hw: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})));
			case 5:
				return newMsg(
					$author$project$Pages$Main$RolesView$BeginEditGroup(
						_Utils_update(
							$author$project$Entity$GenericEntityGroup$createNewGenericEntityGroup,
							{
								dp: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})));
			case 6:
				var role = outMsg.a;
				return A3(
					$author$project$Pages$Main$RolesView$showConfirmModal,
					model,
					'Haluatko varmasti poistaa yhteyden ' + (role.is + '?'),
					$author$project$Pages$Main$RolesView$BeginDeleteRole(role));
			case 7:
				var group = outMsg.a;
				return A3(
					$author$project$Pages$Main$RolesView$showConfirmModal,
					model,
					'Haluatko varmasti poistaa ryhmän ' + (group.is + '?'),
					$author$project$Pages$Main$RolesView$BeginDeleteGroup(group));
			case 8:
				var role = outMsg.a;
				var oldPos = outMsg.b.ad;
				var repo = A4(
					$author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove,
					$author$project$Pages$Main$RolesView$positionUpdatingConfig,
					repository,
					oldPos,
					$author$project$Entity$Common$TEntity(role));
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$andThen,
					A2($author$project$Pages$Main$RolesView$update, apiConfig, repo),
					$author$project$Pages$Main$RolesView$BeginSaveRole(role),
					_Utils_Tuple3(
						model,
						A3(
							$author$project$Api$EntityApi$saveRolePosition,
							apiConfig,
							role,
							$elm$core$Basics$always($author$project$Pages$Main$RolesView$NoOp)),
						$author$project$Pages$Main$OutMsg$UpdateRepository(repo)));
			default:
				var group = outMsg.a;
				var oldPos = outMsg.b.ad;
				var repo = A4(
					$author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterMove,
					$author$project$Pages$Main$RolesView$positionUpdatingConfig,
					repository,
					oldPos,
					$author$project$Entity$Common$TGroup(group));
				return A3(
					$author$project$Pages$Main$SubViewUpdateUtils$andThen,
					A2($author$project$Pages$Main$RolesView$update, apiConfig, repo),
					$author$project$Pages$Main$RolesView$BeginSaveGroup(group),
					_Utils_Tuple3(
						model,
						A3(
							$author$project$Api$EntityApi$saveRoleGroupPosition,
							apiConfig,
							group,
							$elm$core$Basics$always($author$project$Pages$Main$RolesView$NoOp)),
						$author$project$Pages$Main$OutMsg$UpdateRepository(repo)));
		}
	});
var $author$project$Pages$Main$RolesView$update = F4(
	function (apiConfig, repository, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Main$OutMsg$NoOp);
				case 1:
					var listingViewMsg = msg.a;
					var _v1 = A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$update, $author$project$Pages$Main$RolesView$listingViewConfig, repository, listingViewMsg, model.K);
					var listingViewModel = _v1.a;
					var listingViewCmd = _v1.b;
					var listingViewOutMsg = _v1.c;
					return A5(
						$author$project$Pages$Main$RolesView$handleListingViewOutMsg,
						apiConfig,
						repository,
						_Utils_update(
							model,
							{K: listingViewModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Main$RolesView$ListingViewMsg, listingViewCmd),
						listingViewOutMsg);
				case 4:
					var role = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(
									$author$project$Lib$Form$FormView$makeModel(
										$author$project$Forms$RoleForms$createRoleFormValues(role)))
							}));
				case 5:
					var group = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(
									$author$project$Lib$Form$FormView$makeModel(group))
							}));
				case 2:
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{a2: $author$project$Pages$Main$RolesView$Hidden}));
				case 6:
					var newValues = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel(newValues)
							}));
				case 7:
					var newValues = msg.a;
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								l: $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel(newValues)
							}));
				case 8:
					var role = msg.a;
					var $temp$apiConfig = apiConfig,
						$temp$repository = repository,
						$temp$msg = $author$project$Pages$Main$RolesView$BeginEditRole(
						_Utils_update(
							role,
							{
								hw: $author$project$Pages$Main$EntityListing$GenericEntityListingView$getFocusedGroupId(model.K)
							})),
						$temp$model = _Utils_update(
						model,
						{a2: $author$project$Pages$Main$RolesView$Hidden});
					apiConfig = $temp$apiConfig;
					repository = $temp$repository;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 3:
					return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{l: $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing}));
				case 9:
					var role = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$RolesView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$postRole, apiConfig, role, $author$project$Pages$Main$RolesView$GotPostRole),
						$author$project$Pages$Main$OutMsg$NoOp);
				case 10:
					var group = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$RolesView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$postRoleGroup, apiConfig, group, $author$project$Pages$Main$RolesView$GotPostGroup),
						$author$project$Pages$Main$OutMsg$UpdateRepository(
							A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete, $author$project$Pages$Main$RolesView$positionUpdatingConfig, repository, group.cr)));
				case 11:
					var role = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$RolesView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$deleteRole, apiConfig, role.bZ, $author$project$Pages$Main$RolesView$GotDeleteRole),
						$author$project$Pages$Main$OutMsg$UpdateRepository(
							A3($author$project$Pages$Main$EntityListing$PositionUpdating$updatePositionsAfterDelete, $author$project$Pages$Main$RolesView$positionUpdatingConfig, repository, role.cr)));
				case 12:
					var group = msg.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Main$RolesView$setCurrentViewLoadStatusTo, $author$project$Lib$Form$LoadStatus$InProgress, model),
						A3($author$project$Api$EntityApi$deleteRoleGroup, apiConfig, group.bZ, $author$project$Pages$Main$RolesView$GotDeleteGroup),
						$author$project$Pages$Main$OutMsg$NoOp);
				case 15:
					var result = msg.a;
					return A3(
						$author$project$Pages$Main$RolesView$onGotPostResult,
						{
							di: A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Pages$Main$EditEntityOrGroupModel$EditEntityModel, $author$project$Lib$Form$FormView$makeModel),
								$author$project$Forms$RoleForms$createRoleFormValues),
							dL: function (role) {
								return _Utils_update(
									repository,
									{
										eN: A2($author$project$Utils$RemoteDataUtils$insertToEntityDictWebData, repository.eN, role)
									});
							}
						},
						model,
						result);
				case 16:
					var result = msg.a;
					return A3(
						$author$project$Pages$Main$RolesView$onGotPostResult,
						{
							di: A2($elm$core$Basics$composeL, $author$project$Pages$Main$EditEntityOrGroupModel$EditGroupModel, $author$project$Lib$Form$FormView$makeModel),
							dL: function (group) {
								return _Utils_update(
									repository,
									{
										dy: A2($author$project$Utils$RemoteDataUtils$insertToEntityDictWebData, repository.dy, group)
									});
							}
						},
						model,
						result);
				case 13:
					var httpResult = msg.a;
					return A3(
						$author$project$Pages$Main$RolesView$onGotDelete,
						function (id) {
							return _Utils_update(
								repository,
								{
									eN: A2($author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData, repository.eN, id)
								});
						},
						model,
						httpResult);
				default:
					var httpResult = msg.a;
					return A3(
						$author$project$Pages$Main$RolesView$onGotDelete,
						function (id) {
							return _Utils_update(
								repository,
								{
									dy: A2($author$project$Utils$RemoteDataUtils$deleteFromEntityDictWebData, repository.dy, id)
								});
						},
						model,
						httpResult);
			}
		}
	});
var $author$project$Pages$Main$TenantSettingsView$GotTenantSettings = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Main$TenantSettingsView$createTenantSettingsFormValues = function (settings) {
	return {
		gi: A2($elm$core$Maybe$withDefault, $author$project$Entity$Common$nonExistentId, settings.gi),
		gj: A2($elm$core$Maybe$withDefault, $author$project$Entity$Common$nonExistentId, settings.gj),
		gB: settings.gB,
		gY: settings.gY,
		hC: settings.hC,
		h6: settings.h6
	};
};
var $author$project$Entity$TenantSettings$TenantSettings = F6(
	function (delimitersString, cronCommandRunnerRoleId, cronCommandRunnerEnvironmentId, enableMfaForNewUsers, logSuccessfulExecutions, hooks) {
		return {gi: cronCommandRunnerEnvironmentId, gj: cronCommandRunnerRoleId, gB: delimitersString, gY: enableMfaForNewUsers, hC: hooks, h6: logSuccessfulExecutions};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Entity$TenantSettings$TenantHook = F3(
	function (hookType, commandId, environmentId) {
		return {f_: commandId, g$: environmentId, hB: hookType};
	});
var $author$project$Decoding$TenantSettingsDecoding$tenantHookDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'environmentId',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'commandId',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hookType',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Entity$TenantSettings$TenantHook))));
var $author$project$Decoding$TenantSettingsDecoding$tenantSettingsDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Entity$TenantSettings$TenantSettings,
	A2($elm$json$Json$Decode$field, 'delimitersString', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'cronCommandRunnerRoleId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'cronCommandRunnerEnvironmentId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'enableMfaForNewUsers', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'logSuccessfulExecutions', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'hooks',
		$elm$json$Json$Decode$list($author$project$Decoding$TenantSettingsDecoding$tenantHookDecoder)));
var $author$project$Api$ApiUrls$tenantSettingsUrl = $author$project$Api$ApiUrls$adminUrlRoot + '/tenantSettings';
var $author$project$Api$EntityApi$getTenantSettings = F2(
	function (_v0, toMsg) {
		var selectedBranchKey = _v0.js;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A3(
				$lukewestby$elm_http_builder$HttpBuilder$withHeader,
				$author$project$Api$ApiUrls$aavoBranchHeader,
				selectedBranchKey,
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					A2($author$project$Lib$CustomHttp$expectJsonCustom, toMsg, $author$project$Decoding$TenantSettingsDecoding$tenantSettingsDecoder),
					$lukewestby$elm_http_builder$HttpBuilder$get($author$project$Api$ApiUrls$tenantSettingsUrl))));
	});
var $author$project$Encoding$TenantSettingsEncoding$encodeTenantHook = function (tenantHook) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hookType',
				$elm$json$Json$Encode$string(tenantHook.hB)),
				_Utils_Tuple2(
				'commandId',
				$elm$json$Json$Encode$int(tenantHook.f_)),
				_Utils_Tuple2(
				'environmentId',
				$elm$json$Json$Encode$int(tenantHook.g$))
			]));
};
var $author$project$Encoding$TenantSettingsEncoding$encodeTenantSettings = function (tenantSettings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'delimitersString',
				$elm$json$Json$Encode$string(tenantSettings.gB)),
				_Utils_Tuple2(
				'cronCommandRunnerRoleId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, tenantSettings.gj)),
				_Utils_Tuple2(
				'cronCommandRunnerEnvironmentId',
				A2($author$project$Encoding$Utils$encodeMaybe, $elm$json$Json$Encode$int, tenantSettings.gi)),
				_Utils_Tuple2(
				'enableMfaForNewUsers',
				$elm$json$Json$Encode$bool(tenantSettings.gY)),
				_Utils_Tuple2(
				'logSuccessfulExecutions',
				$elm$json$Json$Encode$bool(tenantSettings.h6)),
				_Utils_Tuple2(
				'hooks',
				A2($elm$json$Json$Encode$list, $author$project$Encoding$TenantSettingsEncoding$encodeTenantHook, tenantSettings.hC))
			]));
};
var $author$project$Api$EntityApi$postTenantSettings = F3(
	function (_v0, tenantSettings, toMsg) {
		var selectedBranchKey = _v0.js;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($author$project$Lib$CustomHttp$expectJsonCustom, toMsg, $author$project$Decoding$TenantSettingsDecoding$tenantSettingsDecoder),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					$author$project$Api$ApiUrls$aavoBranchHeader,
					selectedBranchKey,
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						$author$project$Encoding$TenantSettingsEncoding$encodeTenantSettings(tenantSettings),
						$lukewestby$elm_http_builder$HttpBuilder$post($author$project$Api$ApiUrls$tenantSettingsUrl)))));
	});
var $author$project$Pages$Main$TenantSettingsView$update = F4(
	function (apiConfig, _v0, msg, model) {
		switch (msg.$) {
			case 0:
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(model);
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$EntityApi$getTenantSettings, apiConfig, $author$project$Pages$Main$TenantSettingsView$GotTenantSettings),
					$author$project$Pages$Main$OutMsg$NoOp);
			case 2:
				var result = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							ee: A2(
								$author$project$Lib$RemoteData$map,
								A2($elm$core$Basics$composeL, $author$project$Lib$Form$FormView$makeModel, $author$project$Pages$Main$TenantSettingsView$createTenantSettingsFormValues),
								$author$project$Lib$RemoteData$fromResult(result))
						}));
			case 3:
				var formModel = msg.a;
				return $author$project$Pages$Main$SubViewUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							ee: $author$project$Lib$RemoteData$Success(formModel)
						}));
			default:
				var tenantSettings = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$EntityApi$postTenantSettings, apiConfig, tenantSettings, $author$project$Pages$Main$TenantSettingsView$GotTenantSettings),
					$author$project$Pages$Main$OutMsg$NoOp);
		}
	});
var $author$project$Pages$Main$MainPage$updateRepository = F2(
	function (updater, model) {
		return $author$project$Pages$PageUpdateUtils$withoutActions(
			_Utils_update(
				model,
				{
					A: updater(model.A)
				}));
	});
var $author$project$AppMsg$NavigateTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Routes$allMainPageRoutes = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Authentication$UserPermissions$requiredPermissionForRoute = function (mainPageRoute) {
	switch (mainPageRoute) {
		case 4:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Just(13);
		case 1:
			return $elm$core$Maybe$Just(11);
		case 2:
			return $elm$core$Maybe$Just(14);
		default:
			return $elm$core$Maybe$Just(15);
	}
};
var $author$project$Authentication$UserPermissions$hasPermissionToRoute = F2(
	function (userPermissions, mainPageRoute) {
		var _v0 = $author$project$Authentication$UserPermissions$requiredPermissionForRoute(mainPageRoute);
		if (_v0.$ === 1) {
			return true;
		} else {
			var requiredPermission = _v0.a;
			return A2($elm$core$List$member, requiredPermission, userPermissions);
		}
	});
var $author$project$Authentication$UserPermissions$getFirstValidMainPageRoute = function (userPermissions) {
	return A2(
		$elm$core$Maybe$withDefault,
		4,
		A2(
			$elm_community$list_extra$List$Extra$find,
			$author$project$Authentication$UserPermissions$hasPermissionToRoute(userPermissions),
			$author$project$Routes$allMainPageRoutes));
};
var $author$project$Pages$Main$MainPage$validateCurrentRoute = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var appMsg = _v0.c;
	var _v1 = model.S;
	if (_v1.$ === 3) {
		var userPermissions = _v1.a;
		return A2($author$project$Authentication$UserPermissions$hasPermissionToRoute, userPermissions, model.aC) ? _Utils_Tuple3(model, cmd, appMsg) : _Utils_Tuple3(
			model,
			cmd,
			$author$project$AppMsg$NavigateTo(
				$author$project$Routes$MainPage(
					$author$project$Authentication$UserPermissions$getFirstValidMainPageRoute(userPermissions))));
	} else {
		return _Utils_Tuple3(model, cmd, appMsg);
	}
};
var $author$project$Pages$Main$MainPage$update = F2(
	function (msg, model) {
		var handleGotWebData = F2(
			function (updateRepo, result) {
				return A2(
					$author$project$Pages$Main$MainPage$updateRepository,
					function (repo) {
						return A2(
							updateRepo,
							repo,
							$author$project$Lib$RemoteData$fromResult(result));
					},
					model);
			});
		var emptyReturn = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$AppMsg$NoOp);
		var apiConfig = $author$project$Pages$Main$MainPage$getApiConfig(model);
		switch (msg.$) {
			case 0:
				return emptyReturn;
			case 1:
				var pageMsg = msg.a;
				return A2($author$project$Pages$Main$MainPage$updateOnOutMsg, pageMsg, model);
			case 2:
				var appMsg = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, appMsg);
			case 3:
				var route = msg.a;
				return $author$project$Pages$Main$MainPage$validateCurrentRoute(
					$author$project$Pages$PageUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{aC: route})));
			case 4:
				var branchKey = msg.a;
				return A3(
					$author$project$Pages$PageUpdateUtils$andThen,
					$author$project$Pages$Main$MainPage$update,
					$author$project$Pages$Main$MainPage$OutMsg($author$project$Pages$Main$OutMsg$BeginReloadAllEntities),
					_Utils_Tuple3(
						_Utils_update(
							model,
							{js: branchKey}),
						$author$project$Ports$selectedBranchChanged(branchKey),
						$author$project$AppMsg$NoOp));
			case 5:
				var rolesMsg = msg.a;
				return A3(
					$author$project$Pages$Main$MainPage$updateOnSubViewMsg,
					{
						at: function ($) {
							return $.a7;
						},
						ay: $author$project$Pages$Main$MainPage$RolesMsg,
						aD: F2(
							function (subModel, model_) {
								return _Utils_update(
									model_,
									{a7: subModel});
							}),
						dK: $author$project$Pages$Main$RolesView$update
					},
					model,
					rolesMsg);
			case 6:
				var environmentsMsg = msg.a;
				return A3(
					$author$project$Pages$Main$MainPage$updateOnSubViewMsg,
					{
						at: function ($) {
							return $.aQ;
						},
						ay: $author$project$Pages$Main$MainPage$EnvironmentsMsg,
						aD: F2(
							function (subModel, model_) {
								return _Utils_update(
									model_,
									{aQ: subModel});
							}),
						dK: $author$project$Pages$Main$EnvironmentsView$update
					},
					model,
					environmentsMsg);
			case 7:
				var principalsMsg = msg.a;
				return A3(
					$author$project$Pages$Main$MainPage$updateOnSubViewMsg,
					{
						at: function ($) {
							return $.a6;
						},
						ay: $author$project$Pages$Main$MainPage$PrincipalsMsg,
						aD: F2(
							function (subModel, model_) {
								return _Utils_update(
									model_,
									{a6: subModel});
							}),
						dK: $author$project$Pages$Main$PrincipalsView$update
					},
					model,
					principalsMsg);
			case 8:
				var tenantSettingsMsg = msg.a;
				return A3(
					$author$project$Pages$Main$MainPage$updateOnSubViewMsg,
					{
						at: function ($) {
							return $.ba;
						},
						ay: $author$project$Pages$Main$MainPage$TenantSettingsMsg,
						aD: F2(
							function (subModel, model_) {
								return _Utils_update(
									model_,
									{ba: subModel});
							}),
						dK: $author$project$Pages$Main$TenantSettingsView$update
					},
					model,
					tenantSettingsMsg);
			case 9:
				return $author$project$Pages$PageUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{a2: $author$project$Pages$Main$MainPage$Hidden}));
			case 10:
				var config = msg.a;
				return $author$project$Pages$PageUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{
							a2: $author$project$Pages$Main$MainPage$Message(config)
						}));
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							S: $author$project$Lib$RemoteData$Loading(_List_Nil)
						}),
					$author$project$Api$UserApi$getUserPermissions($author$project$Pages$Main$MainPage$GotUserPermissions),
					$author$project$AppMsg$NoOp);
			case 14:
				var result = msg.a;
				return $author$project$Pages$Main$MainPage$validateCurrentRoute(
					A3(
						$author$project$Pages$PageUpdateUtils$andThen,
						$author$project$Pages$Main$MainPage$update,
						$author$project$Pages$Main$MainPage$BeginLoadBranches,
						$author$project$Pages$PageUpdateUtils$withoutActions(
							_Utils_update(
								model,
								{
									S: $author$project$Lib$RemoteData$fromResult(result)
								}))));
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							al: $author$project$Lib$RemoteData$Loading(_List_Nil)
						}),
					$author$project$Api$BranchApi$getBranches($author$project$Pages$Main$MainPage$GotBranches),
					$author$project$AppMsg$NoOp);
			case 15:
				var result = msg.a;
				return A3(
					$author$project$Pages$PageUpdateUtils$andThen,
					$author$project$Pages$Main$MainPage$update,
					$author$project$Pages$Main$MainPage$OutMsg($author$project$Pages$Main$OutMsg$BeginReloadAllEntities),
					$author$project$Pages$PageUpdateUtils$withoutActions(
						_Utils_update(
							model,
							{
								al: $author$project$Lib$RemoteData$fromResult(result)
							})));
			case 11:
				return A2($author$project$Pages$PageUpdateUtils$justAppMsg, model, $author$project$AppMsg$RequestLogout);
			case 16:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					A2($author$project$Api$EntityApi$getRoles, apiConfig, $author$project$Pages$Main$MainPage$GotRoles),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									eN: $author$project$Lib$RemoteData$toLoading(repo.eN)
								});
						},
						model));
			case 17:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					A2($author$project$Api$EntityApi$getRoleGroups, apiConfig, $author$project$Pages$Main$MainPage$GotRoleGroups),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									dy: $author$project$Lib$RemoteData$toLoading(repo.dy)
								});
						},
						model));
			case 18:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					A2(
						$author$project$Api$EntityApi$getEnvironments,
						$author$project$Pages$Main$MainPage$getApiConfig(model),
						$author$project$Pages$Main$MainPage$GotEnvironments),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									ea: $author$project$Lib$RemoteData$toLoading(repo.ea)
								});
						},
						model));
			case 19:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					A2($author$project$Api$EntityApi$getEnvironmentGroups, apiConfig, $author$project$Pages$Main$MainPage$GotEnvironmentGroups),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									Y: $author$project$Lib$RemoteData$toLoading(repo.Y)
								});
						},
						model));
			case 20:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					A2($author$project$Api$EntityApi$getPrincipals, apiConfig, $author$project$Pages$Main$MainPage$GotPrincipals),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									du: $author$project$Lib$RemoteData$toLoading(repo.du)
								});
						},
						model));
			case 21:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					A2($author$project$Api$EntityApi$getPrincipalGroups, apiConfig, $author$project$Pages$Main$MainPage$GotPrincipalGroups),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									dt: $author$project$Lib$RemoteData$toLoading(repo.dt)
								});
						},
						model));
			case 22:
				return A2(
					$author$project$Pages$PageUpdateUtils$addCmd,
					$author$project$Api$MiscApi$getIdentityProviders($author$project$Pages$Main$MainPage$GotIdentityProviders),
					A2(
						$author$project$Pages$Main$MainPage$updateRepository,
						function (repo) {
							return _Utils_update(
								repo,
								{
									de: $author$project$Lib$RemoteData$toLoading(repo.de)
								});
						},
						model));
			case 23:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{eN: data});
						}),
					result);
			case 24:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{dy: data});
						}),
					result);
			case 25:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{ea: data});
						}),
					result);
			case 26:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{Y: data});
						}),
					result);
			case 27:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{du: data});
						}),
					result);
			case 28:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{dt: data});
						}),
					result);
			default:
				var result = msg.a;
				return A2(
					handleGotWebData,
					F2(
						function (repo, data) {
							return _Utils_update(
								repo,
								{de: data});
						}),
					result);
		}
	});
var $author$project$Pages$Main$MainPage$updateOnOutMsg = F2(
	function (appMsg, model) {
		var emptyReturn = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$AppMsg$NoOp);
		switch (appMsg.$) {
			case 0:
				return emptyReturn;
			case 3:
				var err = appMsg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$AppMsg$OnHttpError(err));
			case 1:
				return A3(
					$author$project$Pages$PageUpdateUtils$sequence,
					$author$project$Pages$Main$MainPage$update,
					$author$project$Pages$Main$MainPage$getLoadMessagesForAllPermittedEntities(model),
					emptyReturn);
			case 2:
				var newRepository = appMsg.a;
				return $author$project$Pages$PageUpdateUtils$withoutActions(
					_Utils_update(
						model,
						{A: newRepository}));
			default:
				var msgs = appMsg.a;
				return A3(
					$author$project$Pages$PageUpdateUtils$sequence,
					$author$project$Pages$Main$MainPage$updateOnOutMsg,
					msgs,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$AppMsg$NoOp));
		}
	});
var $author$project$Pages$Main$MainPage$updateOnSubViewMsg = F3(
	function (config, model, msg) {
		var _v0 = A4(
			config.dK,
			$author$project$Pages$Main$MainPage$getApiConfig(model),
			model.A,
			msg,
			config.at(model));
		var updatedSubModel = _v0.a;
		var cmd = _v0.b;
		var pageMsg = _v0.c;
		return A3(
			$author$project$Pages$PageUpdateUtils$andThen,
			$author$project$Pages$Main$MainPage$update,
			$author$project$Pages$Main$MainPage$OutMsg(pageMsg),
			_Utils_Tuple3(
				A2(config.aD, updatedSubModel, model),
				A2($elm$core$Platform$Cmd$map, config.ay, cmd),
				$author$project$AppMsg$NoOp));
	});
var $ccapndave$elm_update_extra$Update$Extra$updateModel = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			f(model),
			cmd);
	});
var $author$project$Main$onUrlChanged = F2(
	function (url, model) {
		var newRoute = $author$project$Routes$urlToRoute(url);
		var _v7 = function () {
			switch (newRoute.$) {
				case 0:
					var newMainPageRoute = newRoute.a;
					var _v9 = model.z;
					if (!_v9.$) {
						return _Utils_Tuple2(
							model.z,
							$elm$core$Maybe$Just(
								$author$project$Main$MainPageMsg(
									$author$project$Pages$Main$MainPage$setRoute(newMainPageRoute))));
					} else {
						return _Utils_Tuple2(
							A2($author$project$Main$routeToDefaultPage, model.bP, newRoute),
							$elm$core$Maybe$Just(
								$author$project$Main$MainPageMsg($author$project$Pages$Main$MainPage$init)));
					}
				case 1:
					return _Utils_Tuple2(
						A2($author$project$Main$routeToDefaultPage, model.bP, newRoute),
						$elm$core$Maybe$Just(
							$author$project$Main$DocsPageMsg($author$project$Pages$DocsPage$init)));
				default:
					return _Utils_Tuple2($author$project$Main$LoggedOutPage, $elm$core$Maybe$Nothing);
			}
		}();
		var page = _v7.a;
		var msg = _v7.b;
		var onNavigatedToMsg = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Main$NoOp,
			A2($elm$core$Maybe$map, $author$project$Main$PageMsg, msg));
		return A3(
			$ccapndave$elm_update_extra$Update$Extra$andThen,
			$author$project$Main$update,
			onNavigatedToMsg,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{z: page}),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 6:
					var urlRequest = msg.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.b7,
								$elm$url$Url$toString(url)));
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href));
					}
				case 3:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a2: $author$project$Main$Hidden}),
						$elm$core$Platform$Cmd$none);
				case 7:
					var url = msg.a;
					return A2($author$project$Main$onUrlChanged, url, model);
				case 1:
					var appMsg = msg.a;
					switch (appMsg.$) {
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 1:
							var route = appMsg.a;
							return _Utils_Tuple2(
								model,
								A2($author$project$Main$navigateToCmd, model, route));
						case 2:
							return _Utils_Tuple2(
								model,
								$author$project$Api$UserApi$requestLogout($author$project$Main$GotLogout));
						case 3:
							var error = appMsg.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										a2: $author$project$Main$Error(
											$author$project$Utils$HttpUtils$httpErrorToString(error))
									}),
								$elm$core$Platform$Cmd$none);
						default:
							var appMsgs = appMsg.a;
							return A3(
								$ccapndave$elm_update_extra$Update$Extra$sequence,
								$author$project$Main$update,
								A2($elm$core$List$map, $author$project$Main$AppMsg, appMsgs),
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				case 2:
					var pageMsg = msg.a;
					return A2($author$project$Main$updateOnPageMsg, pageMsg, model);
				case 4:
					return _Utils_Tuple2(
						model,
						$author$project$Api$UserApi$requestLogin(
							$elm$core$Basics$always($author$project$Main$NoOp)));
				default:
					var result = msg.a;
					if (!result.$) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						var $temp$msg = $author$project$Main$AppMsg(
							$author$project$AppMsg$OnHttpError(err)),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
			}
		}
	});
var $author$project$Main$updateOnPageMsg = F2(
	function (pageMsg, model) {
		var _v0 = _Utils_Tuple2(pageMsg, model.z);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var pageMsg_ = _v0.a.a;
					var page = _v0.b.a;
					var _v1 = A2($author$project$Pages$Main$MainPage$update, pageMsg_, page);
					var pageModel = _v1.a;
					var cmd = _v1.b;
					var appMsg = _v1.c;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$Main$AppMsg(appMsg),
						A2(
							$ccapndave$elm_update_extra$Update$Extra$addCmd,
							A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Main$PageMsg, $author$project$Main$MainPageMsg),
								cmd),
							A2(
								$ccapndave$elm_update_extra$Update$Extra$updateModel,
								function (m) {
									return _Utils_update(
										m,
										{
											z: $author$project$Main$MainPage(pageModel)
										});
								},
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 1) {
					var pageMsg_ = _v0.a.a;
					var page = _v0.b.a;
					var _v2 = A2($author$project$Pages$DocsPage$update, pageMsg_, page);
					var pageModel = _v2.a;
					var cmd = _v2.b;
					var appMsg = _v2.c;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$Main$AppMsg(appMsg),
						A2(
							$ccapndave$elm_update_extra$Update$Extra$addCmd,
							A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Main$PageMsg, $author$project$Main$DocsPageMsg),
								cmd),
							A2(
								$ccapndave$elm_update_extra$Update$Extra$updateModel,
								function (m) {
									return _Utils_update(
										m,
										{
											z: $author$project$Main$DocsPage(pageModel)
										});
								},
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Main$CloseCurrentModal = {$: 3};
var $author$project$Utils$CommonModals$MessageModalConfig = F3(
	function (title, content, close) {
		return {fU: close, gc: content, j_: title};
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$Body = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$Config = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$body = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				fD: $elm$core$Maybe$Just(
					{aK: attributes, dY: children})
			});
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						eU: $elm$core$Maybe$Just(size)
					});
			case 1:
				var coloring = modifier.a;
				return _Utils_update(
					options,
					{
						I: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				return _Utils_update(
					options,
					{bz: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{h: val});
			default:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						aK: _Utils_ap(options.aK, attrs)
					});
		}
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions = {aK: _List_Nil, bz: false, I: $elm$core$Maybe$Nothing, h: false, eU: $elm$core$Maybe$Nothing};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass = function (role) {
	switch (role) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'success';
		case 3:
			return 'info';
		case 4:
			return 'warning';
		case 5:
			return 'danger';
		case 6:
			return 'dark';
		case 7:
			return 'light';
		default:
			return 'link';
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier, $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('btn', true),
						_Utils_Tuple2('btn-block', options.bz),
						_Utils_Tuple2('disabled', options.h)
					])),
				$elm$html$Html$Attributes$disabled(options.h)
			]),
		_Utils_ap(
			function () {
				var _v0 = A2($elm$core$Maybe$andThen, $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.eU);
				if (!_v0.$) {
					var s = _v0.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-' + s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.I;
					if (!_v1.$) {
						if (!_v1.a.$) {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						} else {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-outline-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
				options.aK)));
};
var $rundis$elm_bootstrap$Bootstrap$Button$button = F2(
	function (options, children) {
		return A2(
			$elm$html$Html$button,
			$rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$config = function (closeMsg) {
	return {
		fD: $elm$core$Maybe$Nothing,
		aM: closeMsg,
		db: $elm$core$Maybe$Nothing,
		bY: $elm$core$Maybe$Nothing,
		ae: {c2: true, aU: true, ip: $elm$core$Maybe$Nothing},
		ak: $elm$core$Maybe$Nothing
	};
};
var $rundis$elm_bootstrap$Bootstrap$Modal$Footer = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$footer = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				db: $elm$core$Maybe$Just(
					{aK: attributes, dY: children})
			});
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $rundis$elm_bootstrap$Bootstrap$Modal$Header = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$header = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				bY: $elm$core$Maybe$Just(
					{aK: attributes, dY: children})
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$titledHeader = F3(
	function (itemFn, attributes, children) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Modal$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					itemFn,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('modal-title'),
						attributes),
					children)
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$h3 = $rundis$elm_bootstrap$Bootstrap$Modal$titledHeader($elm$html$Html$h3);
var $rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick = F2(
	function (hide, _v0) {
		var conf = _v0;
		var options = conf.ae;
		return _Utils_update(
			conf,
			{
				ae: _Utils_update(
					options,
					{aU: hide})
			});
	});
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$core$String$lines = _String_lines;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Utils$CommonView$multilineTextLines = function (string) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (line) {
				return _List_fromArray(
					[
						$elm$html$Html$text(line),
						A2($elm$html$Html$br, _List_Nil, _List_Nil)
					]);
			},
			$elm$core$String$lines(string)));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs(attrs_);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $rundis$elm_bootstrap$Bootstrap$Button$onClick = function (message) {
	return $rundis$elm_bootstrap$Bootstrap$Button$attrs(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'click',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(message, true)))
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Outlined = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Primary = 0;
var $rundis$elm_bootstrap$Bootstrap$Button$outlinePrimary = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Outlined(0));
var $rundis$elm_bootstrap$Bootstrap$Modal$Show = 0;
var $rundis$elm_bootstrap$Bootstrap$Modal$shown = 0;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $rundis$elm_bootstrap$Bootstrap$Modal$StartClose = 1;
var $rundis$elm_bootstrap$Bootstrap$Modal$getCloseMsg = function (config_) {
	var _v0 = config_.ak;
	if (!_v0.$) {
		var animationMsg = _v0.a;
		return animationMsg(1);
	} else {
		return config_.aM;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$isFade = function (conf) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return true;
			},
			conf.ak));
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$backdrop = F2(
	function (visibility, conf) {
		var attributes = function () {
			switch (visibility) {
				case 0:
					return _Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal-backdrop', true),
										_Utils_Tuple2(
										'fade',
										$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
										_Utils_Tuple2('show', true)
									]))
							]),
						conf.ae.aU ? _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$rundis$elm_bootstrap$Bootstrap$Modal$getCloseMsg(conf))
							]) : _List_Nil);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', true)
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', false)
								]))
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', false),
									_Utils_Tuple2(
									'fade',
									$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
									_Utils_Tuple2('show', false)
								]))
						]);
			}
		}();
		return _List_fromArray(
			[
				A2($elm$html$Html$div, attributes, _List_Nil)
			]);
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['className']),
	$elm$json$Json$Decode$string);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $rundis$elm_bootstrap$Bootstrap$Modal$containerClickDecoder = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (c) {
			return A2($elm$core$String$contains, 'elm-bootstrap-modal', c) ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignoring');
		},
		$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$target($rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $rundis$elm_bootstrap$Bootstrap$Modal$display = F2(
	function (visibility, conf) {
		switch (visibility) {
			case 0:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 2:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', false)
							])),
						A2(
						$elm$html$Html$Events$on,
						'transitionend',
						$elm$json$Json$Decode$succeed(conf.aM))
					]);
			default:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'height', '0px'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
								_Utils_Tuple2('show', false)
							]))
					]);
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$modalClass = function (size) {
	var _v0 = $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size);
	if (!_v0.$) {
		var s = _v0.a;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-' + s)
			]);
	} else {
		return _List_Nil;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$modalAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('modal-dialog', true),
						_Utils_Tuple2('modal-dialog-centered', options.c2)
					])),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'auto')
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Modal$modalClass, options.ip)));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$renderBody = function (maybeBody) {
	if (!maybeBody.$) {
		var cfg = maybeBody.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-body'),
					cfg.aK),
				cfg.dY));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$renderFooter = function (maybeFooter) {
	if (!maybeFooter.$) {
		var cfg = maybeFooter.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-footer'),
					cfg.aK),
				cfg.dY));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$closeButton = function (closeMsg) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('close'),
				$elm$html$Html$Events$onClick(closeMsg)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('×')
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$renderHeader = function (conf_) {
	var _v0 = conf_.bY;
	if (!_v0.$) {
		var cfg = _v0.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-header'),
					cfg.aK),
				_Utils_ap(
					cfg.dY,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Modal$closeButton(
							$rundis$elm_bootstrap$Bootstrap$Modal$getCloseMsg(conf_))
						]))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$view = F2(
	function (visibility, _v0) {
		var conf = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							A2($rundis$elm_bootstrap$Bootstrap$Modal$display, visibility, conf)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'role', 'document'),
											$elm$html$Html$Attributes$class('elm-bootstrap-modal')
										]),
									_Utils_ap(
										$rundis$elm_bootstrap$Bootstrap$Modal$modalAttributes(conf.ae),
										conf.ae.aU ? _List_fromArray(
											[
												A2(
												$elm$html$Html$Events$on,
												'click',
												$rundis$elm_bootstrap$Bootstrap$Modal$containerClickDecoder(conf.aM))
											]) : _List_Nil)),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-content')
											]),
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													$rundis$elm_bootstrap$Bootstrap$Modal$renderHeader(conf),
													$rundis$elm_bootstrap$Bootstrap$Modal$renderBody(conf.fD),
													$rundis$elm_bootstrap$Bootstrap$Modal$renderFooter(conf.db)
												])))
									]))
							]))
					]),
				A2($rundis$elm_bootstrap$Bootstrap$Modal$backdrop, visibility, conf)));
	});
var $author$project$Utils$CommonModals$messageModal = function (_v0) {
	var title = _v0.j_;
	var content = _v0.gc;
	var close = _v0.fU;
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Modal$view,
		$rundis$elm_bootstrap$Bootstrap$Modal$shown,
		A3(
			$rundis$elm_bootstrap$Bootstrap$Modal$footer,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Button$button,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Button$outlinePrimary,
							$rundis$elm_bootstrap$Bootstrap$Button$onClick(close)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('OK')
						]))
				]),
			A3(
				$rundis$elm_bootstrap$Bootstrap$Modal$body,
				_List_Nil,
				$author$project$Utils$CommonView$multilineTextLines(content),
				A3(
					$rundis$elm_bootstrap$Bootstrap$Modal$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]),
					A2(
						$rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick,
						false,
						$rundis$elm_bootstrap$Bootstrap$Modal$config(close))))));
};
var $author$project$Utils$CommonModals$errorModal = function (_v0) {
	var content = _v0.gc;
	var close = _v0.fU;
	return $author$project$Utils$CommonModals$messageModal(
		A3($author$project$Utils$CommonModals$MessageModalConfig, 'Virhe', content, close));
};
var $author$project$Main$renderModal = function (model) {
	var _v0 = model.a2;
	if (!_v0.$) {
		return $elm$html$Html$text('');
	} else {
		var message = _v0.a;
		return $author$project$Utils$CommonModals$errorModal(
			{fU: $author$project$Main$CloseCurrentModal, gc: message});
	}
};
var $author$project$Main$RequestLogin = {$: 4};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$m2 = $elm$html$Html$Attributes$class('m-2');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Pages$DocsPage$missingPermissionsView = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$m2]),
	_List_fromArray(
		[
			$elm$html$Html$text('Sinulla ei ole oikeutta tähän käyttöalueeseen')
		]));
var $rundis$elm_bootstrap$Bootstrap$Utilities$Flex$alignItemsCenter = $elm$html$Html$Attributes$class('align-items-center');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Size$h100 = $elm$html$Html$Attributes$class('h-100');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Flex$justifyCenter = $elm$html$Html$Attributes$class('justify-content-center');
var $author$project$Utils$CommonView$spinner = function (attrs) {
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spinner-border')
				]),
			attrs),
		_List_Nil);
};
var $author$project$Utils$CommonView$centeredLargeSpinner = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('d-flex flex-1'),
			$rundis$elm_bootstrap$Bootstrap$Utilities$Flex$justifyCenter,
			$rundis$elm_bootstrap$Bootstrap$Utilities$Flex$alignItemsCenter,
			$rundis$elm_bootstrap$Bootstrap$Utilities$Size$h100
		]),
	_List_fromArray(
		[
			$author$project$Utils$CommonView$spinner(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spinner-large')
				]))
		]));
var $author$project$Utils$CommonView$multilineText = function (string) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Utils$CommonView$multilineTextLines(string));
};
var $author$project$Utils$CommonView$renderWebData = F2(
	function (renderSuccess, webData) {
		switch (webData.$) {
			case 3:
				var content = webData.a;
				return renderSuccess(content);
			case 2:
				var err = webData.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Utils$CommonView$multilineText(
							$author$project$Utils$HttpUtils$httpErrorToString(err))
						]));
			default:
				return $author$project$Utils$CommonView$centeredLargeSpinner;
		}
	});
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Pages$DocsPage$viewDocs = A2(
	$elm$html$Html$iframe,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/static/docs/index.html'),
			$elm$html$Html$Attributes$class('flex-1')
		]),
	_List_Nil);
var $author$project$Pages$DocsPage$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('docs-page-root')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Utils$CommonView$renderWebData,
				function (hasPermissions) {
					if (hasPermissions) {
						return $author$project$Pages$DocsPage$viewDocs;
					} else {
						return $author$project$Pages$DocsPage$missingPermissionsView;
					}
				},
				model.aT)
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Utilities$Flex$col = $elm$html$Html$Attributes$class('flex-column');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb3 = $elm$html$Html$Attributes$class('mb-3');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$primary = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(0));
var $author$project$Pages$LoggedOutPage$view = function (_v0) {
	var requestLogin = _v0.i7;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('d-flex flex-1'),
				$rundis$elm_bootstrap$Bootstrap$Utilities$Size$h100,
				$rundis$elm_bootstrap$Bootstrap$Utilities$Flex$col,
				$rundis$elm_bootstrap$Bootstrap$Utilities$Flex$alignItemsCenter,
				$rundis$elm_bootstrap$Bootstrap$Utilities$Flex$justifyCenter
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb3]),
				_List_fromArray(
					[
						$elm$html$Html$text('Olet kirjautunut ulos')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Button$onClick(requestLogin),
						$rundis$elm_bootstrap$Bootstrap$Button$primary
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Kirjaudu sisään')
					]))
			]));
};
var $author$project$Pages$Main$MainPage$BranchSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$MainPage$RequestLogout = {$: 11};
var $author$project$Forms$EnvironmentForms$EnvironmentFormConfig = function (allConnections) {
	return {v: allConnections};
};
var $author$project$Pages$Main$EnvironmentsView$EditFormBackButtonClicked = {$: 3};
var $author$project$Pages$Main$EnvironmentsView$EnvironmentFormChanged = function (a) {
	return {$: 6, a: a};
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Utils$CommonView$icon = F2(
	function (iconName, attrs) {
		return A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('fas fa-' + iconName)
						]),
					_List_Nil)
				]));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$CommonView$iconButton = F3(
	function (iconName, options, innerHtml) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Button$button,
			options,
			_List_fromArray(
				[
					A2(
					$author$project$Utils$CommonView$icon,
					iconName,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mr-2',
									!$elm$core$List$isEmpty(innerHtml))
								]))
						])),
					A2($elm$html$Html$span, _List_Nil, innerHtml)
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$General$Internal$SM = 1;
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Size = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$small = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Size(1);
var $author$project$Pages$Main$FormViewHelpers$editEntityView = F3(
	function (backMsg, title, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('edit-entity-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('edit-entity-view__top-bar')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Utils$CommonView$iconButton,
							'arrow-left',
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Button$onClick(backMsg),
									$rundis$elm_bootstrap$Bootstrap$Button$outlinePrimary,
									$rundis$elm_bootstrap$Bootstrap$Button$small
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('full-height-container')
						]),
					content)
				]));
	});
var $author$project$Forms$CommandParameterForm$NoParameterResolving = 0;
var $author$project$Lib$Form$Base$Base$Form = $elm$core$Basics$identity;
var $author$project$Lib$Form$Base$Base$fill = function (_v0) {
	var fill_ = _v0;
	return fill_;
};
var $author$project$Lib$Form$Base$Base$allowEmpty = F2(
	function (resultForEmpty, form) {
		return function (values) {
			var filled = A2($author$project$Lib$Form$Base$Base$fill, form, values);
			var _v0 = filled.c;
			if (!_v0.$) {
				return filled;
			} else {
				var _v1 = _v0.a;
				var firstError = _v1.a;
				var otherErrors = _v1.b;
				return filled.a ? {
					b: A2(
						$elm$core$List$map,
						function (_v2) {
							var field_ = _v2.a;
							return _Utils_Tuple2(field_, $elm$core$Maybe$Nothing);
						},
						filled.b),
					a: true,
					c: $elm$core$Result$Ok(resultForEmpty)
				} : {
					b: filled.b,
					a: false,
					c: $elm$core$Result$Err(
						_Utils_Tuple2(firstError, otherErrors))
				};
			}
		};
	});
var $author$project$Lib$Form$Form$allowEmptyString = $author$project$Lib$Form$Base$Base$allowEmpty('');
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Lib$Form$Base$Base$append = F2(
	function (_new, current) {
		return function (values) {
			var filledNew = A2($author$project$Lib$Form$Base$Base$fill, _new, values);
			var filledCurrent = A2($author$project$Lib$Form$Base$Base$fill, current, values);
			var isEmpty = filledCurrent.a && filledNew.a;
			var fields = _Utils_ap(filledCurrent.b, filledNew.b);
			var _v0 = filledCurrent.c;
			if (!_v0.$) {
				var fn = _v0.a;
				return {
					b: fields,
					a: isEmpty,
					c: A2($elm$core$Result$map, fn, filledNew.c)
				};
			} else {
				var errors = _v0.a;
				var firstError = errors.a;
				var otherErrors = errors.b;
				var _v1 = filledNew.c;
				if (!_v1.$) {
					return {
						b: fields,
						a: isEmpty,
						c: $elm$core$Result$Err(errors)
					};
				} else {
					var _v2 = _v1.a;
					var newFirstError = _v2.a;
					var newOtherErrors = _v2.b;
					return {
						b: fields,
						a: isEmpty,
						c: $elm$core$Result$Err(
							_Utils_Tuple2(
								firstError,
								_Utils_ap(
									otherErrors,
									A2($elm$core$List$cons, newFirstError, newOtherErrors))))
					};
				}
			}
		};
	});
var $author$project$Lib$Form$Form$append = $author$project$Lib$Form$Base$Base$append;
var $author$project$Lib$Form$Base$Base$meta = function (fn) {
	return function (values) {
		return A2(
			$author$project$Lib$Form$Base$Base$fill,
			fn(values),
			values);
	};
};
var $author$project$Lib$Form$Form$meta = $author$project$Lib$Form$Base$Base$meta;
var $author$project$Lib$Form$Base$Base$succeed = function (output) {
	return $elm$core$Basics$always(
		{
			b: _List_Nil,
			a: true,
			c: $elm$core$Result$Ok(output)
		});
};
var $author$project$Lib$Form$Form$succeed = $author$project$Lib$Form$Base$Base$succeed;
var $author$project$Forms$CommonForms$constantMetaField = function (getter) {
	return $author$project$Lib$Form$Form$meta(
		A2($elm$core$Basics$composeL, $author$project$Lib$Form$Form$succeed, getter));
};
var $author$project$Forms$CommonForms$aproProjectIdField = $author$project$Forms$CommonForms$constantMetaField(
	function ($) {
		return $.fp;
	});
var $author$project$Lib$Form$Form$InlineGroup = function (a) {
	return {$: 6, a: a};
};
var $author$project$Lib$Form$Base$Base$custom = function (fillField) {
	return function (values) {
		var filled = fillField(values);
		return {
			b: _List_fromArray(
				[
					_Utils_Tuple2(
					filled.ec,
					function () {
						var _v0 = filled.c;
						if (!_v0.$) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v1 = _v0.a;
							var firstError = _v1.a;
							return $elm$core$Maybe$Just(firstError);
						}
					}())
				]),
			a: filled.a,
			c: filled.c
		};
	};
};
var $author$project$Lib$Form$Form$inlineGroup = function (form) {
	return $author$project$Lib$Form$Base$Base$custom(
		function (values) {
			var _v0 = A2($author$project$Lib$Form$Base$Base$fill, form, values);
			var fields = _v0.b;
			var result = _v0.c;
			var isEmpty = _v0.a;
			return {
				ec: $author$project$Lib$Form$Form$InlineGroup(fields),
				a: isEmpty,
				c: result
			};
		});
};
var $author$project$Lib$Form$Base$Base$map = F2(
	function (fn, form) {
		return function (values) {
			var filled = A2($author$project$Lib$Form$Base$Base$fill, form, values);
			return {
				b: filled.b,
				a: filled.a,
				c: A2($elm$core$Result$map, fn, filled.c)
			};
		};
	});
var $author$project$Lib$Form$Form$map = $author$project$Lib$Form$Base$Base$map;
var $author$project$Lib$Form$Form$allowEmpty = $author$project$Lib$Form$Base$Base$allowEmpty;
var $elm_community$string_extra$String$Extra$nonEmpty = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Lib$Form$Form$Text = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Lib$Form$Form$TextRaw = 0;
var $author$project$Lib$Form$Base$Error$RequiredFieldIsEmpty = {$: 0};
var $author$project$Lib$Form$Base$Error$ValidationFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lib$Form$Base$Base$field = F3(
	function (_v0, build, config) {
		var isEmpty = _v0.a;
		var requiredParser = function (value) {
			return isEmpty(value) ? $elm$core$Result$Err(
				_Utils_Tuple2($author$project$Lib$Form$Base$Error$RequiredFieldIsEmpty, _List_Nil)) : A2(
				$elm$core$Result$mapError,
				function (error) {
					return _Utils_Tuple2(
						$author$project$Lib$Form$Base$Error$ValidationFailed(error),
						_List_Nil);
				},
				config.u(value));
		};
		var parse = A2($elm$core$Basics$composeR, config.kg, requiredParser);
		var field_ = function (values) {
			var value = config.kg(values);
			var update = function (newValue) {
				return A2(config.dK, newValue, values);
			};
			return build(
				{aK: config.aK, dK: update, kg: value});
		};
		return function (values) {
			var result = parse(values);
			var _v1 = function () {
				if (!result.$) {
					return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
				} else {
					var _v3 = result.a;
					var firstError = _v3.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(firstError),
						_Utils_eq(firstError, $author$project$Lib$Form$Base$Error$RequiredFieldIsEmpty));
				}
			}();
			var error = _v1.a;
			var isEmpty_ = _v1.b;
			return {
				b: _List_fromArray(
					[
						_Utils_Tuple2(
						field_(values),
						error)
					]),
				a: isEmpty_,
				c: result
			};
		};
	});
var $author$project$Lib$Form$Base$TextField$form = $author$project$Lib$Form$Base$Base$field(
	{a: $elm$core$String$isEmpty});
var $author$project$Lib$Form$Form$textField = $author$project$Lib$Form$Base$TextField$form(
	$author$project$Lib$Form$Form$Text(0));
var $author$project$Lib$Form$Form$nullableTextField = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var label = _v0.h0;
	return A2(
		$author$project$Lib$Form$Form$allowEmpty,
		$elm$core$Maybe$Nothing,
		$author$project$Lib$Form$Form$textField(
			{
				aK: {bx: $elm$core$Maybe$Nothing, h0: label, iP: ''},
				u: A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$nonEmpty, $elm$core$Result$Ok),
				dK: F2(
					function (value_, values) {
						return A2(
							update,
							$elm_community$string_extra$String$Extra$nonEmpty(value_),
							values);
					}),
				kg: A2(
					$elm$core$Basics$composeR,
					value,
					$elm$core$Maybe$withDefault(''))
			}));
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $elm$core$String$toLower = _String_toLower;
var $author$project$Utils$StringUtils$parseToBool = function (string) {
	return (($elm$core$String$toLower(string) === 'true') || (string === '1')) ? $elm$core$Maybe$Just(true) : ((($elm$core$String$toLower(string) === 'false') || (string === '0')) ? $elm$core$Maybe$Just(false) : $elm$core$Maybe$Nothing);
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Serializable$parse = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Serializable$String_(str),
		A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				$author$project$Serializable$Bool_,
				$author$project$Utils$StringUtils$parseToBool(str)),
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					$author$project$Serializable$Float_,
					$elm$core$String$toFloat(str)),
				A2(
					$elm$core$Maybe$map,
					$author$project$Serializable$Int_,
					$elm$core$String$toInt(str)))));
};
var $author$project$Lib$Form$Form$simpleTextField = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var label = _v0.h0;
	return $author$project$Lib$Form$Form$textField(
		{
			aK: {bx: $elm$core$Maybe$Nothing, h0: label, iP: ''},
			u: $elm$core$Result$Ok,
			dK: update,
			kg: value
		});
};
var $author$project$Forms$CommandParameterForm$commandParameterField = function (templateResolving) {
	var valueFieldLabelSuffix = function () {
		switch (templateResolving) {
			case 0:
				return '';
			case 1:
				return ' {{B}}';
			default:
				return ' {{F}}';
		}
	}();
	var valueField = A2(
		$author$project$Lib$Form$Form$map,
		$elm$core$Maybe$map($author$project$Serializable$parse),
		$author$project$Lib$Form$Form$nullableTextField(
			{
				h0: 'Arvo (tyhjä => NULL)' + valueFieldLabelSuffix,
				dK: F2(
					function (value_, values) {
						return _Utils_update(
							values,
							{kg: value_});
					}),
				kg: function ($) {
					return $.kg;
				}
			}));
	var keyField = $author$project$Lib$Form$Form$simpleTextField(
		{
			h0: 'Nimi',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{h_: value});
				}),
			kg: function ($) {
				return $.h_;
			}
		});
	return $author$project$Lib$Form$Form$inlineGroup(
		A2(
			$author$project$Lib$Form$Form$append,
			valueField,
			A2(
				$author$project$Lib$Form$Form$append,
				keyField,
				$author$project$Lib$Form$Form$succeed($author$project$Entity$CommandParameter$CommandParameter))));
};
var $author$project$Lib$Form$Form$TextArea = 3;
var $author$project$Lib$Form$Form$textareaField = $author$project$Lib$Form$Base$TextField$form(
	$author$project$Lib$Form$Form$Text(3));
var $author$project$Forms$CommonForms$descriptionField = $author$project$Lib$Form$Form$allowEmptyString(
	$author$project$Lib$Form$Form$textareaField(
		{
			aK: {bx: $elm$core$Maybe$Nothing, h0: 'Kuvaus', iP: ''},
			u: $elm$core$Result$Ok,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gC: value});
				}),
			kg: function ($) {
				return $.gC;
			}
		}));
var $author$project$Forms$CommonForms$idAnchorField = $author$project$Forms$CommonForms$constantMetaField(
	function ($) {
		return $.hH;
	});
var $author$project$Lib$Form$Form$Constant = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lib$Form$Base$ConstantField$form = $author$project$Lib$Form$Base$Base$field(
	{
		a: $elm$core$Basics$always(false)
	});
var $author$project$Lib$Form$Form$intConstantField = function (_v0) {
	var value = _v0.kg;
	var attributes = _v0.aK;
	return A2(
		$author$project$Lib$Form$Form$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toInt,
			$elm$core$Maybe$withDefault(-1)),
		A2(
			$author$project$Lib$Form$Base$ConstantField$form,
			$author$project$Lib$Form$Form$Constant,
			{
				aK: attributes,
				u: $elm$core$Result$Ok,
				dK: F2(
					function (_v1, values) {
						return values;
					}),
				kg: A2($elm$core$Basics$composeR, value, $elm$core$String$fromInt)
			}));
};
var $author$project$Forms$CommonForms$idField = $author$project$Lib$Form$Form$intConstantField(
	{
		aK: {h0: 'Id'},
		kg: function ($) {
			return $.bZ;
		}
	});
var $author$project$Entity$Connection$isAwsOrDynamicConnection = function (connection) {
	var _v0 = connection.jG;
	switch (_v0.$) {
		case 0:
			return true;
		case 4:
			return true;
		default:
			return false;
	}
};
var $author$project$Entity$Connection$isDatabaseOrDynamicConnection = function (connection) {
	var _v0 = connection.jG;
	switch (_v0.$) {
		case 0:
			return true;
		case 1:
			return true;
		default:
			return false;
	}
};
var $author$project$Entity$Connection$isFileServerOrDynamicConnection = function (connection) {
	var _v0 = connection.jG;
	switch (_v0.$) {
		case 0:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		default:
			return false;
	}
};
var $author$project$Entity$Connection$isHttpOrDynamicConnection = function (connection) {
	var _v0 = connection.jG;
	switch (_v0.$) {
		case 0:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Entity$Connection$isMailServerOrDynamicConnection = function (connection) {
	var _v0 = connection.jG;
	switch (_v0.$) {
		case 0:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Lib$Form$Form$Select = function (a) {
	return {$: 5, a: a};
};
var $author$project$Lib$Form$Base$SelectField$form = $author$project$Lib$Form$Base$Base$field(
	{a: $elm$core$String$isEmpty});
var $author$project$Lib$Form$Form$selectField = $author$project$Lib$Form$Base$SelectField$form($author$project$Lib$Form$Form$Select);
var $author$project$Forms$CommonForms$selectIdFieldInternal = function (config) {
	return $author$project$Lib$Form$Form$selectField(
		{
			aK: {
				h0: config.h0,
				ae: A2(
					$elm$core$List$map,
					function (_v0) {
						var id = _v0.a;
						var text = _v0.b;
						return _Utils_Tuple2(
							$elm$core$String$fromInt(id),
							text);
					},
					config.ae),
				iP: $elm$core$Maybe$Just('')
			},
			u: config.u,
			dK: F2(
				function (value, values) {
					return A2(
						config.dK,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Entity$Common$nonExistentId,
							$elm$core$String$toInt(value)),
						values);
				}),
			kg: function (values) {
				var value = config.kg(values);
				return _Utils_eq(value, $author$project$Entity$Common$nonExistentId) ? A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$fromInt),
						$elm$core$List$head(config.ae))) : $elm$core$String$fromInt(value);
			}
		});
};
var $author$project$Forms$CommonForms$selectIdOptionallyField = function (config) {
	var parser = function (str) {
		var _v0 = $elm$core$String$toInt(str);
		if (!_v0.$) {
			var id = _v0.a;
			return _Utils_eq(id, $author$project$Entity$Common$nonExistentId) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : $elm$core$Result$Ok(
				$elm$core$Maybe$Just(id));
		} else {
			return $elm$core$Result$Err('Virhe');
		}
	};
	var allOptions = A2(
		$elm$core$List$cons,
		_Utils_Tuple2($author$project$Entity$Common$nonExistentId, config.it),
		config.ae);
	return A2(
		$author$project$Lib$Form$Form$allowEmpty,
		$elm$core$Maybe$Nothing,
		$author$project$Forms$CommonForms$selectIdFieldInternal(
			{h0: config.h0, ae: allOptions, u: parser, dK: config.dK, kg: config.kg}));
};
var $author$project$Forms$ConnectionForms$selectOptionalConnectionField = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var allConnections = _v0.v;
	var connectionFilter = _v0.T;
	var label = _v0.h0;
	return $author$project$Forms$CommonForms$selectIdOptionallyField(
		{
			h0: label,
			it: 'Ei yhteyttä',
			ae: A2(
				$elm$core$List$map,
				function (c) {
					return _Utils_Tuple2(c.bZ, c.is);
				},
				A2(
					$elm$core$List$filter,
					connectionFilter,
					$elm$core$Dict$values(allConnections))),
			dK: update,
			kg: value
		});
};
var $author$project$Forms$ConnectionForms$makeConnectionSetForm = function (_v0) {
	var allConnections = _v0.v;
	var showFileServerField = _v0.eS;
	var showMailServerField = _v0.eT;
	var mailServerConnectionField = showMailServerField ? $author$project$Forms$ConnectionForms$selectOptionalConnectionField(
		{
			v: allConnections,
			T: $author$project$Entity$Connection$isMailServerOrDynamicConnection,
			h0: 'Sähköpostiserveriyhteys',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{h8: value});
				}),
			kg: function ($) {
				return $.h8;
			}
		}) : $author$project$Forms$CommonForms$constantMetaField(
		$elm$core$Basics$always($elm$core$Maybe$Nothing));
	var httpConnectionField = $author$project$Forms$ConnectionForms$selectOptionalConnectionField(
		{
			v: allConnections,
			T: $author$project$Entity$Connection$isHttpOrDynamicConnection,
			h0: 'HTTP-yhteys',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hF: value});
				}),
			kg: function ($) {
				return $.hF;
			}
		});
	var fileServerConnectionField = showFileServerField ? $author$project$Forms$ConnectionForms$selectOptionalConnectionField(
		{
			v: allConnections,
			T: $author$project$Entity$Connection$isFileServerOrDynamicConnection,
			h0: 'Tiedostoserveriyhteys',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hh: value});
				}),
			kg: function ($) {
				return $.hh;
			}
		}) : $author$project$Forms$CommonForms$constantMetaField(
		$elm$core$Basics$always($elm$core$Maybe$Nothing));
	var dbConnectionField = $author$project$Forms$ConnectionForms$selectOptionalConnectionField(
		{
			v: allConnections,
			T: $author$project$Entity$Connection$isDatabaseOrDynamicConnection,
			h0: 'Tietokantayhteys',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gq: value});
				}),
			kg: function ($) {
				return $.gq;
			}
		});
	var awsConnectionField = showMailServerField ? $author$project$Forms$ConnectionForms$selectOptionalConnectionField(
		{
			v: allConnections,
			T: $author$project$Entity$Connection$isAwsOrDynamicConnection,
			h0: 'AWS-yhteys',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fy: value});
				}),
			kg: function ($) {
				return $.fy;
			}
		}) : $author$project$Forms$CommonForms$constantMetaField(
		$elm$core$Basics$always($elm$core$Maybe$Nothing));
	return A2(
		$author$project$Lib$Form$Form$append,
		awsConnectionField,
		A2(
			$author$project$Lib$Form$Form$append,
			mailServerConnectionField,
			A2(
				$author$project$Lib$Form$Form$append,
				fileServerConnectionField,
				A2(
					$author$project$Lib$Form$Form$append,
					httpConnectionField,
					A2(
						$author$project$Lib$Form$Form$append,
						dbConnectionField,
						$author$project$Lib$Form$Form$succeed($author$project$Entity$Connection$ConnectionReferenceSet))))));
};
var $author$project$Forms$CommonForms$selectIdField = function (config) {
	return $author$project$Forms$CommonForms$selectIdFieldInternal(
		{
			h0: config.h0,
			ae: config.ae,
			u: A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toInt,
				$elm$core$Result$fromMaybe('Virhe')),
			dK: config.dK,
			kg: config.kg
		});
};
var $author$project$Forms$EnvironmentForms$makeDynamicConnectionAssociationForm = function (config) {
	var connectionOptions = A2(
		$elm$core$List$map,
		function (_v0) {
			var id = _v0.a;
			var conn = _v0.b;
			return _Utils_Tuple2(id, conn.is + (' (' + (conn.gC + ')')));
		},
		$elm$core$Dict$toList(config.v));
	var dynamicConnectionIdField = $author$project$Forms$CommonForms$selectIdField(
		{
			h0: 'Dynaaminen yhteys',
			ae: connectionOptions,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gO: value});
				}),
			kg: function ($) {
				return $.gO;
			}
		});
	var actualConnectionIdField = $author$project$Forms$CommonForms$selectIdField(
		{
			h0: 'Varsinainen yhteys',
			ae: connectionOptions,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fh: value});
				}),
			kg: function ($) {
				return $.fh;
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		actualConnectionIdField,
		A2(
			$author$project$Lib$Form$Form$append,
			dynamicConnectionIdField,
			$author$project$Lib$Form$Form$succeed($author$project$Entity$Environment$DynamicConnectionAssociation)));
};
var $author$project$Lib$Form$Base$Base$mapField = F2(
	function (fn, form) {
		return function (values) {
			var filled = A2($author$project$Lib$Form$Base$Base$fill, form, values);
			return {
				b: A2(
					$elm$core$List$map,
					function (_v0) {
						var field_ = _v0.a;
						var error = _v0.b;
						return _Utils_Tuple2(
							fn(field_),
							error);
					},
					filled.b),
				a: filled.a,
				c: filled.c
			};
		};
	});
var $author$project$Lib$Form$Form$Checkbox = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lib$Form$Form$Code = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$Form$Form$List = function (a) {
	return {$: 8, a: a};
};
var $author$project$Lib$Form$Form$Number = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lib$Form$Form$Section = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Lib$Form$Base$Field$mapValues = F2(
	function (fn, _v0) {
		var value = _v0.kg;
		var update = _v0.dK;
		var attributes = _v0.aK;
		return {
			aK: attributes,
			dK: A2($elm$core$Basics$composeR, update, fn),
			kg: value
		};
	});
var $author$project$Lib$Form$Form$mapFieldValues = F3(
	function (update, values, field) {
		var newUpdate = function (oldValues) {
			return A2(update, oldValues, values);
		};
		var mapUpdate = F2(
			function (fn, value) {
				return A2(
					update,
					fn(value),
					values);
			});
		switch (field.$) {
			case 0:
				var field_ = field.a;
				return $author$project$Lib$Form$Form$Constant(
					A2($author$project$Lib$Form$Base$Field$mapValues, newUpdate, field_));
			case 1:
				var textType = field.a;
				var field_ = field.b;
				return A2(
					$author$project$Lib$Form$Form$Text,
					textType,
					A2($author$project$Lib$Form$Base$Field$mapValues, newUpdate, field_));
			case 2:
				var field_ = field.a;
				return $author$project$Lib$Form$Form$Number(
					A2($author$project$Lib$Form$Base$Field$mapValues, newUpdate, field_));
			case 3:
				var field_ = field.a;
				return $author$project$Lib$Form$Form$Code(
					A2($author$project$Lib$Form$Base$Field$mapValues, newUpdate, field_));
			case 4:
				var field_ = field.a;
				return $author$project$Lib$Form$Form$Checkbox(
					A2($author$project$Lib$Form$Base$Field$mapValues, newUpdate, field_));
			case 5:
				var field_ = field.a;
				return $author$project$Lib$Form$Form$Select(
					A2($author$project$Lib$Form$Base$Field$mapValues, newUpdate, field_));
			case 6:
				var fields = field.a;
				return $author$project$Lib$Form$Form$InlineGroup(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var field_ = _v1.a;
							var error = _v1.b;
							return _Utils_Tuple2(
								A3($author$project$Lib$Form$Form$mapFieldValues, update, values, field_),
								error);
						},
						fields));
			case 7:
				var title = field.a;
				var fields = field.b;
				return A2(
					$author$project$Lib$Form$Form$Section,
					title,
					A2(
						$elm$core$List$map,
						function (_v2) {
							var field_ = _v2.a;
							var error = _v2.b;
							return _Utils_Tuple2(
								A3($author$project$Lib$Form$Form$mapFieldValues, update, values, field_),
								error);
						},
						fields));
			default:
				var forms = field.a.ef;
				var add = field.a.dQ;
				var attributes = field.a.aK;
				return $author$project$Lib$Form$Form$List(
					{
						dQ: function (_v3) {
							return A2(
								update,
								add(0),
								values);
						},
						aK: attributes,
						ef: A2(
							$elm$core$List$map,
							function (_v4) {
								var fields = _v4.b;
								var _delete = _v4.d2;
								var move = _v4.ex;
								return {
									d2: function (_v5) {
										return A2(
											update,
											_delete(0),
											values);
									},
									b: A2(
										$elm$core$List$map,
										function (_v6) {
											var field_ = _v6.a;
											var error = _v6.b;
											return _Utils_Tuple2(
												A3($author$project$Lib$Form$Form$mapFieldValues, update, values, field_),
												error);
										},
										fields),
									ex: function (direction) {
										return A2(
											update,
											move(direction),
											values);
									}
								};
							},
							forms)
					});
		}
	});
var $author$project$Lib$Form$Base$Base$mapValues = F2(
	function (fn, form) {
		return A2(
			$elm$core$Basics$composeR,
			fn,
			$author$project$Lib$Form$Base$Base$fill(form));
	});
var $author$project$Lib$Form$Form$mapValues = F2(
	function (_v0, form) {
		var value = _v0.kg;
		var update = _v0.dK;
		return $author$project$Lib$Form$Base$Base$meta(
			function (values) {
				return A2(
					$author$project$Lib$Form$Base$Base$mapField,
					A2($author$project$Lib$Form$Form$mapFieldValues, update, values),
					A2($author$project$Lib$Form$Base$Base$mapValues, value, form));
			});
	});
var $author$project$Lib$Form$Form$fill = $author$project$Lib$Form$Base$Base$fill;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var tail = $elm$core$List$tail(
				A2($elm$core$List$drop, index, l));
			var head = A2($elm$core$List$take, index, l);
			if (tail.$ === 1) {
				return l;
			} else {
				var t = tail.a;
				return A2($elm$core$List$append, head, t);
			}
		}
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $elm_community$list_extra$List$Extra$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $elm_community$list_extra$List$Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$elm_community$list_extra$List$Extra$uncons(head2),
						$elm_community$list_extra$List$Extra$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $author$project$Lib$Form$Base$FormList$form = F3(
	function (tagger, _v0, buildElement) {
		var value = _v0.kg;
		var update = _v0.dK;
		var _default = _v0.gs;
		var attributes = _v0.aK;
		return $author$project$Lib$Form$Base$Base$custom(
			function (values) {
				var listOfElementValues = value(values);
				var toForm = F2(
					function (index, _v8) {
						var fields = _v8.b;
						return {
							d2: function (_v6) {
								return A2(
									update,
									A2($elm_community$list_extra$List$Extra$removeAt, index, listOfElementValues),
									values);
							},
							b: fields,
							ex: function (dir) {
								var newIndex = function () {
									if (!dir) {
										return index - 1;
									} else {
										return index + 1;
									}
								}();
								return A2(
									update,
									A3($elm_community$list_extra$List$Extra$swapAt, index, newIndex, listOfElementValues),
									values);
							}
						};
					});
				var gatherResults = F2(
					function (next, current) {
						var _v2 = next.c;
						if (!_v2.$) {
							var output = _v2.a;
							return A2(
								$elm$core$Result$map,
								$elm$core$List$cons(output),
								current);
						} else {
							var _v3 = _v2.a;
							var head = _v3.a;
							var errors = _v3.b;
							if (!current.$) {
								return $elm$core$Result$Err(
									_Utils_Tuple2(head, errors));
							} else {
								var _v5 = current.a;
								var currentHead = _v5.a;
								var currentErrors = _v5.b;
								return $elm$core$Result$Err(
									_Utils_Tuple2(
										head,
										_Utils_ap(
											errors,
											A2($elm$core$List$cons, currentHead, currentErrors))));
							}
						}
					});
				var elementForIndex = F2(
					function (index, elementValues) {
						return buildElement(
							{
								d6: elementValues,
								en: index,
								dK: F2(
									function (newElementValues, values_) {
										var newList = A3($elm_community$list_extra$List$Extra$setAt, index, newElementValues, listOfElementValues);
										return A2(update, newList, values_);
									}),
								e8: values
							});
					});
				var filledElements = A2($elm$core$List$indexedMap, elementForIndex, listOfElementValues);
				var result = A3(
					$elm$core$List$foldr,
					gatherResults,
					$elm$core$Result$Ok(_List_Nil),
					filledElements);
				return {
					ec: tagger(
						{
							dQ: function (_v1) {
								return A2(
									update,
									_Utils_ap(
										listOfElementValues,
										_List_fromArray(
											[_default])),
									values);
							},
							aK: attributes,
							ef: A2($elm$core$List$indexedMap, toForm, filledElements)
						}),
					a: A2(
						$elm$core$List$all,
						function ($) {
							return $.a;
						},
						filledElements),
					c: result
				};
			});
	});
var $author$project$Lib$Form$Form$list = F2(
	function (config, elementForIndex) {
		var fillElement = function (_v1) {
			var index = _v1.en;
			var update = _v1.dK;
			var values = _v1.e8;
			var elementValues = _v1.d6;
			var filledElement = A2(
				$author$project$Lib$Form$Form$fill,
				elementForIndex(index),
				elementValues);
			return {
				b: A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var error = _v0.b;
						return _Utils_Tuple2(
							A3($author$project$Lib$Form$Form$mapFieldValues, update, values, field),
							error);
					},
					filledElement.b),
				a: filledElement.a,
				c: filledElement.c
			};
		};
		return A3($author$project$Lib$Form$Base$FormList$form, $author$project$Lib$Form$Form$List, config, fillElement);
	});
var $author$project$Lib$Form$Form$simpleList = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var _default = _v0.gs;
	var label = _v0.h0;
	return $author$project$Lib$Form$Form$list(
		{
			aK: {
				fi: $elm$core$Maybe$Just('Uusi'),
				gA: true,
				h0: label,
				iH: true
			},
			gs: _default,
			dK: update,
			kg: value
		});
};
var $author$project$Forms$EnvironmentForms$makeEnvironmentForm = function (config) {
	var allConnections = config.v;
	var nameField = $author$project$Lib$Form$Form$simpleTextField(
		{
			h0: 'Nimi',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{is: value});
				}),
			kg: function ($) {
				return $.is;
			}
		});
	var envTypeField = $author$project$Lib$Form$Form$allowEmptyString(
		$author$project$Lib$Form$Form$simpleTextField(
			{
				h0: 'Tyyppi',
				dK: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{g1: value});
					}),
				kg: function ($) {
					return $.g1;
				}
			}));
	var envParamsForm = A2(
		$author$project$Lib$Form$Form$simpleList,
		{
			gs: {h_: '', kg: $elm$core$Maybe$Nothing},
			h0: 'Parametrit',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{g0: value});
				}),
			kg: function ($) {
				return $.g0;
			}
		},
		function (_v1) {
			return $author$project$Forms$CommandParameterForm$commandParameterField(0);
		});
	var dynamicConnectionsForm = A2(
		$author$project$Lib$Form$Form$simpleList,
		{
			gs: {fh: $author$project$Entity$Common$nonExistentId, gO: $author$project$Entity$Common$nonExistentId},
			h0: 'Dynaamiset yhteydet',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gP: value});
				}),
			kg: function ($) {
				return $.gP;
			}
		},
		function (_v0) {
			return $author$project$Forms$EnvironmentForms$makeDynamicConnectionAssociationForm(config);
		});
	var displayNameField = $author$project$Lib$Form$Form$allowEmptyString(
		$author$project$Lib$Form$Form$simpleTextField(
			{
				h0: 'Näyttönimi',
				dK: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gE: value});
					}),
				kg: function ($) {
					return $.gE;
				}
			}));
	var connectionsForm = A2(
		$author$project$Lib$Form$Form$mapValues,
		{
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bG: value});
				}),
			kg: function ($) {
				return $.bG;
			}
		},
		$author$project$Forms$ConnectionForms$makeConnectionSetForm(
			{v: allConnections, jC: true, eS: true, eT: true}));
	return A2(
		$author$project$Lib$Form$Form$append,
		envParamsForm,
		A2(
			$author$project$Lib$Form$Form$append,
			dynamicConnectionsForm,
			A2(
				$author$project$Lib$Form$Form$append,
				connectionsForm,
				A2(
					$author$project$Lib$Form$Form$append,
					envTypeField,
					A2(
						$author$project$Lib$Form$Form$append,
						$author$project$Forms$CommonForms$descriptionField,
						A2(
							$author$project$Lib$Form$Form$append,
							displayNameField,
							A2(
								$author$project$Lib$Form$Form$append,
								nameField,
								A2(
									$author$project$Lib$Form$Form$append,
									$author$project$Forms$CommonForms$idAnchorField,
									A2(
										$author$project$Lib$Form$Form$append,
										$author$project$Forms$CommonForms$aproProjectIdField,
										A2(
											$author$project$Lib$Form$Form$append,
											$author$project$Forms$CommonForms$constantMetaField(
												function ($) {
													return $.cr;
												}),
											A2(
												$author$project$Lib$Form$Form$append,
												$author$project$Forms$CommonForms$constantMetaField(
													function ($) {
														return $.hw;
													}),
												A2(
													$author$project$Lib$Form$Form$append,
													$author$project$Forms$CommonForms$idField,
													$author$project$Lib$Form$Form$succeed($author$project$Entity$Environment$Environment)))))))))))));
};
var $author$project$Lib$Form$FormView$ValidateOnBlur = 1;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Lib$Form$FormView$appendToId = F2(
	function (prefix, index) {
		return prefix + ('_' + $elm$core$String$fromInt(index));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Email = 8;
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Input = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Type = function (a) {
	return {$: 2, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$create = F2(
	function (tipe, options) {
		return {
			ae: A2(
				$elm$core$List$cons,
				$rundis$elm_bootstrap$Bootstrap$Form$Input$Type(tipe),
				options)
		};
	});
var $elm$html$Html$input = _VirtualDom_node('input');
var $rundis$elm_bootstrap$Bootstrap$Form$Input$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size_ = modifier.a;
				return _Utils_update(
					options,
					{
						eU: $elm$core$Maybe$Just(size_)
					});
			case 1:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						bZ: $elm$core$Maybe$Just(id_)
					});
			case 2:
				var tipe = modifier.a;
				return _Utils_update(
					options,
					{bb: tipe});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{h: val});
			case 4:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{
						kg: $elm$core$Maybe$Just(value_)
					});
			case 7:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{
						iP: $elm$core$Maybe$Just(value_)
					});
			case 5:
				var onInput_ = modifier.a;
				return _Utils_update(
					options,
					{
						cg: $elm$core$Maybe$Just(onInput_)
					});
			case 6:
				var validation_ = modifier.a;
				return _Utils_update(
					options,
					{
						e7: $elm$core$Maybe$Just(validation_)
					});
			case 8:
				var val = modifier.a;
				return _Utils_update(
					options,
					{cC: val});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						aK: _Utils_ap(options.aK, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Text = 0;
var $rundis$elm_bootstrap$Bootstrap$Form$Input$defaultOptions = {aK: _List_Nil, h: false, bZ: $elm$core$Maybe$Nothing, cg: $elm$core$Maybe$Nothing, iP: $elm$core$Maybe$Nothing, cC: false, eU: $elm$core$Maybe$Nothing, bb: 0, e7: $elm$core$Maybe$Nothing, kg: $elm$core$Maybe$Nothing};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $rundis$elm_bootstrap$Bootstrap$Form$Input$sizeAttribute = function (size) {
	return A2(
		$elm$core$Maybe$map,
		function (s) {
			return $elm$html$Html$Attributes$class('form-control-' + s);
		},
		$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $rundis$elm_bootstrap$Bootstrap$Form$Input$typeAttribute = function (inputType) {
	return $elm$html$Html$Attributes$type_(
		function () {
			switch (inputType) {
				case 0:
					return 'text';
				case 1:
					return 'password';
				case 2:
					return 'datetime-local';
				case 3:
					return 'date';
				case 4:
					return 'month';
				case 5:
					return 'time';
				case 6:
					return 'week';
				case 7:
					return 'number';
				case 8:
					return 'email';
				case 9:
					return 'url';
				case 10:
					return 'search';
				case 11:
					return 'tel';
				default:
					return 'color';
			}
		}());
};
var $rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString = function (validation) {
	if (!validation) {
		return 'is-valid';
	} else {
		return 'is-invalid';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$validationAttribute = function (validation) {
	return $elm$html$Html$Attributes$class(
		$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation));
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $rundis$elm_bootstrap$Bootstrap$Form$Input$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Input$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Input$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control'),
				$elm$html$Html$Attributes$disabled(options.h),
				$elm$html$Html$Attributes$readonly(options.cC),
				$rundis$elm_bootstrap$Bootstrap$Form$Input$typeAttribute(options.bb)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.bZ),
						A2($elm$core$Maybe$andThen, $rundis$elm_bootstrap$Bootstrap$Form$Input$sizeAttribute, options.eU),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, options.kg),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$placeholder, options.iP),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, options.cg),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Input$validationAttribute, options.e7)
					])),
			options.aK));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$view = function (_v0) {
	var options = _v0.ae;
	return A2(
		$elm$html$Html$input,
		$rundis$elm_bootstrap$Bootstrap$Form$Input$toAttributes(options),
		_List_Nil);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$input = F2(
	function (tipe, options) {
		return $rundis$elm_bootstrap$Bootstrap$Form$Input$view(
			A2($rundis$elm_bootstrap$Bootstrap$Form$Input$create, tipe, options));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Input$email = $rundis$elm_bootstrap$Bootstrap$Form$Input$input(8);
var $author$project$Utils$MaybeUtils$fromBool = F2(
	function (valueIfTrue, bool) {
		return bool ? $elm$core$Maybe$Just(valueIfTrue) : $elm$core$Maybe$Nothing;
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Lib$Form$FormView$maybeIgnoreChildError = function (maybeParentError) {
	if (!maybeParentError.$) {
		return $elm$core$Basics$identity;
	} else {
		return $elm$core$Tuple$mapSecond(
			function (_v1) {
				return $elm$core$Maybe$Nothing;
			});
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Password = 1;
var $rundis$elm_bootstrap$Bootstrap$Form$Input$password = $rundis$elm_bootstrap$Bootstrap$Form$Input$input(1);
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Attrs = function (a) {
	return {$: 7, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Off = 1;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$On = 0;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Value = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checked = function (isCheck) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Value(
		isCheck ? 0 : 1);
};
var $author$project$Lib$MiscUtils$consIf = F3(
	function (cond, item, list) {
		return cond ? A2($elm$core$List$cons, item, list) : list;
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Custom = {$: 4};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Checkbox = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$create = F2(
	function (options, label) {
		return {h0: label, ae: options};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var val = modifier.a;
				return _Utils_update(
					options,
					{
						bZ: $elm$core$Maybe$Just(val)
					});
			case 1:
				var val = modifier.a;
				return _Utils_update(
					options,
					{F: val});
			case 2:
				return _Utils_update(
					options,
					{aW: true});
			case 3:
				var toMsg = modifier.a;
				return _Utils_update(
					options,
					{
						ce: $elm$core$Maybe$Just(toMsg)
					});
			case 4:
				return _Utils_update(
					options,
					{p: true});
			case 5:
				var val = modifier.a;
				return _Utils_update(
					options,
					{h: val});
			case 6:
				var validation = modifier.a;
				return _Utils_update(
					options,
					{
						e7: $elm$core$Maybe$Just(validation)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						aK: _Utils_ap(options.aK, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$defaultOptions = {aK: _List_Nil, p: false, h: false, bZ: $elm$core$Maybe$Nothing, aW: false, ce: $elm$core$Maybe$Nothing, F: 1, e7: $elm$core$Maybe$Nothing};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$stateAttribute = function (state) {
	switch (state) {
		case 0:
			return $elm$html$Html$Attributes$checked(true);
		case 1:
			return $elm$html$Html$Attributes$checked(false);
		default:
			return A2($elm$html$Html$Attributes$attribute, 'indeterminate', 'true');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$toAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check-input', !options.p),
						_Utils_Tuple2('custom-control-input', options.p)
					])),
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$disabled(options.h),
				$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$stateAttribute(options.F)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onCheck, options.ce),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.bZ)
					])),
			_Utils_ap(
				function () {
					var _v0 = options.e7;
					if (!_v0.$) {
						var v = _v0.a;
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(v))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				options.aK)));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$view = function (_v0) {
	var chk = _v0;
	var opts = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$defaultOptions, chk.ae);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check', !opts.p),
						_Utils_Tuple2('form-check-inline', (!opts.p) && opts.aW),
						_Utils_Tuple2('custom-control', opts.p),
						_Utils_Tuple2('custom-checkbox', opts.p),
						_Utils_Tuple2('custom-control-inline', opts.aW && opts.p)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$toAttributes(opts),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-check-label', !opts.p),
									_Utils_Tuple2('custom-control-label', opts.p)
								]))
						]),
					function () {
						var _v1 = opts.bZ;
						if (!_v1.$) {
							var v = _v1.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$for(v)
								]);
						} else {
							return _List_Nil;
						}
					}()),
				_List_fromArray(
					[
						$elm$html$Html$text(chk.h0)
					]))
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$custom = function (options) {
	return A2(
		$elm$core$Basics$composeL,
		$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$view,
		$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$create(
			A2($elm$core$List$cons, $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Custom, options)));
};
var $rundis$elm_bootstrap$Bootstrap$Form$FormInternal$Danger = 1;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Validation = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$danger = $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Validation(1);
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Disabled = function (a) {
	return {$: 5, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$disabled = function (disabled_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Disabled(disabled_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Id = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$id = function (theId) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Id(theId);
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$OnChecked = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$OnChecked(toMsg);
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Lib$Form$FormView$withMaybeAttribute = F3(
	function (toAttribute, maybeValue, attrs) {
		return A2(
			$elm$core$Maybe$withDefault,
			attrs,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					toAttribute,
					function (attr) {
						return A2($elm$core$List$cons, attr, attrs);
					}),
				maybeValue));
	});
var $author$project$Lib$Form$FormView$renderCheckboxField = F2(
	function (_v0, _v1) {
		var onChange = _v0.r;
		var onFocus = _v0.M;
		var onBlur = _v0.D;
		var disabled = _v0.h;
		var value = _v0.kg;
		var error = _v0.Z;
		var showError = _v0.B;
		var label = _v0.h0;
		var id = _v0.bZ;
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$custom,
			A3(
				$author$project$Lib$MiscUtils$consIf,
				showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error),
				$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$danger,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$id(id),
						$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(onChange),
						$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checked(value),
						$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(disabled),
						$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
						A3(
							$author$project$Lib$Form$FormView$withMaybeAttribute,
							$elm$html$Html$Events$onBlur,
							onBlur,
							_List_fromArray(
								[
									$elm$html$Html$Events$onFocus(onFocus)
								])))
					])),
			label);
	});
var $author$project$Lib$Form$FormView$renderConstantField = F2(
	function (value, _v0) {
		var label = _v0.h0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('constant-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-weight-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label + ': ')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Disabled = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$disabled = function (disabled_) {
	return $rundis$elm_bootstrap$Bootstrap$Internal$Button$Disabled(disabled_);
};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Lib$Form$FormView$renderFormList = function (_v0) {
	var forms = _v0.ef;
	var label = _v0.h0;
	var add = _v0.dQ;
	var disabled = _v0.h;
	var addButton = function () {
		if (!add.$) {
			var add_ = add.a;
			return A2(
				$elm$html$Html$map,
				function (f) {
					return f(0);
				},
				A2(
					$rundis$elm_bootstrap$Bootstrap$Button$button,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Button$onClick(add_.dN),
							$rundis$elm_bootstrap$Bootstrap$Button$disabled(disabled),
							$rundis$elm_bootstrap$Bootstrap$Button$attrs(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-list-add-btn')
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-plus')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(add_.h0)
								]))
						])));
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$fieldset,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-list')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$legend,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
			_Utils_ap(
				forms,
				_List_fromArray(
					[addButton]))));
};
var $author$project$Lib$Form$Base$FormList$MoveDown = 1;
var $author$project$Lib$Form$Base$FormList$MoveUp = 0;
var $author$project$Lib$Form$FormView$renderFormListItem = function (_v0) {
	var fields = _v0.b;
	var _delete = _v0.d2;
	var disabled = _v0.h;
	var move = _v0.ex;
	var maybeActionButton = F2(
		function (iconName, maybeAction) {
			if (!maybeAction.$) {
				var action = maybeAction.a;
				return A2(
					$elm$html$Html$map,
					function (f) {
						return f(0);
					},
					A2(
						$rundis$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Button$onClick(action),
								$rundis$elm_bootstrap$Bootstrap$Button$disabled(disabled),
								$rundis$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-list-action-btn')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-' + iconName)
									]),
								_List_Nil)
							])));
			} else {
				return $elm$html$Html$text('');
			}
		});
	var moveDownButton = A2(
		maybeActionButton,
		'chevron-down',
		A2(
			$elm$core$Maybe$map,
			function (move_) {
				return $elm$core$Basics$always(
					move_(1));
			},
			move));
	var moveUpButton = A2(
		maybeActionButton,
		'chevron-up',
		A2(
			$elm$core$Maybe$map,
			function (move_) {
				return $elm$core$Basics$always(
					move_(0));
			},
			move));
	var deleteButton = A2(maybeActionButton, 'times', _delete);
	var buttons = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-list-action-buttons')
			]),
		_List_fromArray(
			[moveUpButton, moveDownButton, deleteButton]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-list-item')
			]),
		A2($elm$core$List$cons, buttons, fields));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $rundis$elm_bootstrap$Bootstrap$Form$form = F2(
	function (attributes, children) {
		return A2($elm$html$Html$form, attributes, children);
	});
var $rundis$elm_bootstrap$Bootstrap$Form$formInline = function (attributes) {
	return $rundis$elm_bootstrap$Bootstrap$Form$form(
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('form-inline'),
			attributes));
};
var $author$project$Lib$Form$FormView$renderGroup = $rundis$elm_bootstrap$Bootstrap$Form$formInline(_List_Nil);
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Attrs = function (a) {
	return {$: 9, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Input$Attrs(attrs_);
};
var $author$project$Lib$Form$Base$TextField$autoCompleteToStr = function (autoComplete) {
	switch (autoComplete) {
		case 0:
			return 'username';
		case 1:
			return 'current-password';
		default:
			return 'new-password';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Validation = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$danger = $rundis$elm_bootstrap$Bootstrap$Form$Input$Validation(1);
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Disabled = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$disabled = function (disabled_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Input$Disabled(disabled_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Id = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$id = function (id_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Input$Id(id_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$OnInput = function (a) {
	return {$: 5, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$onInput = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Input$OnInput(toMsg);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Placeholder = function (a) {
	return {$: 7, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$placeholder = function (value_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Input$Placeholder(value_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Value = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Input$value = function (value_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Input$Value(value_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$applyModifier = F2(
	function (modifier, options) {
		var value = modifier;
		return _Utils_update(
			options,
			{
				aK: _Utils_ap(options.aK, value)
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Form$defaultOptions = {aK: _List_Nil};
var $rundis$elm_bootstrap$Bootstrap$Form$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-group')
			]),
		options.aK);
};
var $rundis$elm_bootstrap$Bootstrap$Form$group = F2(
	function (options, children) {
		return A2(
			$elm$html$Html$div,
			$rundis$elm_bootstrap$Bootstrap$Form$toAttributes(options),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Form$label = F2(
	function (attributes, children) {
		return A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-control-label'),
				attributes),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Form$invalidFeedback = F2(
	function (attributes, children) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('invalid-feedback'),
				attributes),
			children);
	});
var $author$project$Lib$Form$FormView$errorLabel = function (msg) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Form$invalidFeedback,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(msg)
			]));
};
var $author$project$Lib$Form$FormView$errorToString = function (error) {
	if (!error.$) {
		return 'Vaaditaan';
	} else {
		var validationError = error.a;
		return validationError;
	}
};
var $author$project$Lib$Form$FormView$maybeErrorMessage = F2(
	function (showError, maybeError) {
		return showError ? A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				$author$project$Lib$Form$FormView$errorLabel,
				A2($elm$core$Maybe$map, $author$project$Lib$Form$FormView$errorToString, maybeError))) : $elm$html$Html$text('');
	});
var $author$project$Lib$Form$FormView$withLabelAndError = F4(
	function (label, showError, error, fieldAsHtml) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Form$group,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Form$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					fieldAsHtml,
					A2($author$project$Lib$Form$FormView$maybeErrorMessage, showError, error)
				]));
	});
var $author$project$Lib$Form$FormView$renderInputField = F3(
	function (factory, _v0, _v1) {
		var onChange = _v0.r;
		var onFocus = _v0.M;
		var onBlur = _v0.D;
		var disabled = _v0.h;
		var value = _v0.kg;
		var error = _v0.Z;
		var showError = _v0.B;
		var label = _v0.h0;
		var id = _v0.bZ;
		var placeholder = _v1.iP;
		var autoComplete = _v1.bx;
		return A4(
			$author$project$Lib$Form$FormView$withLabelAndError,
			label,
			showError,
			error,
			factory(
				A3(
					$author$project$Lib$MiscUtils$consIf,
					showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error),
					$rundis$elm_bootstrap$Bootstrap$Form$Input$danger,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Form$Input$onInput(onChange),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$id(id),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$disabled(disabled),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$value(value),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$placeholder(placeholder),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$attrs(
							A3(
								$author$project$Lib$Form$FormView$withMaybeAttribute,
								$elm$html$Html$Attributes$attribute('autocomplete'),
								A2($elm$core$Maybe$map, $author$project$Lib$Form$Base$TextField$autoCompleteToStr, autoComplete),
								A3(
									$author$project$Lib$Form$FormView$withMaybeAttribute,
									$elm$html$Html$Events$onBlur,
									onBlur,
									_List_fromArray(
										[
											$elm$html$Html$Events$onFocus(onFocus)
										]))))
						]))));
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Number = 7;
var $rundis$elm_bootstrap$Bootstrap$Form$Input$number = $rundis$elm_bootstrap$Bootstrap$Form$Input$input(7);
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Lib$Form$FormView$renderNumberField = F2(
	function (_v0, attributes) {
		var onChange = _v0.r;
		var onFocus = _v0.M;
		var onBlur = _v0.D;
		var disabled = _v0.h;
		var value = _v0.kg;
		var error = _v0.Z;
		var showError = _v0.B;
		var label = _v0.h0;
		var id = _v0.bZ;
		var stepAttrValue = A2(
			$elm$core$Maybe$withDefault,
			'any',
			A2($elm$core$Maybe$map, $elm$core$String$fromFloat, attributes.jL));
		return A4(
			$author$project$Lib$Form$FormView$withLabelAndError,
			label,
			showError,
			error,
			$rundis$elm_bootstrap$Bootstrap$Form$Input$number(
				A3(
					$author$project$Lib$MiscUtils$consIf,
					showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error),
					$rundis$elm_bootstrap$Bootstrap$Form$Input$danger,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Form$Input$onInput(onChange),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$id(id),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$disabled(disabled),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$value(value),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$placeholder(attributes.iP),
							$rundis$elm_bootstrap$Bootstrap$Form$Input$attrs(
							A3(
								$author$project$Lib$Form$FormView$withMaybeAttribute,
								A2($elm$core$Basics$composeR, $elm$core$String$fromFloat, $elm$html$Html$Attributes$min),
								attributes.dk,
								A3(
									$author$project$Lib$Form$FormView$withMaybeAttribute,
									A2($elm$core$Basics$composeR, $elm$core$String$fromFloat, $elm$html$Html$Attributes$max),
									attributes.dj,
									A3(
										$author$project$Lib$Form$FormView$withMaybeAttribute,
										$elm$html$Html$Events$onBlur,
										onBlur,
										_List_fromArray(
											[
												$elm$html$Html$Events$onFocus(onFocus),
												$elm$html$Html$Attributes$step(stepAttrValue)
											])))))
						]))));
	});
var $author$project$Lib$Form$FormView$renderSection = F2(
	function (title, fields) {
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-fieldset')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$legend,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
				fields));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Attrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Select$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Custom = {$: 2};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Select = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Select$create = F2(
	function (options, items) {
		return {eq: items, ae: options};
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $rundis$elm_bootstrap$Bootstrap$Form$Select$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size_ = modifier.a;
				return _Utils_update(
					options,
					{
						eU: $elm$core$Maybe$Just(size_)
					});
			case 1:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						bZ: $elm$core$Maybe$Just(id_)
					});
			case 2:
				return _Utils_update(
					options,
					{p: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{h: val});
			case 4:
				var onChange_ = modifier.a;
				return _Utils_update(
					options,
					{
						r: $elm$core$Maybe$Just(onChange_)
					});
			case 5:
				var validation_ = modifier.a;
				return _Utils_update(
					options,
					{
						e7: $elm$core$Maybe$Just(validation_)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						aK: _Utils_ap(options.aK, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$customEventOnChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$defaultOptions = {aK: _List_Nil, p: false, h: false, bZ: $elm$core$Maybe$Nothing, r: $elm$core$Maybe$Nothing, eU: $elm$core$Maybe$Nothing, e7: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$sizeAttribute = F2(
	function (isCustom, size_) {
		var prefix = isCustom ? 'custom-select-' : 'form-control-';
		return A2(
			$elm$core$Maybe$map,
			function (s) {
				return $elm$html$Html$Attributes$class(
					_Utils_ap(prefix, s));
			},
			$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size_));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$validationAttribute = function (validation_) {
	return $elm$html$Html$Attributes$class(
		$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation_));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Select$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Select$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-control', !options.p),
						_Utils_Tuple2('custom-select', options.p)
					])),
				$elm$html$Html$Attributes$disabled(options.h)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.bZ),
						A2(
						$elm$core$Maybe$andThen,
						$rundis$elm_bootstrap$Bootstrap$Form$Select$sizeAttribute(options.p),
						options.eU),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Select$customEventOnChange, options.r),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Select$validationAttribute, options.e7)
					])),
			options.aK));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$view = function (_v0) {
	var options = _v0.ae;
	var items = _v0.eq;
	return A2(
		$elm$html$Html$select,
		$rundis$elm_bootstrap$Bootstrap$Form$Select$toAttributes(options),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var e = _v1;
				return e;
			},
			items));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$custom = function (options) {
	return A2(
		$elm$core$Basics$composeL,
		$rundis$elm_bootstrap$Bootstrap$Form$Select$view,
		$rundis$elm_bootstrap$Bootstrap$Form$Select$create(
			A2($elm$core$List$cons, $rundis$elm_bootstrap$Bootstrap$Form$Select$Custom, options)));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Validation = function (a) {
	return {$: 5, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$danger = $rundis$elm_bootstrap$Bootstrap$Form$Select$Validation(1);
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Disabled = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$disabled = function (disabled_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Select$Disabled(disabled_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Id = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$id = function (id_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Select$Id(id_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Item = $elm$core$Basics$identity;
var $elm$html$Html$option = _VirtualDom_node('option');
var $rundis$elm_bootstrap$Bootstrap$Form$Select$item = F2(
	function (attributes, children) {
		return A2($elm$html$Html$option, attributes, children);
	});
var $author$project$Lib$MiscUtils$maybeCons = F2(
	function (maybeItem, list) {
		if (!maybeItem.$) {
			var item = maybeItem.a;
			return A2($elm$core$List$cons, item, list);
		} else {
			return list;
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$OnChange = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$onChange = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Select$OnChange(toMsg);
};
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Lib$Form$FormView$renderSelectField = F2(
	function (_v0, _v1) {
		var onChange = _v0.r;
		var onFocus = _v0.M;
		var disabled = _v0.h;
		var value = _v0.kg;
		var error = _v0.Z;
		var showError = _v0.B;
		var label = _v0.h0;
		var id = _v0.bZ;
		var options = _v1.ae;
		var placeholder = _v1.iP;
		var toOption = function (_v3) {
			var key = _v3.a;
			var label_ = _v3.b;
			return A2(
				$rundis$elm_bootstrap$Bootstrap$Form$Select$item,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(key),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(value, key))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label_)
					]));
		};
		var selectedOptionExists = A2(
			$elm$core$List$any,
			function (_v2) {
				var key = _v2.a;
				return _Utils_eq(key, value);
			},
			options);
		var placeholderOption = A2(
			$elm$core$Maybe$map,
			function (placeHolder) {
				return A2(
					$rundis$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$selected((value === '') || (!selectedOptionExists))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('-- ' + (placeHolder + ' --'))
						]));
			},
			placeholder);
		return A4(
			$author$project$Lib$Form$FormView$withLabelAndError,
			label,
			showError,
			error,
			A2(
				$rundis$elm_bootstrap$Bootstrap$Form$Select$custom,
				A3(
					$author$project$Lib$MiscUtils$consIf,
					showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error),
					$rundis$elm_bootstrap$Bootstrap$Form$Select$danger,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Form$Select$onChange(onChange),
							$rundis$elm_bootstrap$Bootstrap$Form$Select$id(id),
							$rundis$elm_bootstrap$Bootstrap$Form$Select$disabled(disabled),
							$rundis$elm_bootstrap$Bootstrap$Form$Select$attrs(
							_List_fromArray(
								[
									$elm$html$Html$Events$onFocus(onFocus)
								]))
						])),
				A2(
					$author$project$Lib$MiscUtils$maybeCons,
					placeholderOption,
					A2($elm$core$List$map, toOption, options))));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Attrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Validation = function (a) {
	return {$: 5, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$danger = $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Validation(1);
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Disabled = {$: 2};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$disabled = $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Disabled;
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Id = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$id = function (id_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Id(id_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$OnInput = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$onInput = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$OnInput(toMsg);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Textarea = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$create = function (options) {
	return {ae: options};
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						bZ: $elm$core$Maybe$Just(id_)
					});
			case 1:
				var rows_ = modifier.a;
				return _Utils_update(
					options,
					{
						cE: $elm$core$Maybe$Just(rows_)
					});
			case 2:
				return _Utils_update(
					options,
					{h: true});
			case 3:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{
						kg: $elm$core$Maybe$Just(value_)
					});
			case 4:
				var onInput_ = modifier.a;
				return _Utils_update(
					options,
					{
						cg: $elm$core$Maybe$Just(onInput_)
					});
			case 5:
				var validation = modifier.a;
				return _Utils_update(
					options,
					{
						e7: $elm$core$Maybe$Just(validation)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						aK: _Utils_ap(options.aK, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$defaultOptions = {aK: _List_Nil, h: false, bZ: $elm$core$Maybe$Nothing, cg: $elm$core$Maybe$Nothing, cE: $elm$core$Maybe$Nothing, e7: $elm$core$Maybe$Nothing, kg: $elm$core$Maybe$Nothing};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$validationAttribute = function (validation) {
	return $elm$html$Html$Attributes$class(
		$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control'),
				$elm$html$Html$Attributes$disabled(options.h)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.bZ),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, options.cE),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, options.kg),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, options.cg),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$validationAttribute, options.e7)
					])),
			options.aK));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$view = function (_v0) {
	var options = _v0.ae;
	return A2(
		$elm$html$Html$textarea,
		$rundis$elm_bootstrap$Bootstrap$Form$Textarea$toAttributes(options),
		_List_Nil);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$textarea = A2($elm$core$Basics$composeL, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$view, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$create);
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Value = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$value = function (value_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Value(value_);
};
var $author$project$Lib$Form$FormView$renderTextareaField = F2(
	function (_v0, _v1) {
		var onChange = _v0.r;
		var onFocus = _v0.M;
		var onBlur = _v0.D;
		var disabled = _v0.h;
		var value = _v0.kg;
		var error = _v0.Z;
		var showError = _v0.B;
		var label = _v0.h0;
		var id = _v0.bZ;
		var placeholder = _v1.iP;
		return A4(
			$author$project$Lib$Form$FormView$withLabelAndError,
			label,
			showError,
			error,
			$rundis$elm_bootstrap$Bootstrap$Form$Textarea$textarea(
				A3(
					$author$project$Lib$MiscUtils$consIf,
					disabled,
					$rundis$elm_bootstrap$Bootstrap$Form$Textarea$disabled,
					A3(
						$author$project$Lib$MiscUtils$consIf,
						showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error),
						$rundis$elm_bootstrap$Bootstrap$Form$Textarea$danger,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$onInput(onChange),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$id(id),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$value(value),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$attrs(
								A3(
									$author$project$Lib$Form$FormView$withMaybeAttribute,
									$elm$html$Html$Events$onBlur,
									onBlur,
									_List_fromArray(
										[
											$elm$html$Html$Events$onFocus(onFocus),
											$elm$html$Html$Attributes$placeholder(placeholder)
										])))
							])))));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Input$Search = 10;
var $rundis$elm_bootstrap$Bootstrap$Form$Input$search = $rundis$elm_bootstrap$Bootstrap$Form$Input$input(10);
var $rundis$elm_bootstrap$Bootstrap$Form$Input$text = $rundis$elm_bootstrap$Bootstrap$Form$Input$input(0);
var $author$project$Lib$Form$FormView$renderField = F2(
	function (fieldConfig, _v0) {
		var onChange = fieldConfig.r;
		var setFocusedCodeField = fieldConfig.dA;
		var onBlur = fieldConfig.D;
		var disabled = fieldConfig.h;
		var showError = fieldConfig.B;
		var id = fieldConfig.bZ;
		var field = _v0.a;
		var maybeError = _v0.b;
		var blur = function (label) {
			return A2(
				$elm$core$Maybe$map,
				function (onBlurEvent) {
					return onBlurEvent(label);
				},
				onBlur);
		};
		var createFieldConfig = F3(
			function (update, label, value) {
				return {
					h: disabled,
					Z: maybeError,
					bZ: id,
					h0: label,
					D: blur(label),
					r: A2($elm$core$Basics$composeR, update, onChange),
					M: setFocusedCodeField($elm$core$Maybe$Nothing),
					B: showError(label),
					kg: value
				};
			});
		switch (field.$) {
			case 0:
				var value = field.a.kg;
				var attributes = field.a.aK;
				return A2($author$project$Lib$Form$FormView$renderConstantField, value, attributes);
			case 1:
				var type_ = field.a;
				var update = field.b.dK;
				var value = field.b.kg;
				var attributes = field.b.aK;
				var config = A3(createFieldConfig, update, attributes.h0, value);
				switch (type_) {
					case 0:
						return A3($author$project$Lib$Form$FormView$renderInputField, $rundis$elm_bootstrap$Bootstrap$Form$Input$text, config, attributes);
					case 3:
						return A2($author$project$Lib$Form$FormView$renderTextareaField, config, attributes);
					case 2:
						return A3($author$project$Lib$Form$FormView$renderInputField, $rundis$elm_bootstrap$Bootstrap$Form$Input$password, config, attributes);
					case 1:
						return A3($author$project$Lib$Form$FormView$renderInputField, $rundis$elm_bootstrap$Bootstrap$Form$Input$email, config, attributes);
					default:
						return A3($author$project$Lib$Form$FormView$renderInputField, $rundis$elm_bootstrap$Bootstrap$Form$Input$search, config, attributes);
				}
			case 2:
				var attributes = field.a.aK;
				var value = field.a.kg;
				var update = field.a.dK;
				return A2(
					$author$project$Lib$Form$FormView$renderNumberField,
					A3(createFieldConfig, update, attributes.h0, value),
					attributes);
			case 3:
				var field_ = field.a;
				var attributes = field_.aK;
				var value = field_.kg;
				var update = field_.dK;
				var textFieldAttrs = {bx: $elm$core$Maybe$Nothing, h0: attributes.h0, iP: attributes.iP};
				var baseConfig = A3(createFieldConfig, update, attributes.h0, value);
				var config = _Utils_update(
					baseConfig,
					{
						M: setFocusedCodeField(
							$elm$core$Maybe$Just(field_))
					});
				return A3($author$project$Lib$Form$FormView$renderInputField, $rundis$elm_bootstrap$Bootstrap$Form$Input$text, config, textFieldAttrs);
			case 4:
				var attributes = field.a.aK;
				var value = field.a.kg;
				var update = field.a.dK;
				return A2(
					$author$project$Lib$Form$FormView$renderCheckboxField,
					A3(createFieldConfig, update, attributes.h0, value),
					attributes);
			case 5:
				var attributes = field.a.aK;
				var value = field.a.kg;
				var update = field.a.dK;
				return A2(
					$author$project$Lib$Form$FormView$renderSelectField,
					A3(createFieldConfig, update, attributes.h0, value),
					attributes);
			case 6:
				var fields = field.a;
				return $author$project$Lib$Form$FormView$renderGroup(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Lib$Form$FormView$maybeIgnoreChildError(maybeError),
							$author$project$Lib$Form$FormView$renderField(fieldConfig)),
						fields));
			case 7:
				var title = field.a;
				var fields = field.b;
				return A2(
					$author$project$Lib$Form$FormView$renderSection,
					title,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, item) {
								var newFieldConfig = _Utils_update(
									fieldConfig,
									{
										bZ: id + ('_' + $elm$core$String$fromInt(index))
									});
								return A2(
									$elm$core$Basics$composeR,
									$author$project$Lib$Form$FormView$maybeIgnoreChildError(maybeError),
									$author$project$Lib$Form$FormView$renderField(newFieldConfig))(item);
							}),
						fields));
			default:
				var forms = field.a.ef;
				var add = field.a.dQ;
				var attributes = field.a.aK;
				return $author$project$Lib$Form$FormView$renderFormList(
					{
						dQ: A2(
							$elm$core$Maybe$map,
							function (addLabel) {
								return {
									dN: A2($elm$core$Basics$composeR, add, onChange),
									h0: addLabel
								};
							},
							attributes.fi),
						h: disabled,
						ef: A2(
							$elm$core$List$indexedMap,
							F2(
								function (listItemIndex, _v3) {
									var fields = _v3.b;
									var _delete = _v3.d2;
									var move = _v3.ex;
									var idPrefix = A2($author$project$Lib$Form$FormView$appendToId, id, listItemIndex);
									var fieldMapper = F2(
										function (index, field_) {
											return A2(
												$author$project$Lib$Form$FormView$renderField,
												_Utils_update(
													fieldConfig,
													{
														bZ: A2($author$project$Lib$Form$FormView$appendToId, idPrefix, index)
													}),
												field_);
										});
									return $author$project$Lib$Form$FormView$renderFormListItem(
										{
											d2: attributes.gA ? $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, _delete, onChange)) : $elm$core$Maybe$Nothing,
											h: disabled,
											b: A2($elm$core$List$indexedMap, fieldMapper, fields),
											ex: A2(
												$author$project$Utils$MaybeUtils$fromBool,
												A2($elm$core$Basics$composeR, move, onChange),
												attributes.iH)
										});
								}),
							forms),
						h0: attributes.h0
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Flex$alignSelfStart = $elm$html$Html$Attributes$class('align-self-start');
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter = {$: 37};
var $Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent = F7(
	function (altKey, ctrlKey, key, keyCode, metaKey, repeat, shiftKey) {
		return {fn: altKey, gl: ctrlKey, h_: key, h$: keyCode, ih: metaKey, i4: repeat, jB: shiftKey};
	});
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKey = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return $elm$core$String$isEmpty(key) ? $elm$json$Json$Decode$fail('empty key') : $elm$json$Json$Decode$succeed(key);
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		return (!code) ? $elm$json$Json$Decode$fail('code was zero') : $elm$json$Json$Decode$succeed(code);
	},
	$elm$json$Json$Decode$int);
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'keyCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'which', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'charCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			$elm$json$Json$Decode$succeed(0)
		]));
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$A = {$: 0};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add = {$: 85};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt = {$: 32};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous = function (a) {
	return {$: 89, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$B = {$: 1};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace = {$: 38};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$C = {$: 2};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock = {$: 34};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch = {$: 59};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command = {$: 58};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl = function (a) {
	return {$: 31, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$D = {$: 3};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal = {$: 87};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete = {$: 39};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide = {$: 88};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down = {$: 29};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$E = {$: 4};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight = {$: 52};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$End = {$: 42};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape = {$: 36};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F = {$: 5};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1 = {$: 62};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10 = {$: 71};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11 = {$: 72};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12 = {$: 73};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2 = {$: 63};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3 = {$: 64};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4 = {$: 65};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5 = {$: 66};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6 = {$: 67};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7 = {$: 68};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8 = {$: 69};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9 = {$: 70};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five = {$: 49};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four = {$: 48};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$G = {$: 6};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$H = {$: 7};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home = {$: 43};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$I = {$: 8};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert = {$: 54};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$J = {$: 9};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$K = {$: 10};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$L = {$: 11};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left = {$: 26};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$M = {$: 12};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply = {$: 84};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$N = {$: 13};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine = {$: 53};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock = {$: 60};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight = {$: 82};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive = {$: 79};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour = {$: 78};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine = {$: 83};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne = {$: 75};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven = {$: 81};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix = {$: 80};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree = {$: 77};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo = {$: 76};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero = {$: 74};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$O = {$: 14};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$One = {$: 45};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$P = {$: 15};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown = {$: 41};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp = {$: 40};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak = {$: 56};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen = {$: 55};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q = {$: 16};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$R = {$: 17};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right = {$: 27};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$S = {$: 18};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock = {$: 61};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven = {$: 51};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift = function (a) {
	return {$: 30, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six = {$: 50};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar = {$: 35};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract = {$: 86};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$T = {$: 19};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab = {$: 33};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three = {$: 47};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two = {$: 46};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$U = {$: 20};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown = function (a) {
	return {$: 90, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up = {$: 28};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$V = {$: 21};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$W = {$: 22};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows = {$: 57};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$X = {$: 23};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y = {$: 24};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z = {$: 25};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero = {$: 44};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode = function (keyCode) {
	switch (keyCode) {
		case 8:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace;
		case 9:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab;
		case 13:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter;
		case 16:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift($elm$core$Maybe$Nothing);
		case 17:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl($elm$core$Maybe$Nothing);
		case 18:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt;
		case 19:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak;
		case 20:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock;
		case 27:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape;
		case 32:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar;
		case 33:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp;
		case 34:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown;
		case 35:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$End;
		case 36:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home;
		case 37:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left;
		case 38:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up;
		case 39:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right;
		case 40:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down;
		case 44:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen;
		case 45:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert;
		case 46:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete;
		case 48:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero;
		case 49:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$One;
		case 50:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two;
		case 51:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three;
		case 52:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four;
		case 53:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five;
		case 54:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six;
		case 55:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven;
		case 56:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight;
		case 57:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine;
		case 65:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$A;
		case 66:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$B;
		case 67:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$C;
		case 68:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$D;
		case 69:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$E;
		case 70:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F;
		case 71:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$G;
		case 72:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$H;
		case 73:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$I;
		case 74:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$J;
		case 75:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$K;
		case 76:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$L;
		case 77:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$M;
		case 78:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$N;
		case 79:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$O;
		case 80:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$P;
		case 81:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q;
		case 82:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$R;
		case 83:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$S;
		case 84:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$T;
		case 85:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$U;
		case 86:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$V;
		case 87:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$W;
		case 88:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$X;
		case 89:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y;
		case 90:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z;
		case 91:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous(
				_List_fromArray(
					[$SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command, $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch]));
		case 96:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero;
		case 97:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne;
		case 98:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo;
		case 99:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree;
		case 100:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour;
		case 101:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive;
		case 102:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix;
		case 103:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven;
		case 104:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight;
		case 105:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine;
		case 106:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply;
		case 107:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add;
		case 109:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract;
		case 110:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal;
		case 111:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide;
		case 112:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1;
		case 113:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2;
		case 114:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3;
		case 115:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4;
		case 116:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5;
		case 117:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6;
		case 118:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7;
		case 119:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8;
		case 120:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9;
		case 121:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10;
		case 122:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11;
		case 123:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12;
		case 144:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock;
		case 145:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock;
		default:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown(keyCode);
	}
};
var $elm$json$Json$Decode$map7 = _Json_map7;
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent = A8(
	$elm$json$Json$Decode$map7,
	$Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	$Gizra$elm_keyboard_event$Keyboard$Event$decodeKey,
	A2($elm$json$Json$Decode$map, $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $author$project$Lib$Form$FormView$submitOnCtrlEnterAttr = function (onSubmit) {
	var isCtrlEnter = function (keyEvent) {
		return (_Utils_eq(keyEvent.h$, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter) && keyEvent.gl) ? $elm$json$Json$Decode$succeed(onSubmit) : $elm$json$Json$Decode$fail('');
	};
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$andThen, isCtrlEnter, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent));
};
var $author$project$Lib$Form$FormView$renderForm = function (_v0) {
	var loadingLabel = _v0.a0;
	var onSubmit = _v0.dn;
	var action = _v0.dN;
	var state = _v0.F;
	var fields = _v0.b;
	var submitOnCtrlEnter = _v0.a8;
	var rootOnEnterAttrs = function () {
		var _v1 = _Utils_Tuple2(onSubmit, submitOnCtrlEnter);
		if ((!_v1.a.$) && _v1.b) {
			var onSubmit_ = _v1.a.a;
			return _List_fromArray(
				[
					$author$project$Lib$Form$FormView$submitOnCtrlEnterAttr(onSubmit_)
				]);
		} else {
			return _List_Nil;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-root')
				]),
			rootOnEnterAttrs),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-body')
					]),
				fields),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-footer')
					]),
				_List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Button$button,
						A2(
							$author$project$Lib$MiscUtils$maybeCons,
							A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Button$onClick, onSubmit),
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Button$primary,
									$rundis$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rundis$elm_bootstrap$Bootstrap$Utilities$Flex$alignSelfStart,
											$elm$html$Html$Attributes$disabled(
											_Utils_eq(onSubmit, $elm$core$Maybe$Nothing) || _Utils_eq(state, $author$project$Lib$Form$LoadStatus$InProgress))
										]))
								])),
						_Utils_eq(state, $author$project$Lib$Form$LoadStatus$InProgress) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('spinner-border spinner-border-sm mr-2')
									]),
								_List_Nil),
								$elm$html$Html$text(loadingLabel)
							]) : _List_fromArray(
							[
								$elm$html$Html$text(action)
							]))
					]))
			]));
};
var $author$project$Lib$Form$FormView$asHtml = F3(
	function (_v0, form_, model) {
		var loadingLabel = _v0.a0;
		var onChange = _v0.r;
		var actionLabel = _v0.dP;
		var validation = _v0.e7;
		var submitOnCtrlEnter = _v0.a8;
		var id = _v0.bZ;
		var errorTracking = function (_v4) {
			var e = _v4;
			return e;
		}(model.aR);
		var onBlur = function () {
			if (!validation) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					function (label) {
						return onChange(
							_Utils_update(
								model,
								{
									aR: _Utils_update(
										errorTracking,
										{
											cK: A2($elm$core$Set$insert, label, errorTracking.cK)
										})
								}));
					});
			}
		}();
		var showError = function (label) {
			return errorTracking.cJ || A2($elm$core$Set$member, label, errorTracking.cK);
		};
		var fieldToElement = function (index) {
			return $author$project$Lib$Form$FormView$renderField(
				{
					h: _Utils_eq(model.F, $author$project$Lib$Form$LoadStatus$InProgress),
					bZ: id + ('_' + $elm$core$String$fromInt(index)),
					D: onBlur,
					r: function (values) {
						return onChange(
							_Utils_update(
								model,
								{e8: values}));
					},
					dA: function (maybeCodeField) {
						return onChange(
							_Utils_update(
								model,
								{_: maybeCodeField}));
					},
					B: showError
				});
		};
		var _v1 = A2($author$project$Lib$Form$Form$fill, form_, model.e8);
		var fields = _v1.b;
		var result = _v1.c;
		var onSubmit = function () {
			if (!result.$) {
				var msg = result.a;
				return _Utils_eq(model.F, $author$project$Lib$Form$LoadStatus$InProgress) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(msg);
			} else {
				return errorTracking.cJ ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					onChange(
						_Utils_update(
							model,
							{
								aR: _Utils_update(
									errorTracking,
									{cJ: true})
							})));
			}
		}();
		return $author$project$Lib$Form$FormView$renderForm(
			{
				dN: actionLabel,
				b: A2($elm$core$List$indexedMap, fieldToElement, fields),
				a0: loadingLabel,
				dn: onSubmit,
				F: model.F,
				a8: submitOnCtrlEnter
			});
	});
var $author$project$Pages$Main$FormViewHelpers$renderCommonForm = function (_v0) {
	var onChange = _v0.r;
	var id = _v0.bZ;
	var form = _v0.ed;
	var formModel = _v0.ee;
	return A3(
		$author$project$Lib$Form$FormView$asHtml,
		{dP: 'Tallenna', bZ: id, a0: 'Tallennetaan', r: onChange, a8: true, e7: 1},
		form,
		formModel);
};
var $author$project$Pages$Main$EnvironmentsView$renderEditEnvironmentForm = F2(
	function (formModel, config) {
		return A3(
			$author$project$Pages$Main$FormViewHelpers$editEntityView,
			$author$project$Pages$Main$EnvironmentsView$EditFormBackButtonClicked,
			'Muokkaa ympäristöä',
			_List_fromArray(
				[
					$author$project$Pages$Main$FormViewHelpers$renderCommonForm(
					{
						ed: A2(
							$author$project$Lib$Form$Form$map,
							$author$project$Pages$Main$EnvironmentsView$BeginSaveEnvironment,
							$author$project$Forms$EnvironmentForms$makeEnvironmentForm(config)),
						ee: formModel,
						bZ: 'edit_environment',
						r: $author$project$Pages$Main$EnvironmentsView$EnvironmentFormChanged
					})
				]));
	});
var $author$project$Pages$Main$EnvironmentsView$GroupFormChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Forms$CommonForms$nameField = $author$project$Lib$Form$Form$textField(
	{
		aK: {bx: $elm$core$Maybe$Nothing, h0: 'Nimi', iP: ''},
		u: $elm$core$Result$Ok,
		dK: F2(
			function (value, values) {
				return _Utils_update(
					values,
					{is: value});
			}),
		kg: function ($) {
			return $.is;
		}
	});
var $author$project$Forms$GenericEntityGroupForm$genericEntityGroupForm = A2(
	$author$project$Lib$Form$Form$append,
	$author$project$Forms$CommonForms$constantMetaField(
		function ($) {
			return $.dp;
		}),
	A2(
		$author$project$Lib$Form$Form$append,
		$author$project$Forms$CommonForms$descriptionField,
		A2(
			$author$project$Lib$Form$Form$append,
			$author$project$Forms$CommonForms$nameField,
			A2(
				$author$project$Lib$Form$Form$append,
				$author$project$Forms$CommonForms$aproProjectIdField,
				A2(
					$author$project$Lib$Form$Form$append,
					$author$project$Forms$CommonForms$constantMetaField(
						function ($) {
							return $.cr;
						}),
					A2(
						$author$project$Lib$Form$Form$append,
						$author$project$Forms$CommonForms$idField,
						$author$project$Lib$Form$Form$succeed($author$project$Entity$GenericEntityGroup$GenericEntityGroup)))))));
var $author$project$Pages$Main$EnvironmentsView$renderEditGroupView = function (formModel) {
	return A3(
		$author$project$Pages$Main$FormViewHelpers$editEntityView,
		$author$project$Pages$Main$EnvironmentsView$EditFormBackButtonClicked,
		'Muokkaa ryhmää',
		_List_fromArray(
			[
				$author$project$Pages$Main$FormViewHelpers$renderCommonForm(
				{
					ed: A2($author$project$Lib$Form$Form$map, $author$project$Pages$Main$EnvironmentsView$BeginSaveGroup, $author$project$Forms$GenericEntityGroupForm$genericEntityGroupForm),
					ee: formModel,
					bZ: 'edit_environment_group',
					r: $author$project$Pages$Main$EnvironmentsView$GroupFormChanged
				})
			]));
};
var $author$project$Lib$RemoteData$succeed = $author$project$Lib$RemoteData$Success;
var $author$project$Pages$Main$EnvironmentsView$renderEditView = F2(
	function (model, repository) {
		var _v0 = model.l;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var formModel = _v0.a;
				return A2(
					$author$project$Utils$CommonView$renderWebData,
					$author$project$Pages$Main$EnvironmentsView$renderEditEnvironmentForm(formModel),
					A2(
						$author$project$Lib$RemoteData$map,
						$author$project$Forms$EnvironmentForms$EnvironmentFormConfig,
						$author$project$Lib$RemoteData$succeed($elm$core$Dict$empty)));
			default:
				var formModel = _v0.a;
				return $author$project$Pages$Main$EnvironmentsView$renderEditGroupView(formModel);
		}
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewEntity = {$: 6};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewGroup = {$: 7};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditElement = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginRefresh = {$: 3};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$ConfirmDeleteElement = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Main$FormViewHelpers$entityActionButton = F3(
	function (icon, options, innerHtml) {
		return A3(
			$author$project$Utils$CommonView$iconButton,
			icon,
			A2($elm$core$List$cons, $rundis$elm_bootstrap$Bootstrap$Button$primary, options),
			innerHtml);
	});
var $author$project$Utils$Visibility$isHidden = function (visibility) {
	if (visibility === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Lib$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$5:
		while (true) {
			_v0$6:
			while (true) {
				_v0$7:
				while (true) {
					switch (_v0.a.$) {
						case 1:
							switch (_v0.b.$) {
								case 1:
									var f = _v0.a.a;
									var value = _v0.b.a;
									return $author$project$Lib$RemoteData$Loading(
										f(value));
								case 3:
									var f = _v0.a.a;
									var value = _v0.b.a;
									return $author$project$Lib$RemoteData$Loading(
										f(value));
								case 2:
									break _v0$5;
								default:
									break _v0$7;
							}
						case 3:
							switch (_v0.b.$) {
								case 3:
									var f = _v0.a.a;
									var value = _v0.b.a;
									return $author$project$Lib$RemoteData$Success(
										f(value));
								case 1:
									var f = _v0.a.a;
									var value = _v0.b.a;
									return $author$project$Lib$RemoteData$Loading(
										f(value));
								case 2:
									break _v0$5;
								default:
									break _v0$7;
							}
						case 2:
							var error = _v0.a.a;
							return $author$project$Lib$RemoteData$Failure(error);
						default:
							switch (_v0.b.$) {
								case 2:
									break _v0$5;
								case 0:
									break _v0$6;
								default:
									break _v0$6;
							}
					}
				}
				var _v2 = _v0.b;
				return $author$project$Lib$RemoteData$EmptyLoading;
			}
			var _v1 = _v0.a;
			return $author$project$Lib$RemoteData$EmptyLoading;
		}
		var error = _v0.b.a;
		return $author$project$Lib$RemoteData$Failure(error);
	});
var $author$project$Lib$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$author$project$Lib$RemoteData$andMap,
			b,
			A2($author$project$Lib$RemoteData$map, f, a));
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Pages$Main$EntityListing$TreeView$LeafElement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$EntityListing$TreeView$NodeElement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$TreeViewStateChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$EntityListing$TreeElement$GroupTreeElement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Main$EntityListing$TreeElement$getParentGroupOfElement = F2(
	function (allGroups, element) {
		var getGroupById = function (id) {
			return A2(
				$elm_community$list_extra$List$Extra$find,
				function (g) {
					return _Utils_eq(g.bZ, id);
				},
				allGroups);
		};
		return A2(
			$elm$core$Maybe$andThen,
			getGroupById,
			$author$project$Pages$Main$EntityListing$TreeElement$getParentIdOfElement(element));
	});
var $author$project$Pages$Main$EntityListing$TreeElement$getAllAncestors = F2(
	function (allGroups, element) {
		var _v0 = A2($author$project$Pages$Main$EntityListing$TreeElement$getParentGroupOfElement, allGroups, element);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var parentGroup = _v0.a;
			return A2(
				$elm$core$List$cons,
				parentGroup,
				A2(
					$author$project$Pages$Main$EntityListing$TreeElement$getAllAncestors,
					allGroups,
					$author$project$Pages$Main$EntityListing$TreeElement$GroupTreeElement(parentGroup)));
		}
	});
var $author$project$Pages$Main$EntityListing$TreeElement$getIdOfElement = function (element) {
	if (!element.$) {
		var entity = element.a;
		return entity.bZ;
	} else {
		var group = element.a;
		return group.bZ;
	}
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Pages$Main$EntityListing$TreeElement$getAllDescendants = F2(
	function (allElements, element) {
		var _v0 = A2(
			$elm$core$List$partition,
			function (el) {
				return _Utils_eq(
					$author$project$Pages$Main$EntityListing$TreeElement$getParentIdOfElement(el),
					$elm$core$Maybe$Just(
						$author$project$Pages$Main$EntityListing$TreeElement$getIdOfElement(element)));
			},
			allElements);
		var directChildren = _v0.a;
		var others = _v0.b;
		return _Utils_ap(
			directChildren,
			A2(
				$elm$core$List$concatMap,
				$author$project$Pages$Main$EntityListing$TreeElement$getAllDescendants(others),
				directChildren));
	});
var $author$project$Pages$Main$EntityListing$TreeElement$getGroupElements = $elm$core$List$filterMap(
	function (el) {
		if (el.$ === 1) {
			var group = el.a;
			return $elm$core$Maybe$Just(group);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Pages$Main$EntityListing$EntityListingFilters$applyNonEmptyFilter = F3(
	function (filter, filterValue, allElements) {
		var directResults = A2(
			$elm$core$List$filter,
			function (treeElement) {
				if (!treeElement.$) {
					var entity = treeElement.a;
					return A2(filter.bN, filterValue, entity);
				} else {
					var group = treeElement.a;
					return A2(filter.bO, filterValue, group);
				}
			},
			allElements);
		var descendants = A2(
			$elm$core$List$concatMap,
			$author$project$Pages$Main$EntityListing$TreeElement$getAllDescendants(allElements),
			directResults);
		var allGroups = $author$project$Pages$Main$EntityListing$TreeElement$getGroupElements(allElements);
		var ancestors = A2(
			$elm$core$List$map,
			$author$project$Pages$Main$EntityListing$TreeElement$GroupTreeElement,
			A2(
				$elm$core$List$concatMap,
				$author$project$Pages$Main$EntityListing$TreeElement$getAllAncestors(allGroups),
				directResults));
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			$author$project$Pages$Main$EntityListing$TreeElement$getIdOfElement,
			_Utils_ap(
				directResults,
				_Utils_ap(ancestors, descendants)));
	});
var $author$project$Pages$Main$EntityListing$EntityListingFilters$applyFilter = F3(
	function (filter, filterValue, allElements) {
		return $elm$core$String$isEmpty(filterValue) ? allElements : A3($author$project$Pages$Main$EntityListing$EntityListingFilters$applyNonEmptyFilter, filter, filterValue, allElements);
	});
var $author$project$Pages$Main$EntityListing$EntityListingFilters$applyFilters = F3(
	function (filters, filterValues, allElements) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (filter, acc) {
					var _v0 = A2($elm$core$Dict$get, filter.bZ, filterValues);
					if (!_v0.$) {
						var filterValue = _v0.a;
						return A3($author$project$Pages$Main$EntityListing$EntityListingFilters$applyFilter, filter, filterValue, acc);
					} else {
						return acc;
					}
				}),
			allElements,
			filters);
	});
var $author$project$Pages$Main$EntityListing$TreeElement$EntityTreeElement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Main$EntityListing$TreeElement$mapEntitiesAndGroupsToTreeElements = F2(
	function (entities, groups) {
		return _Utils_ap(
			A2($elm$core$List$map, $author$project$Pages$Main$EntityListing$TreeElement$EntityTreeElement, entities),
			A2($elm$core$List$map, $author$project$Pages$Main$EntityListing$TreeElement$GroupTreeElement, groups));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$DragDropMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$SelectTreeElement = function (a) {
	return {$: 8, a: a};
};
var $author$project$Lib$DragDrop$DragEnd = {$: 1};
var $author$project$Lib$DragDrop$DragStart = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Lib$DragDrop$onWithOptions = F3(
	function (name, _v0, decoder) {
		var stopPropagation = _v0.P;
		var preventDefault = _v0.O;
		return A2(
			$elm$html$Html$Events$custom,
			name,
			A2(
				$elm$json$Json$Decode$map,
				function (msg) {
					return {ev: msg, O: preventDefault, P: stopPropagation};
				},
				decoder));
	});
var $author$project$Lib$DragDrop$draggable = F2(
	function (wrap, drag) {
		return _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'draggable', 'true'),
				A3(
				$author$project$Lib$DragDrop$onWithOptions,
				'dragstart',
				{O: false, P: true},
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						wrap,
						$author$project$Lib$DragDrop$DragStart(drag)),
					$elm$json$Json$Decode$value)),
				A3(
				$author$project$Lib$DragDrop$onWithOptions,
				'dragend',
				{O: false, P: true},
				$elm$json$Json$Decode$succeed(
					wrap($author$project$Lib$DragDrop$DragEnd)))
			]);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$DropAreaConfig = F2(
	function (droppableAttrs, isActiveDropArea) {
		return {bM: droppableAttrs, b$: isActiveDropArea};
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$GroupDropArea = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$dropIdToMaybeGroup = function (dropId) {
	if (dropId.$ === 2) {
		var group = dropId.a;
		return $elm$core$Maybe$Just(group);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Lib$DragDrop$DragEnter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Lib$DragDrop$DragLeave = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$DragDrop$DragOver = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Lib$DragDrop$Drop = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Lib$DragDrop$Position = F4(
	function (width, height, x, y) {
		return {hy: height, kk: width, km: x, kn: y};
	});
var $author$project$Lib$DragDrop$positionDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Lib$DragDrop$Position,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['currentTarget', 'clientWidth']),
		$elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['currentTarget', 'clientHeight']),
		$elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$round,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$round,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetY']),
			$elm$json$Json$Decode$float)));
var $author$project$Lib$DragDrop$timeStampDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$round,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['timeStamp']),
		$elm$json$Json$Decode$float));
var $author$project$Lib$DragDrop$droppable = F2(
	function (wrap, dropId) {
		return _List_fromArray(
			[
				A3(
				$author$project$Lib$DragDrop$onWithOptions,
				'dragenter',
				{O: true, P: true},
				$elm$json$Json$Decode$succeed(
					wrap(
						$author$project$Lib$DragDrop$DragEnter(dropId)))),
				A3(
				$author$project$Lib$DragDrop$onWithOptions,
				'dragleave',
				{O: true, P: true},
				$elm$json$Json$Decode$succeed(
					wrap(
						$author$project$Lib$DragDrop$DragLeave(dropId)))),
				A3(
				$author$project$Lib$DragDrop$onWithOptions,
				'dragover',
				{O: true, P: true},
				A2(
					$elm$json$Json$Decode$map,
					wrap,
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Lib$DragDrop$DragOver(dropId),
						$author$project$Lib$DragDrop$timeStampDecoder,
						$author$project$Lib$DragDrop$positionDecoder))),
				A3(
				$author$project$Lib$DragDrop$onWithOptions,
				'drop',
				{O: true, P: true},
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						wrap,
						$author$project$Lib$DragDrop$Drop(dropId)),
					$author$project$Lib$DragDrop$positionDecoder))
			]);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$NotInDropArea = {$: 0};
var $author$project$Lib$DragDrop$getDropId = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var dragId = model.a;
			return $elm$core$Maybe$Nothing;
		default:
			var dragId = model.a;
			var dropId = model.b;
			return $elm$core$Maybe$Just(dropId);
	}
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$getActiveDropId = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Pages$Main$EntityListing$GenericEntityListingView$NotInDropArea,
		$author$project$Lib$DragDrop$getDropId(model.W));
};
var $author$project$Lib$DragDrop$getDragId = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var dragId = model.a;
			return $elm$core$Maybe$Just(dragId);
		default:
			var dragId = model.a;
			var dropId = model.b;
			return $elm$core$Maybe$Just(dragId);
	}
};
var $author$project$Lib$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$author$project$Lib$RemoteData$map($elm$core$Maybe$Just),
	$author$project$Lib$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$isAncestorOfGroup = F4(
	function (config, repository, group, possibleAncestor) {
		var _v0 = group.dp;
		if (_v0.$ === 1) {
			return false;
		} else {
			var actualParentId = _v0.a;
			var maybeActualParent = A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(actualParentId),
				$author$project$Lib$RemoteData$toMaybe(
					config.bQ(repository)));
			if (maybeActualParent.$ === 1) {
				return false;
			} else {
				var parent = maybeActualParent.a;
				return A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$isAncestorOfGroupOrSelf, config, repository, parent, possibleAncestor);
			}
		}
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$isAncestorOfGroupOrSelf = F4(
	function (config, repository, group, possibleAncestor) {
		return _Utils_eq(group.bZ, possibleAncestor.bZ) ? true : A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$isAncestorOfGroup, config, repository, group, possibleAncestor);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$groupIsCurrentlyDragged = F4(
	function (config, model, repository, group) {
		var currentlyDraggedGroup = function () {
			var _v1 = $author$project$Lib$DragDrop$getDragId(model.W);
			if ((!_v1.$) && (_v1.a.$ === 1)) {
				var group_ = _v1.a.a;
				return $elm$core$Maybe$Just(group_);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (currentlyDraggedGroup.$ === 1) {
			return false;
		} else {
			var draggedGroup = currentlyDraggedGroup.a;
			return A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$isAncestorOfGroupOrSelf, config, repository, group, draggedGroup);
		}
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$getGroupElementDropAreaConfig = F4(
	function (config, model, repository, group) {
		var groupIsCurrentlyDragged_ = A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$groupIsCurrentlyDragged, config, model, repository, group);
		var isActiveDropArea = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (activeDropAreaGroup) {
					return _Utils_eq(activeDropAreaGroup, group) && (!groupIsCurrentlyDragged_);
				},
				$author$project$Pages$Main$EntityListing$GenericEntityListingView$dropIdToMaybeGroup(
					$author$project$Pages$Main$EntityListing$GenericEntityListingView$getActiveDropId(model))));
		var droppableAttrs = (!groupIsCurrentlyDragged_) ? A2(
			$author$project$Lib$DragDrop$droppable,
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$DragDropMsg,
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$GroupDropArea(group)) : _List_Nil;
		return A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$DropAreaConfig, droppableAttrs, isActiveDropArea);
	});
var $elm$html$Html$Events$onDoubleClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dblclick',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$ElementSpanDropArea = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$elementsEquals = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var a_ = _v0.a.a;
					var b_ = _v0.b.a;
					return _Utils_eq(a_.bZ, b_.bZ);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 1) {
					var a_ = _v0.a.a;
					var b_ = _v0.b.a;
					return _Utils_eq(a_.bZ, b_.bZ);
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$getElementSpanDropAreaConfig = F2(
	function (model, targetLowerElement) {
		var isActiveDropArea = function () {
			var _v0 = $author$project$Pages$Main$EntityListing$GenericEntityListingView$getActiveDropId(model);
			if (_v0.$ === 3) {
				var activeDropArea = _v0.a;
				return A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$elementsEquals, targetLowerElement, activeDropArea.b4);
			} else {
				return false;
			}
		}();
		var droppableAttrs = A2(
			$author$project$Lib$DragDrop$droppable,
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$DragDropMsg,
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$ElementSpanDropArea(
				{b4: targetLowerElement}));
		return A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$DropAreaConfig, droppableAttrs, isActiveDropArea);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderElementSpanDropArea = F2(
	function (model, lowerElement) {
		var dropAreaConfig = A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$getElementSpanDropAreaConfig, model, lowerElement);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('tree-view__element-span-drop-area'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('active-drop-area', dropAreaConfig.b$)
							])),
					dropAreaConfig.bM)),
			_List_Nil);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeElement = F5(
	function (config, model, repository, element, columns) {
		var isSelected = _Utils_eq(
			model.E,
			$elm$core$Maybe$Just(element));
		var elementDropAreaConfig = function () {
			if (!element.$) {
				return {bM: _List_Nil, b$: false};
			} else {
				var group = element.a;
				return A4($author$project$Pages$Main$EntityListing$GenericEntityListingView$getGroupElementDropAreaConfig, config, model, repository, group);
			}
		}();
		var backgroundColorClass = function () {
			if (!element.$) {
				return 'tree-view__element--entity';
			} else {
				return 'tree-view__element--group';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tree-view__element-content-wrapper')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$renderElementSpanDropArea, model, element),
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Main$EntityListing$GenericEntityListingView$SelectTreeElement(element)),
								$elm$html$Html$Events$onDoubleClick(
								$author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditElement(element)),
								$elm$html$Html$Attributes$class('tree-view__element'),
								$elm$html$Html$Attributes$class(backgroundColorClass),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active-drop-area', elementDropAreaConfig.b$),
										_Utils_Tuple2('tree-view__element--selected', isSelected)
									]))
							]),
						_Utils_ap(
							A2($author$project$Lib$DragDrop$draggable, $author$project$Pages$Main$EntityListing$GenericEntityListingView$DragDropMsg, element),
							elementDropAreaConfig.bM)),
					columns)
				]));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeElementColumns = $elm$core$List$map(
	function (content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tree-element__col')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeViewEntityElementContent = F4(
	function (config, model, repository, entity) {
		return A5(
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeElement,
			config,
			model,
			repository,
			$author$project$Pages$Main$EntityListing$TreeElement$EntityTreeElement(entity),
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeElementColumns(
				config.eh(entity)));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeViewGroupElementContent = F4(
	function (config, model, repository, group) {
		return A5(
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeElement,
			config,
			model,
			repository,
			$author$project$Pages$Main$EntityListing$TreeElement$GroupTreeElement(group),
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeElementColumns(
				config.ei(group)));
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Pages$Main$EntityListing$TreeView$getElementParentKey = F2(
	function (config, el) {
		if (!el.$) {
			var node = el.a;
			return config.hu(node);
		} else {
			var leaf = el.a;
			return config.hs(leaf);
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ol = $elm$html$Html$Keyed$node('ol');
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Pages$Main$EntityListing$TreeView$renderIndents = function (depth) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tree-view__indent')
					]),
				_List_Nil);
		},
		A2($elm$core$List$range, 0, depth - 1));
};
var $author$project$Pages$Main$EntityListing$TreeView$renderElementWithIndents = F4(
	function (depth, attrs, htmlKey, content) {
		return _Utils_Tuple2(
			htmlKey,
			A2(
				$elm$html$Html$Lazy$lazy,
				function (content_) {
					return A2(
						$elm$html$Html$li,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('tree-view__element-wrapper'),
							attrs),
						_Utils_ap(
							$author$project$Pages$Main$EntityListing$TreeView$renderIndents(depth),
							_List_fromArray(
								[content_])));
				},
				content));
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Pages$Main$EntityListing$TreeView$toggleNode = F3(
	function (config, state, key) {
		var isOpen = A2($elm$core$Set$member, key, state.N);
		var openNodes = isOpen ? A2($elm$core$Set$remove, key, state.N) : A2($elm$core$Set$insert, key, state.N);
		var newState = _Utils_update(
			state,
			{N: openNodes});
		return config.dK(newState);
	});
var $author$project$Pages$Main$EntityListing$TreeView$viewLeaf = F3(
	function (config, depth, leaf) {
		return A4(
			$author$project$Pages$Main$EntityListing$TreeView$renderElementWithIndents,
			depth + 1,
			config.h2(leaf),
			'l_' + $elm$core$String$fromInt(
				config.hr(leaf)),
			config.i1(leaf));
	});
var $author$project$Pages$Main$EntityListing$TreeView$viewElement = F5(
	function (config, state, allElements, depth, element) {
		if (!element.$) {
			var node = element.a;
			return A5($author$project$Pages$Main$EntityListing$TreeView$viewNode, config, state, allElements, depth, node);
		} else {
			var leaf = element.a;
			return _List_fromArray(
				[
					A3($author$project$Pages$Main$EntityListing$TreeView$viewLeaf, config, depth, leaf)
				]);
		}
	});
var $author$project$Pages$Main$EntityListing$TreeView$viewNode = F5(
	function (config, state, allElements, depth, node) {
		var nodeKey = config.ht(node);
		var renderToggleIcon = F2(
			function (iconName, isVisible) {
				return A2(
					$author$project$Utils$CommonView$icon,
					iconName,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-wrapper'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('d-none', !isVisible)
								])),
							$elm$html$Html$Events$onClick(
							A3($author$project$Pages$Main$EntityListing$TreeView$toggleNode, config, state, nodeKey))
						]));
			});
		var isOpen = A2($elm$core$Set$member, nodeKey, state.N);
		var children = isOpen ? A5($author$project$Pages$Main$EntityListing$TreeView$viewNodeChildren, config, state, allElements, depth, nodeKey) : _List_Nil;
		return A2(
			$elm$core$List$cons,
			A4(
				$author$project$Pages$Main$EntityListing$TreeView$renderElementWithIndents,
				depth,
				_List_Nil,
				'n_' + $elm$core$String$fromInt(
					config.ht(node)),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tree-view__node')
						]),
					_List_fromArray(
						[
							A2(renderToggleIcon, 'chevron-up', isOpen),
							A2(renderToggleIcon, 'chevron-down', !isOpen),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content-wrapper')
								]),
							_List_fromArray(
								[
									config.i3(node)
								]))
						]))),
			children);
	});
var $author$project$Pages$Main$EntityListing$TreeView$viewNodeChildren = F5(
	function (config, state, allElements, parentDepth, nodeKey) {
		var childElements = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Main$EntityListing$TreeView$getElementParentKey(config),
				$elm$core$Basics$eq(
					$elm$core$Maybe$Just(nodeKey))),
			allElements);
		var childDepth = parentDepth + 1;
		return A2(
			$elm$core$List$concatMap,
			A4($author$project$Pages$Main$EntityListing$TreeView$viewElement, config, state, allElements, childDepth),
			childElements);
	});
var $author$project$Pages$Main$EntityListing$TreeView$view = F3(
	function (config, _v0, allElements) {
		var state = _v0;
		var rootElements = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Main$EntityListing$TreeView$getElementParentKey(config),
				$elm$core$Basics$eq($elm$core$Maybe$Nothing)),
			allElements);
		var rootDepth = 0;
		return A2(
			$elm$html$Html$Keyed$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tree-view__root')
				]),
			A2(
				$elm$core$List$concatMap,
				A4($author$project$Pages$Main$EntityListing$TreeView$viewElement, config, state, allElements, rootDepth),
				rootElements));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderEntityTree = F5(
	function (config, model, repository, allEntities, allGroups) {
		var treeElementToTreeViewElement = function (el) {
			if (!el.$) {
				var e = el.a;
				return $author$project$Pages$Main$EntityListing$TreeView$LeafElement(e);
			} else {
				var g = el.a;
				return $author$project$Pages$Main$EntityListing$TreeView$NodeElement(g);
			}
		};
		var treeViewElements = A2(
			$elm$core$List$map,
			treeElementToTreeViewElement,
			A2(
				$elm$core$List$sortBy,
				$author$project$Pages$Main$EntityListing$TreeElement$getPositionOfElement,
				A3(
					$author$project$Pages$Main$EntityListing$EntityListingFilters$applyFilters,
					config.da,
					model.ar,
					A2($author$project$Pages$Main$EntityListing$TreeElement$mapEntitiesAndGroupsToTreeElements, allEntities, allGroups))));
		return A3(
			$author$project$Pages$Main$EntityListing$TreeView$view,
			{
				hr: function ($) {
					return $.bZ;
				},
				hs: function ($) {
					return $.hw;
				},
				ht: function ($) {
					return $.bZ;
				},
				hu: function ($) {
					return $.dp;
				},
				h2: $elm$core$Basics$always(_List_Nil),
				i1: A3($author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeViewEntityElementContent, config, model, repository),
				i3: A3($author$project$Pages$Main$EntityListing$GenericEntityListingView$renderTreeViewGroupElementContent, config, model, repository),
				dK: $author$project$Pages$Main$EntityListing$GenericEntityListingView$TreeViewStateChanged
			},
			model.cP,
			treeViewElements);
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$RootDropArea = {$: 1};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderRootDropArea = function (model) {
	var rootDropAreaIsActive = _Utils_eq(
		$author$project$Pages$Main$EntityListing$GenericEntityListingView$getActiveDropId(model),
		$author$project$Pages$Main$EntityListing$GenericEntityListingView$RootDropArea);
	var isDragging = !_Utils_eq(
		$author$project$Lib$DragDrop$getDragId(model.W),
		$elm$core$Maybe$Nothing);
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tree-view__root-drop-area'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active-drop-area', rootDropAreaIsActive),
							_Utils_Tuple2('d-none', !isDragging)
						]))
				]),
			A2($author$project$Lib$DragDrop$droppable, $author$project$Pages$Main$EntityListing$GenericEntityListingView$DragDropMsg, $author$project$Pages$Main$EntityListing$GenericEntityListingView$RootDropArea)),
		_List_fromArray(
			[
				$elm$html$Html$text('Siirrä juuritasolle viimeiseksi')
			]));
};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderCommandTreeWithRootDropArea = F5(
	function (config, model, repository, allEntities, allGroups) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tree-view__container')
				]),
			_List_fromArray(
				[
					A5($author$project$Pages$Main$EntityListing$GenericEntityListingView$renderEntityTree, config, model, repository, allEntities, allGroups),
					$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderRootDropArea(model)
				]));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$maybeRenderTreeView = F3(
	function (config, model, repository) {
		return A2(
			$author$project$Utils$CommonView$renderWebData,
			function (_v0) {
				var commands = _v0.a;
				var groups = _v0.b;
				return A5(
					$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderCommandTreeWithRootDropArea,
					config,
					model,
					repository,
					$elm$core$Dict$values(commands),
					$elm$core$Dict$values(groups));
			},
			A3(
				$author$project$Lib$RemoteData$map2,
				$elm$core$Tuple$pair,
				config.dc(repository),
				config.bQ(repository)));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$NoOp = {$: 0};
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$nothingToNoOp = F2(
	function (toMsg, maybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pages$Main$EntityListing$GenericEntityListingView$NoOp,
			A2($elm$core$Maybe$map, toMsg, maybe));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$FilterValueChanged = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$select = F2(
	function (options, items) {
		return $rundis$elm_bootstrap$Bootstrap$Form$Select$view(
			A2($rundis$elm_bootstrap$Bootstrap$Form$Select$create, options, items));
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$renderFilter = F2(
	function (model, filter) {
		var filterValue = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, filter.bZ, model.ar));
		var _v0 = filter.c9;
		if (!_v0.$) {
			var placeholder = _v0.a;
			return $rundis$elm_bootstrap$Bootstrap$Form$Input$text(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Form$Input$onInput(
						$author$project$Pages$Main$EntityListing$GenericEntityListingView$FilterValueChanged(filter.bZ)),
						$rundis$elm_bootstrap$Bootstrap$Form$Input$value(filterValue),
						$rundis$elm_bootstrap$Bootstrap$Form$Input$placeholder(placeholder),
						$rundis$elm_bootstrap$Bootstrap$Form$Input$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-auto')
							]))
					]));
		} else {
			var options = _v0.a;
			return A2(
				$rundis$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Form$Select$onChange(
						$author$project$Pages$Main$EntityListing$GenericEntityListingView$FilterValueChanged(filter.bZ)),
						$rundis$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-auto')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var value = _v1.b;
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(key),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(filterValue, key))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]));
					},
					options));
		}
	});
var $author$project$Pages$Main$EntityListing$GenericEntityListingView$view = F4(
	function (config, model, repository, visibility) {
		var editSelectedItemMsg = A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$nothingToNoOp, $author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginEditElement, model.E);
		var disabledWhenNoSelection = $rundis$elm_bootstrap$Bootstrap$Button$disabled(
			_Utils_eq(model.E, $elm$core$Maybe$Nothing));
		var deleteSelectedItem = A2($author$project$Pages$Main$EntityListing$GenericEntityListingView$nothingToNoOp, $author$project$Pages$Main$EntityListing$GenericEntityListingView$ConfirmDeleteElement, model.E);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('entity-listing-view__root'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'd-none',
							$author$project$Utils$Visibility$isHidden(visibility))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('entity-listing-view__action-bar')
						]),
					A2(
						$elm$core$List$cons,
						A3(
							$author$project$Pages$Main$FormViewHelpers$entityActionButton,
							'sync',
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginRefresh)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Päivitä')
								])),
						A2(
							$elm$core$List$cons,
							A3(
								$author$project$Pages$Main$FormViewHelpers$entityActionButton,
								'pen',
								_List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Button$onClick(editSelectedItemMsg),
										disabledWhenNoSelection
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Muokkaa')
									])),
							A2(
								$elm$core$List$cons,
								A3(
									$author$project$Pages$Main$FormViewHelpers$entityActionButton,
									'trash',
									_List_fromArray(
										[
											$rundis$elm_bootstrap$Bootstrap$Button$onClick(deleteSelectedItem),
											disabledWhenNoSelection
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Poista')
										])),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Pages$Main$FormViewHelpers$entityActionButton,
										'plus',
										_List_fromArray(
											[
												$rundis$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewEntity)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Uusi')
											])),
									A2(
										$elm$core$List$cons,
										A3(
											$author$project$Pages$Main$FormViewHelpers$entityActionButton,
											'plus',
											_List_fromArray(
												[
													$rundis$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Main$EntityListing$GenericEntityListingView$BeginAddNewGroup)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Uusi ryhmä')
												])),
										A2(
											$elm$core$List$map,
											$author$project$Pages$Main$EntityListing$GenericEntityListingView$renderFilter(model),
											config.da))))))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 overflow-hidden')
						]),
					_List_fromArray(
						[
							A3($author$project$Pages$Main$EntityListing$GenericEntityListingView$maybeRenderTreeView, config, model, repository)
						]))
				]));
	});
var $author$project$Utils$Visibility$Hidden = 1;
var $author$project$Utils$Visibility$Visible = 0;
var $author$project$Utils$Visibility$visibleIf = function (isVisible) {
	return isVisible ? 0 : 1;
};
var $author$project$Pages$Main$EnvironmentsView$renderListingView = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Main$EnvironmentsView$ListingViewMsg,
			A4(
				$author$project$Pages$Main$EntityListing$GenericEntityListingView$view,
				$author$project$Pages$Main$EnvironmentsView$listingViewConfig,
				model.K,
				repository,
				$author$project$Utils$Visibility$visibleIf(
					_Utils_eq(model.l, $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing))));
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$small = function (_v0) {
	var conf = _v0;
	var options = conf.ae;
	return _Utils_update(
		conf,
		{
			ae: _Utils_update(
				options,
				{
					ip: $elm$core$Maybe$Just(1)
				})
		});
};
var $author$project$Utils$CommonModals$confirmationModal = function (_v0) {
	var content = _v0.gc;
	var cancel = _v0.fI;
	var confirm = _v0.f6;
	var status = _v0.eV;
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Modal$view,
		$rundis$elm_bootstrap$Bootstrap$Modal$shown,
		$rundis$elm_bootstrap$Bootstrap$Modal$small(
			A3(
				$rundis$elm_bootstrap$Bootstrap$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Utils$CommonView$spinner(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'invisible',
										!_Utils_eq(status, $author$project$Lib$Form$LoadStatus$InProgress))
									]))
							])),
						A2(
						$rundis$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Button$primary,
								$rundis$elm_bootstrap$Bootstrap$Button$onClick(confirm)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ok')
							])),
						A2(
						$rundis$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Button$outlinePrimary,
								$rundis$elm_bootstrap$Bootstrap$Button$onClick(cancel)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Peruuta')
							]))
					]),
				A3(
					$rundis$elm_bootstrap$Bootstrap$Modal$body,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						]),
					A3(
						$rundis$elm_bootstrap$Bootstrap$Modal$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Oletko varma?')
							]),
						A2(
							$rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick,
							false,
							$rundis$elm_bootstrap$Bootstrap$Modal$config(cancel)))))));
};
var $author$project$Pages$Main$EnvironmentsView$renderModal = function (model) {
	var _v0 = model.a2;
	switch (_v0.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			var config = _v0.a;
			return $author$project$Utils$CommonModals$messageModal(config);
		default:
			var config = _v0.a;
			return $author$project$Utils$CommonModals$confirmationModal(config);
	}
};
var $author$project$Pages$Main$EnvironmentsView$view = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tab-view-root-container')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Main$EnvironmentsView$renderModal(model),
					A2($author$project$Pages$Main$EnvironmentsView$renderListingView, model, repository),
					A2($author$project$Pages$Main$EnvironmentsView$renderEditView, model, repository)
				]));
	});
var $author$project$Pages$Main$MainPage$environmentsView = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Main$MainPage$EnvironmentsMsg,
		A2($author$project$Pages$Main$EnvironmentsView$view, model.aQ, model.A));
};
var $author$project$Pages$Main$MainPage$missingPermissionsView = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$m2]),
	_List_fromArray(
		[
			$elm$html$Html$text('Sinulla ei ole oikeutta tähän käyttöalueeseen')
		]));
var $author$project$Forms$PrincipalForms$PrincipalFormConfig = F2(
	function (roles, environments) {
		return {ea: environments, eN: roles};
	});
var $author$project$Pages$Main$PrincipalsView$EditFormBackButtonClicked = {$: 3};
var $author$project$Pages$Main$PrincipalsView$GroupFormChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Main$PrincipalsView$renderEditGroupView = function (formModel) {
	return A3(
		$author$project$Pages$Main$FormViewHelpers$editEntityView,
		$author$project$Pages$Main$PrincipalsView$EditFormBackButtonClicked,
		'Muokkaa ryhmää',
		_List_fromArray(
			[
				$author$project$Pages$Main$FormViewHelpers$renderCommonForm(
				{
					ed: A2($author$project$Lib$Form$Form$map, $author$project$Pages$Main$PrincipalsView$BeginSaveGroup, $author$project$Forms$GenericEntityGroupForm$genericEntityGroupForm),
					ee: formModel,
					bZ: 'edit_principal_group',
					r: $author$project$Pages$Main$PrincipalsView$GroupFormChanged
				})
			]));
};
var $author$project$Pages$Main$PrincipalsView$PrincipalFormChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Lib$Form$Base$Base$andThen = F2(
	function (child, parent) {
		return function (values) {
			var filled = A2($author$project$Lib$Form$Base$Base$fill, parent, values);
			var _v0 = filled.c;
			if (!_v0.$) {
				var output = _v0.a;
				var childFilled = A2(
					$author$project$Lib$Form$Base$Base$fill,
					child(output),
					values);
				return {
					b: _Utils_ap(filled.b, childFilled.b),
					a: filled.a && childFilled.a,
					c: childFilled.c
				};
			} else {
				var errors = _v0.a;
				return {
					b: filled.b,
					a: filled.a,
					c: $elm$core$Result$Err(errors)
				};
			}
		};
	});
var $author$project$Lib$Form$Form$andThen = $author$project$Lib$Form$Base$Base$andThen;
var $author$project$Lib$Form$Base$NumberField$form = $author$project$Lib$Form$Base$Base$field(
	{a: $elm$core$String$isEmpty});
var $author$project$Lib$Form$Form$numberField = $author$project$Lib$Form$Base$NumberField$form($author$project$Lib$Form$Form$Number);
var $author$project$Forms$CommonForms$limitedIntegerField = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var label = _v0.h0;
	var min = _v0.dk;
	var max = _v0.dj;
	var upperLimitParser = function (numValue) {
		return (_Utils_cmp(numValue, max) > 0) ? $elm$core$Result$Err(
			'Tulee olla korkeintaan ' + $elm$core$String$fromInt(max)) : $elm$core$Result$Ok(numValue);
	};
	var lowerLimitParser = function (numValue) {
		return (_Utils_cmp(numValue, min) < 0) ? $elm$core$Result$Err(
			'Tulee olla vähintään ' + $elm$core$String$fromInt(min)) : $elm$core$Result$Ok(numValue);
	};
	var intParser = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		$elm$core$Result$fromMaybe('Kokonaisluku vaaditaan'));
	return $author$project$Lib$Form$Form$numberField(
		{
			aK: {
				h0: label,
				dj: $elm$core$Maybe$Just(max),
				dk: $elm$core$Maybe$Just(min),
				iP: '',
				jL: $elm$core$Maybe$Just(1)
			},
			u: A2(
				$elm$core$Basics$composeR,
				intParser,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(lowerLimitParser),
					$elm$core$Result$andThen(upperLimitParser))),
			dK: update,
			kg: value
		});
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {en: index, ib: match, iw: number, jN: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{fJ: false, ir: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$isBlank = function (string) {
	return A2(
		$elm$regex$Regex$contains,
		$elm_community$string_extra$String$Extra$regexFromString('^\\s*$'),
		string);
};
var $elm_community$string_extra$String$Extra$nonBlank = function (string) {
	return $elm_community$string_extra$String$Extra$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Entity$Environment$displayNameOrName = function (env) {
	return A2(
		$elm$core$Maybe$withDefault,
		env.is,
		$elm_community$string_extra$String$Extra$nonBlank(env.gE));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Utils$DictUtils$filterByValue = function (isGood) {
	return $elm$core$Dict$filter(
		F2(
			function (_v0, v) {
				return isGood(v);
			}));
};
var $author$project$Forms$PrincipalForms$makeEnvironmentAssociationForm = function (_v0) {
	var roles = _v0.eN;
	var environments = _v0.ea;
	var selectRoleField = $author$project$Forms$CommonForms$selectIdField(
		{
			h0: 'Rooli',
			ae: $elm$core$Dict$toList(
				A2(
					$author$project$Utils$DictUtils$mapValues,
					function ($) {
						return $.is;
					},
					A2(
						$author$project$Utils$DictUtils$filterByValue,
						function ($) {
							return $.hY;
						},
						roles))),
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{jj: value});
				}),
			kg: function ($) {
				return $.jj;
			}
		});
	var selectEnvField = $author$project$Forms$CommonForms$selectIdField(
		{
			h0: 'Ympäristö',
			ae: $elm$core$Dict$toList(
				A2($author$project$Utils$DictUtils$mapValues, $author$project$Entity$Environment$displayNameOrName, environments)),
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{g$: value});
				}),
			kg: function ($) {
				return $.g$;
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		selectRoleField,
		A2(
			$author$project$Lib$Form$Form$append,
			selectEnvField,
			$author$project$Lib$Form$Form$succeed($author$project$Entity$Environment$EnvironmentAssociation)));
};
var $author$project$Lib$Form$Base$CheckboxField$form = $author$project$Lib$Form$Base$Base$field(
	{
		a: $elm$core$Basics$always(false)
	});
var $author$project$Lib$Form$Form$checkboxField = $author$project$Lib$Form$Base$CheckboxField$form($author$project$Lib$Form$Form$Checkbox);
var $author$project$Lib$Form$Form$simpleCheckboxField = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var label = _v0.h0;
	return $author$project$Lib$Form$Form$checkboxField(
		{
			aK: {h0: label},
			u: $elm$core$Result$Ok,
			dK: update,
			kg: value
		});
};
var $author$project$Lib$Form$Form$simpleConstantField = function (_v0) {
	var value = _v0.kg;
	var label = _v0.h0;
	return A2(
		$author$project$Lib$Form$Base$ConstantField$form,
		$author$project$Lib$Form$Form$Constant,
		{
			aK: {h0: label},
			u: $elm$core$Result$Ok,
			dK: F2(
				function (_v1, values) {
					return values;
				}),
			kg: value
		});
};
var $author$project$Forms$PrincipalForms$principalTypeField = function () {
	var mfaEnabledField = $author$project$Lib$Form$Form$meta(
		function (_v4) {
			var principalType = _v4.iZ;
			if (!principalType.$) {
				var email = principalType.a.d7;
				var mfaEnabled = principalType.a.il;
				return $author$project$Lib$Form$Form$simpleCheckboxField(
					{
						h0: 'Vaadi kaksivaiheinen tunnistautuminen',
						dK: F2(
							function (value, values) {
								return _Utils_update(
									values,
									{
										iZ: $author$project$Entity$PrincipalAssociation$UserPrincipal(
											{d7: email, il: value})
									});
							}),
						kg: $elm$core$Basics$always(mfaEnabled)
					});
			} else {
				return $author$project$Lib$Form$Form$succeed(false);
			}
		});
	var emailOrClientIdField = $author$project$Lib$Form$Form$simpleConstantField(
		{
			h0: 'Sähköposti',
			kg: function (_v2) {
				var principalType = _v2.iZ;
				if (!principalType.$) {
					var email = principalType.a.d7;
					return email;
				} else {
					var clientId = principalType.a.fS;
					return 'API-token (' + (clientId + ')');
				}
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		mfaEnabledField,
		A2(
			$author$project$Lib$Form$Form$append,
			emailOrClientIdField,
			A2(
				$author$project$Lib$Form$Form$append,
				$author$project$Forms$CommonForms$constantMetaField(
					function ($) {
						return $.iZ;
					}),
				$author$project$Lib$Form$Form$succeed(
					F3(
						function (principalType, _v0, mfaEnabled) {
							if (!principalType.$) {
								var email = principalType.a.d7;
								return $author$project$Entity$PrincipalAssociation$UserPrincipal(
									{d7: email, il: mfaEnabled});
							} else {
								var clientId = principalType.a.fS;
								return principalType;
							}
						})))));
}();
var $author$project$Forms$PrincipalForms$userSettingsForm = function () {
	var userParametersListForm = A2(
		$author$project$Lib$Form$Form$simpleList,
		{
			gs: {h_: '', kg: $elm$core$Maybe$Nothing},
			h0: 'Käyttäjän parametrit',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{kd: value});
				}),
			kg: function ($) {
				return $.kd;
			}
		},
		function (_v0) {
			return $author$project$Forms$CommandParameterForm$commandParameterField(0);
		});
	var useNfcField = $author$project$Lib$Form$Form$simpleCheckboxField(
		{
			h0: 'Käytä NFC-lukijaa',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ka: value});
				}),
			kg: function ($) {
				return $.ka;
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		useNfcField,
		A2(
			$author$project$Lib$Form$Form$append,
			userParametersListForm,
			$author$project$Lib$Form$Form$succeed($author$project$Entity$PrincipalAssociation$UserSettings)));
}();
var $author$project$Forms$PrincipalForms$makePrincipalForm = function (config) {
	var sessionExpirationDurationField = $author$project$Forms$CommonForms$limitedIntegerField(
		{
			h0: 'Session kesto (vuorokautta)',
			dj: 365,
			dk: 1,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{jy: value});
				}),
			kg: function ($) {
				return $.jy;
			}
		});
	var principalStateForm = A2(
		$author$project$Lib$Form$Form$andThen,
		function (_v3) {
			return $author$project$Forms$CommonForms$constantMetaField(
				function ($) {
					return $.iY;
				});
		},
		$author$project$Lib$Form$Form$simpleConstantField(
			{
				h0: 'Tila',
				kg: function (_v1) {
					var principalState = _v1.iY;
					if (principalState.$ === 1) {
						var principalId = principalState.a.iX;
						return 'Valmis, käyttäjän ID: (' + (principalId + ')');
					} else {
						var preparedPrincipalId = principalState.a.iV;
						return 'Odottaa ensimmäistä kirjautumista';
					}
				}
			}));
	var environmentAssociationsForm = A2(
		$author$project$Lib$Form$Form$simpleList,
		{
			gs: {g$: $author$project$Entity$Common$nonExistentId, jj: $author$project$Entity$Common$nonExistentId},
			h0: 'Ympäristöt',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{g_: value});
				}),
			kg: function ($) {
				return $.g_;
			}
		},
		function (_v0) {
			return $author$project$Forms$PrincipalForms$makeEnvironmentAssociationForm(config);
		});
	var descriptionField = $author$project$Lib$Form$Form$textareaField(
		{
			aK: {bx: $elm$core$Maybe$Nothing, h0: 'Kuvaus', iP: ''},
			u: $elm$core$Result$Ok,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gC: value});
				}),
			kg: function ($) {
				return $.gC;
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		A2(
			$author$project$Lib$Form$Form$mapValues,
			{
				dK: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{ke: value});
					}),
				kg: function ($) {
					return $.ke;
				}
			},
			$author$project$Forms$PrincipalForms$userSettingsForm),
		A2(
			$author$project$Lib$Form$Form$append,
			environmentAssociationsForm,
			A2(
				$author$project$Lib$Form$Form$append,
				$author$project$Lib$Form$Form$allowEmptyString(descriptionField),
				A2(
					$author$project$Lib$Form$Form$append,
					sessionExpirationDurationField,
					A2(
						$author$project$Lib$Form$Form$append,
						$author$project$Forms$PrincipalForms$principalTypeField,
						A2(
							$author$project$Lib$Form$Form$append,
							principalStateForm,
							A2(
								$author$project$Lib$Form$Form$append,
								$author$project$Forms$CommonForms$constantMetaField(
									function ($) {
										return $.cr;
									}),
								A2(
									$author$project$Lib$Form$Form$append,
									$author$project$Forms$CommonForms$constantMetaField(
										function ($) {
											return $.hw;
										}),
									A2(
										$author$project$Lib$Form$Form$append,
										$author$project$Forms$CommonForms$idField,
										$author$project$Lib$Form$Form$succeed($author$project$Entity$PrincipalAssociation$PrincipalAssociation))))))))));
};
var $author$project$Pages$Main$PrincipalsView$renderEditPrincipalForm = F2(
	function (formModel, config) {
		return A3(
			$author$project$Pages$Main$FormViewHelpers$editEntityView,
			$author$project$Pages$Main$PrincipalsView$EditFormBackButtonClicked,
			'Muokkaa yhteyttä',
			_List_fromArray(
				[
					$author$project$Pages$Main$FormViewHelpers$renderCommonForm(
					{
						ed: A2(
							$author$project$Lib$Form$Form$map,
							$author$project$Pages$Main$PrincipalsView$BeginSavePrincipal,
							$author$project$Forms$PrincipalForms$makePrincipalForm(config)),
						ee: formModel,
						bZ: 'edit_principal',
						r: $author$project$Pages$Main$PrincipalsView$PrincipalFormChanged
					})
				]));
	});
var $author$project$Pages$Main$PrincipalsView$renderEditView = F2(
	function (model, repository) {
		var _v0 = model.l;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var formModel = _v0.a;
				return A2(
					$author$project$Utils$CommonView$renderWebData,
					$author$project$Pages$Main$PrincipalsView$renderEditPrincipalForm(formModel),
					A3($author$project$Lib$RemoteData$map2, $author$project$Forms$PrincipalForms$PrincipalFormConfig, repository.eN, repository.ea));
			default:
				var formModel = _v0.a;
				return $author$project$Pages$Main$PrincipalsView$renderEditGroupView(formModel);
		}
	});
var $author$project$Pages$Main$PrincipalsView$renderListingView = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Main$PrincipalsView$ListingViewMsg,
			A4(
				$author$project$Pages$Main$EntityListing$GenericEntityListingView$view,
				$author$project$Pages$Main$PrincipalsView$listingViewConfig,
				model.K,
				repository,
				$author$project$Utils$Visibility$visibleIf(
					_Utils_eq(model.l, $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing))));
	});
var $author$project$Pages$Main$PrincipalsView$AddNewPrincipalFormChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Main$PrincipalsView$AddNewPrincipalFormSubmitted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Forms$CreateNewPrincipalAssociationForm$NewPrincipalAssociationFormResult = F3(
	function (principalType, identityProviderId, password) {
		return {hK: identityProviderId, dq: password, iZ: principalType};
	});
var $author$project$Entity$IdentityProvider$getIdentityProviderDescription = function (identityProvider) {
	var _v0 = identityProvider.j5;
	if (!_v0) {
		return 'Sisäinen';
	} else {
		return 'Ulkoinen';
	}
};
var $author$project$Forms$CreateNewPrincipalAssociationForm$selectIdentityProviderIdField = function (allProviders) {
	var selectProviderField = $author$project$Lib$Form$Form$selectField(
		{
			aK: {
				h0: 'Käyttäjätietokanta',
				ae: A2(
					$elm$core$List$map,
					function (provider) {
						return _Utils_Tuple2(
							provider.bZ,
							$author$project$Entity$IdentityProvider$getIdentityProviderDescription(provider));
					},
					allProviders),
				iP: $elm$core$Maybe$Nothing
			},
			u: $elm$core$Result$Ok,
			dK: F2(
				function (value, values_) {
					return _Utils_update(
						values_,
						{hK: value});
				}),
			kg: function ($) {
				return $.hK;
			}
		});
	return $author$project$Lib$Form$Form$meta(
		function (_v0) {
			var principalTypeStr = _v0.ag;
			if (principalTypeStr === 'user') {
				return selectProviderField;
			} else {
				return $author$project$Lib$Form$Form$succeed('');
			}
		});
};
var $author$project$Lib$Form$Form$TextEmail = 1;
var $author$project$Lib$Form$Form$emailField = $author$project$Lib$Form$Base$TextField$form(
	$author$project$Lib$Form$Form$Text(1));
var $author$project$Forms$CreateNewPrincipalAssociationForm$selectPrincipalTypeField = function () {
	var typeField = $author$project$Lib$Form$Form$meta(
		function (values) {
			return $author$project$Lib$Form$Form$selectField(
				{
					aK: {
						h0: 'Tyyppi',
						ae: _List_fromArray(
							[
								_Utils_Tuple2('user', 'Käyttäjä'),
								_Utils_Tuple2('token', 'API-token')
							]),
						iP: $elm$core$Maybe$Nothing
					},
					u: function (str) {
						switch (str) {
							case 'user':
								return $elm$core$Result$Ok(
									$author$project$Entity$PrincipalAssociation$UserPrincipal(
										{d7: values.bf, il: false}));
							case 'token':
								return $elm$core$Result$Ok(
									$author$project$Entity$PrincipalAssociation$TokenPrincipal(
										{fS: ''}));
							default:
								return $elm$core$Result$Err('Valitse tyyppi');
						}
					},
					dK: F2(
						function (value, values_) {
							return _Utils_update(
								values_,
								{ag: value});
						}),
					kg: function ($) {
						return $.ag;
					}
				});
		});
	var emailField = $author$project$Lib$Form$Form$meta(
		function (_v1) {
			var principalTypeStr = _v1.ag;
			if (principalTypeStr === 'user') {
				return $author$project$Lib$Form$Form$emailField(
					{
						aK: {bx: $elm$core$Maybe$Nothing, h0: 'Sähköposti', iP: ''},
						u: $elm$core$Result$Ok,
						dK: F2(
							function (value, values) {
								return _Utils_update(
									values,
									{bf: value});
							}),
						kg: function ($) {
							return $.bf;
						}
					});
			} else {
				return $author$project$Lib$Form$Form$succeed('');
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		emailField,
		A2(
			$author$project$Lib$Form$Form$append,
			typeField,
			$author$project$Lib$Form$Form$succeed(
				F2(
					function (type_, _v0) {
						return type_;
					}))));
}();
var $author$project$Forms$CommonForms$convertFormToOptional = F2(
	function (label, form) {
		return A2(
			$author$project$Lib$Form$Form$andThen,
			function (isDefined) {
				return isDefined ? A2(
					$author$project$Lib$Form$Form$map,
					$elm$core$Maybe$Just,
					A2(
						$author$project$Lib$Form$Form$mapValues,
						{
							dK: F2(
								function (newValue, values) {
									return _Utils_update(
										values,
										{aX: newValue});
								}),
							kg: function ($) {
								return $.aX;
							}
						},
						form)) : $author$project$Lib$Form$Form$succeed($elm$core$Maybe$Nothing);
			},
			$author$project$Lib$Form$Form$checkboxField(
				{
					aK: {h0: label},
					u: $elm$core$Result$Ok,
					dK: F2(
						function (newValue, values) {
							return _Utils_update(
								values,
								{aY: newValue});
						}),
					kg: function ($) {
						return $.aY;
					}
				}));
	});
var $author$project$Lib$Form$Form$TextPassword = 2;
var $author$project$Lib$Form$Form$passwordField = $author$project$Lib$Form$Base$TextField$form(
	$author$project$Lib$Form$Form$Text(2));
var $author$project$Lib$Form$Form$simplePasswordField = function (_v0) {
	var value = _v0.kg;
	var update = _v0.dK;
	var label = _v0.h0;
	var autoComplete = _v0.bx;
	return $author$project$Lib$Form$Form$passwordField(
		{
			aK: {bx: autoComplete, h0: label, iP: ''},
			u: $elm$core$Result$Ok,
			dK: update,
			kg: value
		});
};
var $author$project$Forms$CreateNewPrincipalAssociationForm$userPasswordField = function (identityProviders) {
	var field = A2(
		$author$project$Lib$Form$Form$mapValues,
		{
			dK: F2(
				function (value, values_) {
					return _Utils_update(
						values_,
						{dq: value});
				}),
			kg: function ($) {
				return $.dq;
			}
		},
		A2(
			$author$project$Forms$CommonForms$convertFormToOptional,
			'Aseta salasana',
			$author$project$Lib$Form$Form$simplePasswordField(
				{
					bx: $elm$core$Maybe$Nothing,
					h0: 'Salasana',
					dK: F2(
						function (value, _v2) {
							return value;
						}),
					kg: $elm$core$Basics$identity
				})));
	return $author$project$Lib$Form$Form$meta(
		function (_v0) {
			var principalTypeStr = _v0.ag;
			var identityProviderId = _v0.hK;
			var internalIdentityProviderSelected = A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Maybe$map,
					$author$project$Entity$IdentityProvider$isInternalIdentityProvider,
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (idp) {
							return _Utils_eq(idp.bZ, identityProviderId);
						},
						identityProviders)));
			var _v1 = _Utils_Tuple2(principalTypeStr, internalIdentityProviderSelected);
			if ((_v1.a === 'user') && _v1.b) {
				return field;
			} else {
				return $author$project$Lib$Form$Form$succeed($elm$core$Maybe$Nothing);
			}
		});
};
var $author$project$Forms$CreateNewPrincipalAssociationForm$makeNewPrincipalAssociationForm = function (allIdentityProviders) {
	return A2(
		$author$project$Lib$Form$Form$append,
		$author$project$Forms$CreateNewPrincipalAssociationForm$userPasswordField(allIdentityProviders),
		A2(
			$author$project$Lib$Form$Form$append,
			$author$project$Forms$CreateNewPrincipalAssociationForm$selectIdentityProviderIdField(allIdentityProviders),
			A2(
				$author$project$Lib$Form$Form$append,
				$author$project$Forms$CreateNewPrincipalAssociationForm$selectPrincipalTypeField,
				$author$project$Lib$Form$Form$succeed($author$project$Forms$CreateNewPrincipalAssociationForm$NewPrincipalAssociationFormResult))));
};
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb0 = $elm$html$Html$Attributes$class('mb-0');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt2 = $elm$html$Html$Attributes$class('mt-2');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Pages$Main$FormViewHelpers$renderCommonModal = F3(
	function (title, close, content) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Modal$view,
			$rundis$elm_bootstrap$Bootstrap$Modal$shown,
			A3(
				$rundis$elm_bootstrap$Bootstrap$Modal$body,
				_List_Nil,
				_List_fromArray(
					[content]),
				$rundis$elm_bootstrap$Bootstrap$Modal$small(
					A3(
						$rundis$elm_bootstrap$Bootstrap$Modal$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							]),
						A2(
							$rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick,
							false,
							$rundis$elm_bootstrap$Bootstrap$Modal$config(close))))));
	});
var $author$project$Pages$Main$PrincipalsView$renderNewPrincipalForm = F2(
	function (repository, _v0) {
		var formModel = _v0.ee;
		var errorText = _v0.aq;
		var errorTextHtml = $elm$core$String$isEmpty(errorText) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-danger'),
					$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt2,
					$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb0
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(errorText)
				]));
		var renderFormContent = function (identityProviders) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('d-flex flex-column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-1')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Lib$Form$FormView$asHtml,
								{dP: 'OK', bZ: 'add_new_principal_association', a0: 'Ladataan', r: $author$project$Pages$Main$PrincipalsView$AddNewPrincipalFormChanged, a8: true, e7: 1},
								A2(
									$author$project$Lib$Form$Form$map,
									$author$project$Pages$Main$PrincipalsView$AddNewPrincipalFormSubmitted,
									$author$project$Forms$CreateNewPrincipalAssociationForm$makeNewPrincipalAssociationForm(identityProviders)),
								formModel)
							])),
						errorTextHtml
					]));
		};
		return A2(
			$author$project$Utils$CommonView$renderWebData,
			function (identityProviders) {
				return A3(
					$author$project$Pages$Main$FormViewHelpers$renderCommonModal,
					'Uusi käyttäjä',
					$author$project$Pages$Main$PrincipalsView$CloseCurrentModal,
					renderFormContent(identityProviders));
			},
			repository.de);
	});
var $author$project$Utils$CommonView$boldText = function (content) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('font-weight-bold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $author$project$Pages$Main$PrincipalsView$viewRevealApiTokenModalBody = function (apiToken) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Tässä on uuden API-tokenin tiedot. Tallenna salasana - sitä ei voi katsoa tämän ikkunan sulkemisen jälkeen')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Id: ')
						])),
					$author$project$Utils$CommonView$boldText(apiToken.fS)
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Salasana: ')
						])),
					$author$project$Utils$CommonView$boldText(apiToken.fT)
				]))
		]);
};
var $author$project$Pages$Main$PrincipalsView$renderModal = F2(
	function (model, repository) {
		var _v0 = model.a2;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 4:
				var config = _v0.a;
				return $author$project$Utils$CommonModals$messageModal(config);
			case 3:
				var config = _v0.a;
				return $author$project$Utils$CommonModals$confirmationModal(config);
			case 1:
				var modalState = _v0.a;
				return A2($author$project$Pages$Main$PrincipalsView$renderNewPrincipalForm, repository, modalState);
			default:
				var apiToken = _v0.a;
				var principal = _v0.b;
				return A2(
					$rundis$elm_bootstrap$Bootstrap$Modal$view,
					$rundis$elm_bootstrap$Bootstrap$Modal$shown,
					A3(
						$rundis$elm_bootstrap$Bootstrap$Modal$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rundis$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Main$PrincipalsView$BeginEditPrincipal(principal)),
										$rundis$elm_bootstrap$Bootstrap$Button$primary
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OK')
									]))
							]),
						A3(
							$rundis$elm_bootstrap$Bootstrap$Modal$body,
							_List_Nil,
							$author$project$Pages$Main$PrincipalsView$viewRevealApiTokenModalBody(apiToken),
							A3(
								$rundis$elm_bootstrap$Bootstrap$Modal$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('API-Token')
									]),
								A2(
									$rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick,
									false,
									$rundis$elm_bootstrap$Bootstrap$Modal$config($author$project$Pages$Main$PrincipalsView$CloseCurrentModal))))));
		}
	});
var $author$project$Entity$PrincipalAssociation$isUserPrincipal = function (principalAssociation) {
	var _v0 = principalAssociation.iZ;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Main$PrincipalsView$renderSummary = F2(
	function (model, repository) {
		var _v0 = _Utils_Tuple2(repository.du, model.l);
		if ((_v0.a.$ === 3) && (!_v0.b.$)) {
			var principals = _v0.a.a;
			var _v1 = _v0.b;
			var userCount = $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					$author$project$Entity$PrincipalAssociation$isUserPrincipal,
					$elm$core$Dict$values(principals)));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt2]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Käyttäjiä yhteensä: ' + $elm$core$String$fromInt(userCount))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Main$PrincipalsView$view = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tab-view-root-container')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Main$PrincipalsView$renderModal, model, repository),
					A2($author$project$Pages$Main$PrincipalsView$renderListingView, model, repository),
					A2($author$project$Pages$Main$PrincipalsView$renderEditView, model, repository),
					A2($author$project$Pages$Main$PrincipalsView$renderSummary, model, repository)
				]));
	});
var $author$project$Pages$Main$MainPage$principalsView = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Main$MainPage$PrincipalsMsg,
		A2($author$project$Pages$Main$PrincipalsView$view, model.a6, model.A));
};
var $author$project$Forms$RoleForms$RoleFormConfig = F3(
	function (allViews, allRoles, allCommands) {
		return {cY: allCommands, dT: allRoles, aJ: allViews};
	});
var $author$project$Lib$RemoteData$map3 = F4(
	function (f, a, b, c) {
		return A2(
			$author$project$Lib$RemoteData$andMap,
			c,
			A2(
				$author$project$Lib$RemoteData$andMap,
				b,
				A2($author$project$Lib$RemoteData$map, f, a)));
	});
var $author$project$Pages$Main$RolesView$EditFormBackButtonClicked = {$: 3};
var $author$project$Pages$Main$RolesView$GroupFormChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Main$RolesView$renderEditGroupView = function (formModel) {
	return A3(
		$author$project$Pages$Main$FormViewHelpers$editEntityView,
		$author$project$Pages$Main$RolesView$EditFormBackButtonClicked,
		'Muokkaa ryhmää',
		_List_fromArray(
			[
				$author$project$Pages$Main$FormViewHelpers$renderCommonForm(
				{
					ed: A2($author$project$Lib$Form$Form$map, $author$project$Pages$Main$RolesView$BeginSaveGroup, $author$project$Forms$GenericEntityGroupForm$genericEntityGroupForm),
					ee: formModel,
					bZ: 'edit_role_group',
					r: $author$project$Pages$Main$RolesView$GroupFormChanged
				})
			]));
};
var $author$project$Pages$Main$RolesView$RoleFormChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Forms$RoleForms$ViewAssociationFormConfig = F2(
	function (allViews, usedViews) {
		return {aJ: allViews, e5: usedViews};
	});
var $author$project$Entity$Command$commandTypeComparator = F2(
	function (a, b) {
		var getPriority = function (command) {
			var _v0 = command.jF;
			switch (_v0.$) {
				case 0:
					return 1;
				case 1:
					return 2;
				case 2:
					return 3;
				case 3:
					return 4;
				case 4:
					return 5;
				case 5:
					return 6;
				case 6:
					return 7;
				case 7:
					return 8;
				case 8:
					return 9;
				case 9:
					return 10;
				case 10:
					return 11;
				case 11:
					return 12;
				case 14:
					return 13;
				case 15:
					return 14;
				case 13:
					return 15;
				default:
					return 16;
			}
		};
		return A2(
			$elm$core$Basics$compare,
			getPriority(a),
			getPriority(b));
	});
var $author$project$Forms$RoleForms$createDefaultViewAssociationFormValues = {
	cq: {aO: false},
	jD: true,
	ki: $author$project$Entity$Common$nonExistentId
};
var $author$project$Entity$Command$getCommandTypeAsString = function (command) {
	var _v0 = command.jF;
	switch (_v0.$) {
		case 0:
			return 'Yksi lause';
		case 1:
			return 'Datanäkymän komento';
		case 2:
			return 'Lomakenäkymän tallennuskomento';
		case 3:
			return 'Linjastonäkymän komento';
		case 4:
			return 'Sähköpostikomento';
		case 5:
			return 'Ilmoituskomento';
		case 6:
			return 'Tiedoston lataus käyttäjälle';
		case 7:
			return 'Tiedostojen vienti palvelimelle';
		case 8:
			return 'Raporttikomento';
		case 9:
			return 'Kuvaajanäkymän komento';
		case 10:
			return 'Diagramminäkymän komento';
		case 11:
			return 'Puunäkymän komento';
		case 12:
			return 'Kalenterinäkymän komento';
		case 13:
			return 'QuickSight-komento';
		case 14:
			return 'Ajastettu komento';
		default:
			return 'Näkymän komponenttien määrittely';
	}
};
var $author$project$Entity$Command$getCommandLongDescription = function (command) {
	return $elm$core$String$fromInt(command.bZ) + (' | ' + ($author$project$Entity$Command$getCommandTypeAsString(command) + (' | ' + (command.h_ + (' | ' + $author$project$Utils$StringUtils$firstLine(command.gC))))));
};
var $author$project$Entity$View$getViewSpecAsString = function (view_) {
	var _v0 = view_.jF;
	switch (_v0.$) {
		case 0:
			return 'Säiliönäkymä';
		case 1:
			return 'Komponenttinäkymä';
		case 2:
			return 'Komentorivi';
		case 3:
			return 'Datanäkymä';
		case 4:
			return 'Lomakenäkymä';
		case 5:
			var type_ = _v0.a.j5;
			switch (type_) {
				case 0:
					return 'Linjastonäkymä';
				case 1:
					return 'Kuvaajanäkymä';
				case 2:
					return 'Dokumenttinäkymä';
				case 3:
					return 'Diagramminäkymä';
				case 4:
					return 'Puunäkymä';
				case 5:
					return 'Karttanäkymä';
				case 6:
					return 'QuickSight-näkymä';
				case 7:
					return 'Kalenterinäkymä';
				default:
					return 'HTML-näkymä';
			}
		default:
			return 'Generaattorinäkymä';
	}
};
var $author$project$Entity$View$getLongViewDescription = function (view) {
	var appendIfNotEmpty = function (str) {
		return (str !== '') ? (' | ' + str) : '';
	};
	return $elm$core$String$fromInt(view.bZ) + (' | ' + ($author$project$Entity$View$getViewSpecAsString(view) + (' | ' + (view.is + (appendIfNotEmpty(view.gE) + appendIfNotEmpty(
		$author$project$Utils$StringUtils$firstLine(view.gC)))))));
};
var $author$project$Entity$Command$isViewComponentsCommand = function (command) {
	var _v0 = command.jF;
	if (_v0.$ === 15) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Forms$EntitySelectFormList$makeSelectEntityForm = F2(
	function (_v0, index) {
		var allEntities = _v0.aI;
		var selectedEntities = _v0.ah;
		var label = _v0.h0;
		var extraFilter = _v0.aS;
		return $author$project$Lib$Form$Form$meta(
			function (values) {
				var entityIsNotInUse = function (id) {
					return !A2($elm$core$List$member, id, selectedEntities);
				};
				var filteredEntities = A2(
					$elm$core$List$filter,
					function (_v3) {
						var id = _v3.a;
						return _Utils_eq(values.bZ, id) || entityIsNotInUse(id);
					},
					allEntities);
				var extraFilteredEntities = function () {
					if (!extraFilter.$) {
						var filter = extraFilter.a;
						return A2(
							$elm$core$List$filter,
							function (_v2) {
								var id = _v2.a;
								return filter(id);
							},
							filteredEntities);
					} else {
						return filteredEntities;
					}
				}();
				return $author$project$Forms$CommonForms$selectIdField(
					{
						h0: label,
						ae: extraFilteredEntities,
						dK: F2(
							function (value, values_) {
								return _Utils_update(
									values_,
									{bZ: value});
							}),
						kg: function ($) {
							return $.bZ;
						}
					});
			});
	});
var $author$project$Forms$EntitySelectFormList$makeEntitySelectFormList = function (_v0) {
	var allEntities = _v0.aI;
	var listLabel = _v0.et;
	var entitySelectLabel = _v0.d9;
	var extraFilter = _v0.aS;
	return $author$project$Lib$Form$Form$meta(
		function (values) {
			var selectSingleEntityFormConfig = {
				aI: allEntities,
				aS: extraFilter,
				h0: entitySelectLabel,
				ah: A2(
					$elm$core$List$map,
					function ($) {
						return $.bZ;
					},
					values.ah)
			};
			return A2(
				$author$project$Lib$Form$Form$simpleList,
				{
					gs: {bZ: $author$project$Entity$Common$nonExistentId},
					h0: listLabel,
					dK: F2(
						function (value, values_) {
							return _Utils_update(
								values_,
								{ah: value});
						}),
					kg: function ($) {
						return $.ah;
					}
				},
				$author$project$Forms$EntitySelectFormList$makeSelectEntityForm(selectSingleEntityFormConfig));
		});
};
var $author$project$Entity$Role$defaultDataViewPermissions = {gT: false};
var $author$project$Entity$Role$defaultViewPermissions = {go: $author$project$Entity$Role$defaultDataViewPermissions};
var $author$project$Entity$View$isContainerView = function (view) {
	var _v0 = view.jF;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Entity$View$isDataView = function (view) {
	var _v0 = view.jF;
	if (_v0.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Forms$RoleForms$makeViewPermissionsForm = function (view) {
	var dataViewPermissionsForm = ($author$project$Entity$View$isDataView(view) || $author$project$Entity$View$isContainerView(view)) ? A2(
		$author$project$Lib$Form$Form$append,
		$author$project$Lib$Form$Form$simpleCheckboxField(
			{
				h0: 'Taulujen muokkausoikeus',
				dK: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{aO: value});
					}),
				kg: function ($) {
					return $.aO;
				}
			}),
		$author$project$Lib$Form$Form$succeed($author$project$Entity$Role$DataViewPermissions)) : $author$project$Lib$Form$Form$succeed($author$project$Entity$Role$defaultDataViewPermissions);
	return A2(
		$author$project$Lib$Form$Form$append,
		dataViewPermissionsForm,
		$author$project$Lib$Form$Form$succeed($author$project$Entity$Role$ViewPermissions));
};
var $author$project$Utils$ListUtils$mapValues = function (tagger) {
	return $elm$core$List$map(
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return _Utils_Tuple2(
				k,
				tagger(v));
		});
};
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Utils$ListUtils$sortByValues = function (comparator) {
	return $elm$core$List$sortWith(
		F2(
			function (a, b) {
				return A2(comparator, a.b, b.b);
			}));
};
var $author$project$Entity$View$viewTypeComparator = F2(
	function (a, b) {
		var getposber = function (view) {
			var _v0 = view.jF;
			switch (_v0.$) {
				case 0:
					return 1;
				case 1:
					return 2;
				case 2:
					return 3;
				case 3:
					return 4;
				case 4:
					return 5;
				case 5:
					var type_ = _v0.a.j5;
					switch (type_) {
						case 0:
							return 6;
						case 1:
							return 7;
						case 2:
							return 8;
						case 3:
							return 9;
						case 4:
							return 10;
						case 5:
							return 11;
						case 6:
							return 12;
						case 7:
							return 13;
						default:
							return 14;
					}
				default:
					return 15;
			}
		};
		return A2(
			$elm$core$Basics$compare,
			getposber(a),
			getposber(b));
	});
var $author$project$Forms$RoleForms$makeSelectViewAssociationForm = function (_v0) {
	var allViews = _v0.aJ;
	var usedViews = _v0.e5;
	return $author$project$Lib$Form$Form$meta(
		function (values) {
			var viewPermissionsForm = $author$project$Lib$Form$Form$meta(
				function (_v2) {
					var viewId = _v2.ki;
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Lib$Form$Form$succeed($author$project$Entity$Role$defaultViewPermissions),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Forms$RoleForms$makeViewPermissionsForm,
								$author$project$Lib$Form$Form$mapValues(
									{
										dK: F2(
											function (value, values_) {
												return _Utils_update(
													values_,
													{cq: value});
											}),
										kg: function ($) {
											return $.cq;
										}
									})),
							A2($elm$core$Dict$get, viewId, allViews)));
				});
			var viewIsNotInUse = function (id) {
				return !A2($elm$core$List$member, id, usedViews);
			};
			var showDirectlyField = $author$project$Lib$Form$Form$simpleCheckboxField(
				{
					h0: 'Näytä päävalikossa',
					dK: F2(
						function (value, values_) {
							return _Utils_update(
								values_,
								{jD: value});
						}),
					kg: function ($) {
						return $.jD;
					}
				});
			var filteredViews = A2(
				$elm$core$Dict$filter,
				F2(
					function (id, _v1) {
						return _Utils_eq(id, values.ki) || viewIsNotInUse(id);
					}),
				allViews);
			var viewOptions = A2(
				$author$project$Utils$ListUtils$mapValues,
				$author$project$Entity$View$getLongViewDescription,
				A2(
					$author$project$Utils$ListUtils$sortByValues,
					$author$project$Entity$View$viewTypeComparator,
					$elm$core$Dict$toList(filteredViews)));
			var selectViewField = $author$project$Forms$CommonForms$selectIdField(
				{
					h0: 'Valitse näkymä',
					ae: viewOptions,
					dK: F2(
						function (value, values_) {
							return _Utils_update(
								values_,
								{ki: value});
						}),
					kg: function ($) {
						return $.ki;
					}
				});
			return A2(
				$author$project$Lib$Form$Form$append,
				viewPermissionsForm,
				A2(
					$author$project$Lib$Form$Form$append,
					showDirectlyField,
					A2(
						$author$project$Lib$Form$Form$append,
						selectViewField,
						$author$project$Lib$Form$Form$succeed($author$project$Entity$Role$ViewAssociation))));
		});
};
var $author$project$Forms$RoleForms$makeRoleForm = function (config) {
	var viewsField = $author$project$Lib$Form$Form$meta(
		function (topLevelValues) {
			var usedViews = A2(
				$elm$core$List$map,
				function ($) {
					return $.ki;
				},
				topLevelValues.bg);
			return A2(
				$author$project$Lib$Form$Form$simpleList,
				{
					gs: $author$project$Forms$RoleForms$createDefaultViewAssociationFormValues,
					h0: 'Näkymät',
					dK: F2(
						function (value, values) {
							return _Utils_update(
								values,
								{bg: value});
						}),
					kg: function ($) {
						return $.bg;
					}
				},
				function (_v0) {
					return $author$project$Forms$RoleForms$makeSelectViewAssociationForm(
						A2($author$project$Forms$RoleForms$ViewAssociationFormConfig, config.aJ, usedViews));
				});
		});
	var viewComponentCommandOptions = A2(
		$author$project$Utils$ListUtils$mapValues,
		$author$project$Entity$Command$getCommandLongDescription,
		A2(
			$author$project$Utils$ListUtils$sortByValues,
			$author$project$Entity$Command$commandTypeComparator,
			$elm$core$Dict$toList(
				A2($author$project$Utils$DictUtils$filterByValue, $author$project$Entity$Command$isViewComponentsCommand, config.cY))));
	var settingsViewComponentCommandField = A2(
		$author$project$Lib$Form$Form$mapValues,
		{
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{cI: value});
				}),
			kg: function ($) {
				return $.cI;
			}
		},
		$author$project$Forms$EntitySelectFormList$makeEntitySelectFormList(
			{aI: viewComponentCommandOptions, d9: 'Valitse komento', aS: $elm$core$Maybe$Nothing, et: 'Asetusnäkymän komponenttikomennot'}));
	var permissionsField = A2(
		$author$project$Lib$Form$Form$allowEmpty,
		_List_Nil,
		$author$project$Lib$Form$Form$textField(
			{
				aK: {bx: $elm$core$Maybe$Nothing, h0: 'Käyttöoikeustagit', iP: ''},
				u: A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split(','),
					$elm$core$Result$Ok),
				dK: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{cp: value});
					}),
				kg: function ($) {
					return $.cp;
				}
			}));
	var isUserRoleField = $author$project$Lib$Form$Form$simpleCheckboxField(
		{
			h0: 'Käyttäjän rooli',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hY: value});
				}),
			kg: function ($) {
				return $.hY;
			}
		});
	var includedRolesField = $author$project$Lib$Form$Form$meta(
		function (values) {
			return A2(
				$author$project$Lib$Form$Form$mapValues,
				{
					dK: F2(
						function (value, values_) {
							return _Utils_update(
								values_,
								{b_: value});
						}),
					kg: function ($) {
						return $.b_;
					}
				},
				$author$project$Forms$EntitySelectFormList$makeEntitySelectFormList(
					{
						aI: $elm$core$Dict$toList(
							A2(
								$author$project$Utils$DictUtils$mapValues,
								function ($) {
									return $.is;
								},
								config.dT)),
						d9: 'Valitse rooli',
						aS: $elm$core$Maybe$Just(
							$elm$core$Basics$neq(values.bZ)),
						et: 'Aliroolit'
					}));
		});
	var defaultViewField = $author$project$Forms$CommonForms$selectIdOptionallyField(
		{
			h0: 'Oletusnäkymä',
			it: 'Ei mitään',
			ae: A2(
				$author$project$Utils$ListUtils$mapValues,
				$author$project$Entity$View$getLongViewDescription,
				A2(
					$author$project$Utils$ListUtils$sortByValues,
					$author$project$Entity$View$viewTypeComparator,
					$elm$core$Dict$toList(config.aJ))),
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gx: value});
				}),
			kg: function ($) {
				return $.gx;
			}
		});
	var commandsField = A2(
		$author$project$Lib$Form$Form$mapValues,
		{
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bE: value});
				}),
			kg: function ($) {
				return $.bE;
			}
		},
		$author$project$Forms$EntitySelectFormList$makeEntitySelectFormList(
			{
				aI: A2(
					$author$project$Utils$ListUtils$mapValues,
					$author$project$Entity$Command$getCommandLongDescription,
					A2(
						$author$project$Utils$ListUtils$sortByValues,
						$author$project$Entity$Command$commandTypeComparator,
						$elm$core$Dict$toList(config.cY))),
				d9: 'Valitse komento',
				aS: $elm$core$Maybe$Nothing,
				et: 'Komennot'
			}));
	var appBarViewComponentCommandField = A2(
		$author$project$Lib$Form$Form$mapValues,
		{
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bv: value});
				}),
			kg: function ($) {
				return $.bv;
			}
		},
		$author$project$Forms$EntitySelectFormList$makeEntitySelectFormList(
			{aI: viewComponentCommandOptions, d9: 'Valitse komento', aS: $elm$core$Maybe$Nothing, et: 'Sovelluspalkin komponenttikomennot'}));
	return A2(
		$author$project$Lib$Form$Form$append,
		appBarViewComponentCommandField,
		A2(
			$author$project$Lib$Form$Form$append,
			settingsViewComponentCommandField,
			A2(
				$author$project$Lib$Form$Form$append,
				permissionsField,
				A2(
					$author$project$Lib$Form$Form$append,
					includedRolesField,
					A2(
						$author$project$Lib$Form$Form$append,
						commandsField,
						A2(
							$author$project$Lib$Form$Form$append,
							viewsField,
							A2(
								$author$project$Lib$Form$Form$append,
								defaultViewField,
								A2(
									$author$project$Lib$Form$Form$append,
									isUserRoleField,
									A2(
										$author$project$Lib$Form$Form$append,
										$author$project$Forms$CommonForms$descriptionField,
										A2(
											$author$project$Lib$Form$Form$append,
											$author$project$Forms$CommonForms$nameField,
											A2(
												$author$project$Lib$Form$Form$append,
												$author$project$Forms$CommonForms$idAnchorField,
												A2(
													$author$project$Lib$Form$Form$append,
													$author$project$Forms$CommonForms$aproProjectIdField,
													A2(
														$author$project$Lib$Form$Form$append,
														$author$project$Forms$CommonForms$constantMetaField(
															function ($) {
																return $.cr;
															}),
														A2(
															$author$project$Lib$Form$Form$append,
															$author$project$Forms$CommonForms$constantMetaField(
																function ($) {
																	return $.hw;
																}),
															A2(
																$author$project$Lib$Form$Form$append,
																$author$project$Forms$CommonForms$idField,
																$author$project$Lib$Form$Form$succeed($author$project$Entity$Role$Role))))))))))))))));
};
var $author$project$Pages$Main$RolesView$renderEditRoleForm = F2(
	function (formModel, config) {
		return A3(
			$author$project$Pages$Main$FormViewHelpers$editEntityView,
			$author$project$Pages$Main$RolesView$EditFormBackButtonClicked,
			'Muokkaa roolia',
			_List_fromArray(
				[
					$author$project$Pages$Main$FormViewHelpers$renderCommonForm(
					{
						ed: A2(
							$author$project$Lib$Form$Form$map,
							$author$project$Pages$Main$RolesView$BeginSaveRole,
							$author$project$Forms$RoleForms$makeRoleForm(config)),
						ee: formModel,
						bZ: 'edit_role',
						r: $author$project$Pages$Main$RolesView$RoleFormChanged
					})
				]));
	});
var $author$project$Pages$Main$RolesView$renderEditView = F2(
	function (model, repository) {
		var _v0 = model.l;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var formModel = _v0.a;
				return A2(
					$author$project$Utils$CommonView$renderWebData,
					$author$project$Pages$Main$RolesView$renderEditRoleForm(formModel),
					A4(
						$author$project$Lib$RemoteData$map3,
						$author$project$Forms$RoleForms$RoleFormConfig,
						$author$project$Lib$RemoteData$succeed($elm$core$Dict$empty),
						repository.eN,
						$author$project$Lib$RemoteData$succeed($elm$core$Dict$empty)));
			default:
				var formModel = _v0.a;
				return $author$project$Pages$Main$RolesView$renderEditGroupView(formModel);
		}
	});
var $author$project$Pages$Main$RolesView$renderListingView = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Main$RolesView$ListingViewMsg,
			A4(
				$author$project$Pages$Main$EntityListing$GenericEntityListingView$view,
				$author$project$Pages$Main$RolesView$listingViewConfig,
				model.K,
				repository,
				$author$project$Utils$Visibility$visibleIf(
					_Utils_eq(model.l, $author$project$Pages$Main$EditEntityOrGroupModel$NotEditing))));
	});
var $author$project$Pages$Main$RolesView$renderModal = function (model) {
	var _v0 = model.a2;
	switch (_v0.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			var config = _v0.a;
			return $author$project$Utils$CommonModals$messageModal(config);
		default:
			var config = _v0.a;
			return $author$project$Utils$CommonModals$confirmationModal(config);
	}
};
var $author$project$Pages$Main$RolesView$view = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tab-view-root-container')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Main$RolesView$renderModal(model),
					A2($author$project$Pages$Main$RolesView$renderListingView, model, repository),
					A2($author$project$Pages$Main$RolesView$renderEditView, model, repository)
				]));
	});
var $author$project$Pages$Main$MainPage$rolesView = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Main$MainPage$RolesMsg,
		A2($author$project$Pages$Main$RolesView$view, model.a7, model.A));
};
var $author$project$Pages$Main$TenantSettingsView$TenantSettingsFormConfig = F2(
	function (allRoles, allEnvironments) {
		return {cZ: allEnvironments, dT: allRoles};
	});
var $author$project$Pages$Main$TenantSettingsView$FormChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Main$TenantSettingsView$SaveTenantSettings = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Main$TenantSettingsView$makeTenantHookForm = function (config) {
	var hookTypeField = $author$project$Lib$Form$Form$selectField(
		{
			aK: {
				h0: 'Triggeri',
				ae: _List_fromArray(
					[
						_Utils_Tuple2('PostPrincipalCreate', 'Käyttäjän luonnin jälkeen')
					]),
				iP: $elm$core$Maybe$Nothing
			},
			u: $elm$core$Result$Ok,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hB: value});
				}),
			kg: function ($) {
				return $.hB;
			}
		});
	var environmentIdField = $author$project$Forms$CommonForms$selectIdField(
		{
			h0: 'Ympäristö',
			ae: A2(
				$author$project$Utils$ListUtils$mapValues,
				$author$project$Entity$Environment$displayNameOrName,
				$elm$core$Dict$toList(config.cZ)),
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{g$: value});
				}),
			kg: function ($) {
				return $.g$;
			}
		});
	var commandIdForm = $author$project$Forms$CommonForms$selectIdField(
		{
			h0: 'Komento',
			ae: _List_Nil,
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{f_: value});
				}),
			kg: function ($) {
				return $.f_;
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		environmentIdField,
		A2(
			$author$project$Lib$Form$Form$append,
			commandIdForm,
			A2(
				$author$project$Lib$Form$Form$append,
				hookTypeField,
				$author$project$Lib$Form$Form$succeed($author$project$Entity$TenantSettings$TenantHook))));
};
var $author$project$Pages$Main$TenantSettingsView$tenantSettingsForm = function (config) {
	var logSuccessfulExecutionsField = $author$project$Lib$Form$Form$simpleCheckboxField(
		{
			h0: 'Tallenna onnistuneiden suoritusten lokit',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{h6: value});
				}),
			kg: function ($) {
				return $.h6;
			}
		});
	var hooksForm = A2(
		$author$project$Lib$Form$Form$simpleList,
		{
			gs: {f_: $author$project$Entity$Common$nonExistentId, g$: $author$project$Entity$Common$nonExistentId, hB: 'PostPrincipalCreate'},
			h0: 'Tapahtumat',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hC: value});
				}),
			kg: function ($) {
				return $.hC;
			}
		},
		function (_v0) {
			return $author$project$Pages$Main$TenantSettingsView$makeTenantHookForm(config);
		});
	var enableMfaForNewUsersField = $author$project$Lib$Form$Form$simpleCheckboxField(
		{
			h0: 'Kaksivaiheinen tunnistus oletuksena päällä',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gY: value});
				}),
			kg: function ($) {
				return $.gY;
			}
		});
	var delimitersStringField = $author$project$Lib$Form$Form$simpleTextField(
		{
			h0: 'Koodien erottelumerkit',
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gB: value});
				}),
			kg: function ($) {
				return $.gB;
			}
		});
	var cronCommandRoleIdField = $author$project$Forms$CommonForms$selectIdOptionallyField(
		{
			h0: 'Ajastettujen komentojen suorittajan rooli',
			it: 'Ei ajastettua suorittajaa',
			ae: $elm$core$Dict$toList(
				A2(
					$author$project$Utils$DictUtils$mapValues,
					function ($) {
						return $.is;
					},
					config.dT)),
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gj: value});
				}),
			kg: function ($) {
				return $.gj;
			}
		});
	var cronCommandEnvironmentIdField = $author$project$Forms$CommonForms$selectIdOptionallyField(
		{
			h0: 'Ajastettujen komentojen suorittajan ympäristö',
			it: 'Ei ajastettua suorittajaa',
			ae: $elm$core$Dict$toList(
				A2(
					$author$project$Utils$DictUtils$mapValues,
					function ($) {
						return $.is;
					},
					config.cZ)),
			dK: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gi: value});
				}),
			kg: function ($) {
				return $.gi;
			}
		});
	return A2(
		$author$project$Lib$Form$Form$append,
		hooksForm,
		A2(
			$author$project$Lib$Form$Form$append,
			logSuccessfulExecutionsField,
			A2(
				$author$project$Lib$Form$Form$append,
				enableMfaForNewUsersField,
				A2(
					$author$project$Lib$Form$Form$append,
					cronCommandEnvironmentIdField,
					A2(
						$author$project$Lib$Form$Form$append,
						cronCommandRoleIdField,
						A2(
							$author$project$Lib$Form$Form$append,
							delimitersStringField,
							$author$project$Lib$Form$Form$succeed($author$project$Entity$TenantSettings$TenantSettings)))))));
};
var $author$project$Pages$Main$TenantSettingsView$viewTenantSettingsForm = F2(
	function (config, formModel) {
		return A3(
			$author$project$Lib$Form$FormView$asHtml,
			{dP: 'Tallenna', bZ: 'tenant_settings', a0: 'Tallennetaan', r: $author$project$Pages$Main$TenantSettingsView$FormChanged, a8: true, e7: 1},
			A2(
				$author$project$Lib$Form$Form$map,
				$author$project$Pages$Main$TenantSettingsView$SaveTenantSettings,
				$author$project$Pages$Main$TenantSettingsView$tenantSettingsForm(config)),
			formModel);
	});
var $author$project$Pages$Main$TenantSettingsView$viewTenantSettingsFormWebData = F2(
	function (model, repository) {
		var formConfig = A3($author$project$Lib$RemoteData$map2, $author$project$Pages$Main$TenantSettingsView$TenantSettingsFormConfig, repository.eN, repository.ea);
		var _v0 = A3($author$project$Lib$RemoteData$map2, $elm$core$Tuple$pair, formConfig, model.ee);
		switch (_v0.$) {
			case 3:
				var _v1 = _v0.a;
				var config = _v1.a;
				var formModel = _v1.b;
				return A2($author$project$Pages$Main$TenantSettingsView$viewTenantSettingsForm, config, formModel);
			case 2:
				var error = _v0.a;
				return $author$project$Utils$CommonView$multilineText(
					$author$project$Utils$HttpUtils$httpErrorToString(error));
			default:
				return $author$project$Utils$CommonView$centeredLargeSpinner;
		}
	});
var $author$project$Pages$Main$TenantSettingsView$view = F2(
	function (model, repository) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tab-view-root-container')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Main$TenantSettingsView$viewTenantSettingsFormWebData, model, repository)
				]));
	});
var $author$project$Pages$Main$MainPage$tenantSettingsView = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Main$MainPage$TenantSettingsMsg,
		A2($author$project$Pages$Main$TenantSettingsView$view, model.ba, model.A));
};
var $author$project$Pages$Main$MainPage$getViewForRoute = F3(
	function (model, branches, route) {
		switch (route) {
			case 4:
				return $author$project$Pages$Main$MainPage$missingPermissionsView;
			case 0:
				return $author$project$Pages$Main$MainPage$rolesView(model);
			case 1:
				return $author$project$Pages$Main$MainPage$environmentsView(model);
			case 2:
				return $author$project$Pages$Main$MainPage$principalsView(model);
			default:
				return $author$project$Pages$Main$MainPage$tenantSettingsView(model);
		}
	});
var $author$project$Pages$Main$MainPage$getViewForRouteIfHasPermission = F4(
	function (model, branches, userPermissions, mainPageRoute) {
		return A2($author$project$Authentication$UserPermissions$hasPermissionToRoute, userPermissions, mainPageRoute) ? A3($author$project$Pages$Main$MainPage$getViewForRoute, model, branches, mainPageRoute) : $author$project$Pages$Main$MainPage$missingPermissionsView;
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Pages$Main$Navbar$navItem = F3(
	function (title, currentRoute, navItemRoute) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nav-link'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									_Utils_eq(currentRoute, navItemRoute))
								])),
							$elm$html$Html$Attributes$href(
							$author$project$Routes$mainPageRouteToUrlStr(navItemRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]))
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mr4 = $elm$html$Html$Attributes$class('mr-4');
var $author$project$Pages$Main$Navbar$aavoBranchSelectElement = function (config) {
	return A2($elm$core$List$member, 0, config.S) ? A2(
		$rundis$elm_bootstrap$Bootstrap$Form$Select$custom,
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Form$Select$onChange(config.ix),
				$rundis$elm_bootstrap$Bootstrap$Form$Select$attrs(
				_List_fromArray(
					[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mr4]))
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var key = _v0.h_;
				var title = _v0.j_;
				return A2(
					$rundis$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$selected(
							_Utils_eq(key, config.js)),
							$elm$html$Html$Attributes$value(key)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]));
			},
			config.al)) : $elm$html$Html$text('');
};
var $author$project$Pages$Main$Navbar$logoutButton = function (msg) {
	return A3(
		$author$project$Utils$CommonView$iconButton,
		'sign-out-alt',
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Button$outlinePrimary,
				$rundis$elm_bootstrap$Bootstrap$Button$onClick(msg)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Kirjaudu ulos')
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb2 = $elm$html$Html$Attributes$class('mb-2');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mlAuto = $elm$html$Html$Attributes$class('ml-auto');
var $author$project$Pages$Main$Navbar$navbarExtraControls = function (config) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-inline'),
				$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mlAuto,
				$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb2
			]),
		_List_fromArray(
			[
				$author$project$Pages$Main$Navbar$aavoBranchSelectElement(config),
				$author$project$Pages$Main$Navbar$logoutButton(config.h7)
			]));
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Pages$Main$Navbar$navbar = function (config) {
	var currentRoute = config.gm;
	var userPermissions = config.S;
	var navItemsFactoriesByRoutes = _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			A2($author$project$Pages$Main$Navbar$navItem, 'Roolit', currentRoute)),
			_Utils_Tuple2(
			1,
			A2($author$project$Pages$Main$Navbar$navItem, 'Ympäristöt', currentRoute)),
			_Utils_Tuple2(
			2,
			A2($author$project$Pages$Main$Navbar$navItem, 'Käyttäjät', currentRoute)),
			_Utils_Tuple2(
			3,
			A2($author$project$Pages$Main$Navbar$navItem, 'Asetukset', currentRoute))
		]);
	var filteredNavItems = A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, acc) {
				var route = _v0.a;
				var factory = _v0.b;
				return A2($author$project$Authentication$UserPermissions$hasPermissionToRoute, userPermissions, route) ? A2(
					$elm$core$List$cons,
					factory(route),
					acc) : acc;
			}),
		_List_Nil,
		navItemsFactoriesByRoutes);
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('nav nav-tabs')
			]),
		_Utils_ap(
			filteredNavItems,
			_List_fromArray(
				[
					$author$project$Pages$Main$Navbar$navbarExtraControls(config)
				])));
};
var $author$project$Pages$Main$MainPage$CloseCurrentModal = {$: 9};
var $author$project$Pages$Main$MainPage$renderModal = function (model) {
	var _v0 = model.a2;
	if (!_v0.$) {
		return $elm$html$Html$text('');
	} else {
		var title = _v0.a.j_;
		var content = _v0.a.gc;
		return $author$project$Utils$CommonModals$messageModal(
			{fU: $author$project$Pages$Main$MainPage$CloseCurrentModal, gc: content, j_: title});
	}
};
var $author$project$Pages$Main$MainPage$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('main-page-root')
			]),
		function () {
			var _v0 = A3($author$project$Lib$RemoteData$map2, $elm$core$Tuple$pair, model.S, model.al);
			switch (_v0.$) {
				case 3:
					var _v1 = _v0.a;
					var userPermissions = _v1.a;
					var allBranches = _v1.b;
					return _List_fromArray(
						[
							$author$project$Pages$Main$Navbar$navbar(
							{al: allBranches, gm: model.aC, h7: $author$project$Pages$Main$MainPage$RequestLogout, ix: $author$project$Pages$Main$MainPage$BranchSelected, js: model.js, S: userPermissions}),
							A4($author$project$Pages$Main$MainPage$getViewForRouteIfHasPermission, model, allBranches, userPermissions, model.aC),
							$author$project$Pages$Main$MainPage$renderModal(model)
						]);
				case 2:
					var err = _v0.a;
					return _List_fromArray(
						[
							$author$project$Utils$CommonView$multilineText(
							$author$project$Utils$HttpUtils$httpErrorToString(err))
						]);
				default:
					return _List_fromArray(
						[$author$project$Utils$CommonView$centeredLargeSpinner]);
			}
		}());
};
var $author$project$Main$renderPage = function (model) {
	var _v0 = model.z;
	switch (_v0.$) {
		case 0:
			var pageModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Main$PageMsg, $author$project$Main$MainPageMsg),
				$author$project$Pages$Main$MainPage$view(pageModel));
		case 1:
			var pageModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Main$PageMsg, $author$project$Main$DocsPageMsg),
				$author$project$Pages$DocsPage$view(pageModel));
		default:
			return $author$project$Pages$LoggedOutPage$view(
				{i7: $author$project$Main$RequestLogin});
	}
};
var $author$project$Main$renderBody = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('root')
			]),
		_List_fromArray(
			[
				$author$project$Main$renderPage(model),
				$author$project$Main$renderModal(model)
			]));
};
var $author$project$Main$view = function (model) {
	return {
		fD: _List_fromArray(
			[
				$author$project$Main$renderBody(model)
			]),
		j_: 'Aavo Admin'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		hP: $author$project$Main$init,
		iB: $author$project$Main$UrlChanged,
		iC: $author$project$Main$LinkClicked,
		jP: $elm$core$Basics$always($elm$core$Platform$Sub$none),
		dK: $author$project$Main$update,
		kh: $author$project$Main$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (selectedBranchKey) {
			return $elm$json$Json$Decode$succeed(
				{js: selectedBranchKey});
		},
		A2($elm$json$Json$Decode$field, 'selectedBranchKey', $elm$json$Json$Decode$string)))(0)}});}(this));